import {
  hardCodeIsCaesarStone,
  hardCodeIsLowes,
  hardCodeIsMcDermott,
  hardCodeIsModerno,
  hardCodeIsPorcelanosa,
  isProd
} from "../../misc/fabricatorHardcode";

export const isDevMode = () => {
  return window.location.href.includes("dev=1") || document.kvConfig.devMode
};

export const SQFT_POST_MESSAGE_ACTIONS = {
  initialLoad: "initialLoad",
  setQTData: "setQTData",
  closeSqFtCalc: "closeSqFtCalc",
  callResetDataPopup: "callResetDataPopup",
  callChangeLayoutDataPopup: "callChangeLayoutDataPopup",
  userIdleResetCounter: "userIdleResetCounter",
  resetHistory: "resetHistory",
  saveHistory: "saveHistory",
  setNewLayoutOnSqft: "setNewLayoutOnSqft",
  setCanvasCenter: "setCanvasCenter",
  stopRender: "stopRender",
  startRender: "startRender",
};

export const MEASURE_UNITS = {
  Metric: "Metric",
  Imperial: "Imperial",
};

/**
 *
 * This is used only to take shape part id
 * @type {{top_cabinet: string, bottom_cabinet: string, center_island_countertop: string, slabPlaceHolder: string, seamPiece: string, countertop: string, spacer: string, vanity_countertop: string, backsplashPiece: string}}
 */
export const SHAPE_PART_ID = {
  edge: 'edge',
  seamPiece: 'seamPiece',
  backsplashPiece: 'backsplashPiece',
  waterfallPiece: 'waterfallPiece',
  slabPlaceHolder: 'slabPlaceHolder',
  top_cabinet: 'top_cabinet',//
  bottom_cabinet: 'bottom_cabinet',//
  tall_cabinet: 'tall_cabinet', //
  lower_cabinet_boxes: 'lower_cabinet_boxes',
  upper_cabinet_boxes: 'upper_cabinet_boxes',
  tall_cabinet_boxes: 'tall_cabinet_boxes',
  vanitie_cabinet_boxes: 'vanitie_cabinet_boxes',
  vanity_cabinet_boxes: 'vanity_cabinet_boxes',
  countertop: 'countertop',
  spacer: 'spacer',
  vanity_countertop: 'vanity_countertop',
  center_island_countertop: 'center_island_countertop',
  front_wall: 'front_wall',

  //appliances
  dishwasher: "dishwasher",
  hood: "hood",
  fridge: "fridge",
  stove: "stove",
};

export const SQFT_FEATURES = {
  bumpouts: 'bumpouts',
  countertop: 'countertop',
  center_island_countertop: 'center_island_countertop',
  slabs: 'slabs',
  backsplashes: 'backsplashes',
  edges: 'edges',
  radius: 'radius',
  corners: 'corners',
  shower_wall: 'shower_wall',
  shower_floor: 'shower_floor',
  kitchen_floor: 'kitchen_floor',
  vanity_accent: 'vanity_accent',
  vanity_countertop: 'vanity_countertop',
  vanity_backsplash: 'vanity_backsplash',
  shower_interior_wall: 'shower_interior_wall',
  shower_interior_wall_accent: 'shower_interior_wall_accent',
  shower_wall_accent: 'shower_wall_accent',
  accent_wall: 'accent_wall',
  bathroom_floor: 'bathroom_floor',
  wall_a: 'wall_a',
  wall_b: 'wall_b',
  wall_c: 'wall_c',
  front_wall: 'front_wall',
  top_cabinet: 'top_cabinet',
  upper_cabinet_boxes: 'upper_cabinet_boxes',
  top_handle: 'top_handle',
  bottom_cabinet: 'bottom_cabinet',
  lower_cabinet_boxes: 'lower_cabinet_boxes',
  bottom_handle: 'bottom_handle',
  tall_cabinet: 'tall_cabinet',
  tall_cabinet_boxes: 'tall_cabinet_boxes',
  vanity_cabinet: 'vanity_cabinet',
  vanitie_cabinet_boxes: 'vanitie_cabinet_boxes',
  vanity_cabinet_boxes: 'vanity_cabinet_boxes',
  crown_molding: 'crown_molding',
  handle: 'handle',
  underlayment: 'underlayment',
  wall_door_end_accessory: 'wall_door_end_accessory',
  base_door: 'base_door',
  island_panel: 'island_panel',
  refridgerator_panel: 'refridgerator_panel',
  end_cap: 'end_cap',
  hinge: 'hinge',
};

export const APPLIANCE_PART_IDS = [
  SHAPE_PART_ID.dishwasher,
  SHAPE_PART_ID.hood,
  SHAPE_PART_ID.fridge,
  SHAPE_PART_ID.stove,
]

export const FEATUREGROUP_PART_ID = {
  specialty_cut_and_designs: 'specialty_cut_and_designs'
}

export const SHAPE_ROTATE_DIRECTION = {
  right: 0,
  left: 1,
};

export const ALIGN = {
  right: 'right',
  left: 'left',
  center: 'center',
};

export const SHAPE_TYPE = {
  polygon: "polygon",
  square: "square",
  wideangle: "wideangle",
  horseshoe: "horseshoe",
  appliances: "appliances",
};

export const RENDER_TEMPLATES = {
  default: "default",
  disabled: "disabled",
  linesOnly: "linesOnly",
  filledPrimary: "filledPrimary",
  accordingToFeature: "accordingToFeature",
  filledActive: "filledActive",
};

/**
 * NAVIGATION
 */
export const SIDEBAR2_BUTTONS = [
  {
    menu: "summary",
    classNames: "button--parent button--summary",
    text: "mobile.summary",
    hasMenu: true
  },
  // {
  //   menu: "settings",
  //   classNames: "button--parent button--settings",
  //   text: "settings",
  //   hasMenu: true
  // }
];

export const SIDEBAR_BUTTONS_MENU = {
  move: "move",
  shapes: "shapes",
  layouts: "layouts",
  summary: "summary",
  delete: "delete",
  cabinetset: "cabinetset"
}

export const SIDEBAR_SLAB_BUTTONS = {
  move: "move",
  //moveSlab: "moveSlab",
  rotate: "rotate",
  loadSlab: "loadSlab",
  seam: "seam",
  duplicate: "duplicate",
  delete: "delete",
};

export const MOVABLE_IMAGE_TYPES = {
  slabImage: "slabImage",
};

export const SIDEBAR_SLAB_SEAM_BUTTONS = {
  addFreeSeam: "addFreeSeam", //todo enable when ready
  addSeamHorizontal: "addSeamHorizontal",
  addSeamVertical: "addSeamVertical",
  undoSeam: "undoSeam",
  resetSeams: "resetSeams",
};

/**
 * remember to update SIDEBAR_HIDDEN_BUTTONS (names should be the same)
 */
export const SIDEBAR_NAVIGATION_BUTTONS = {
  move: "move",
  //freeDraw: "freeDraw",
  resize: "resize",
  rotate: "rotate",
  corners: "corners",
  radius: "radius",
  edge: "edge",
  backsplash: "backsplash",
  end_cap: "end_cap",
  appliances: "appliances",
  angle: "angle",
  bumpout: "bumpout",
  label: "label",
  text: "text",
  ...((!hardCodeIsLowes()) && { mitered: "mitered" }),
  ...((!hardCodeIsMcDermott() && !hardCodeIsLowes()) && { toolWaterfall: "toolWaterfall" }),
  ...((!isProd && (hardCodeIsModerno() || hardCodeIsPorcelanosa() || isDevMode())) && { toolUnderlayment: "toolUnderlayment" }),
  duplicate: "duplicate",
};

export const SIDEBAR_TYPE_AREA_NAVIGATION_BUTTONS = {
  move: "move",
  freeDraw: "freeDraw",
  resize: "resize",
  rotate: "rotate",
  corners: "corners",
  edge: "edge",
  bumpout: "bumpout",
  mitered: "mitered",
  ...((hardCodeIsModerno() || hardCodeIsPorcelanosa() || isDevMode()) && {toolWaterfall: "toolWaterfall"}),
  appliances: "appliances",
  label: "label",
  text: "text",
  duplicate: "duplicate",
};

export const SIDEBAR_NAVIGATION_CABINET_BUTTONS = {
  move: "move",
  resize: "resize",
  rotate: "rotate",
  lower: "lower",
  upper: "upper",
  tall: "tall",
  centerIsland: "centerIsland",
  spacer: "spacer",
  //style: "style",
  wall: "wall",
  crown_molding: "crown_molding",
  handles: "handles",
  hinge: "hinge",
  // top_handle: "top_handle",
  // bottom_handle: "bottom_handle",
  end_panel: "end_panel",
  appliances: "appliances", // disable appliances for caes
  text: "text",
};

export const SIDEBAR_NAVIGATION_BATHROOM_CABINET_BUTTONS = {
  move: "move",
  resize: "resize",
  rotate: "rotate",
  vanity: "vanity",
  spacer: "spacer",
  wall: "wall",
  appliances: "appliances",
  text: "text",
};

export const SIDEBAR_NAVIGATION_3D_CABINET_BUTTONS = {
  //move: "move",
  top_cabinet: "top_cabinet",
  bottom_cabinet: "bottom_cabinet",
  tall_cabinet: "tall_cabinet",
  //crown_molding: "crown_molding",
  handles: "handles",
  centerIsland: "centerIsland",
  //vanity: "vanity",
  //spacer: "spacer",
  //wall: "wall",
  //appliances: "appliances",
  //text: "text",
};

export const SIDEBAR_SHAPE_BUTTONS = {
  square: "square",
  lshape: "lshape",
  wideangle: "wideangle",
  rectangle: "rectangle",
  dot: "dot",
  freeDraw: "freeDraw",
  shapeFreeForm: "shapeFreeForm",
};

export const SIDEBAR_NAVIGATION_BUTTONS_LEVEL3 = {
  filters: "filters",
};

export const FREE_FORM_THICKNESS_POPUP_ID = "freeForm";

export const SIDEBAR_BUTTONS = [
  {
    menu: "move",
    message: "sqft.navigation.menu.tools",
    shouldHardcodeMessage: true,
    hasMenu: true,
    subMenu: SIDEBAR_NAVIGATION_BUTTONS
  }, {
    menu: "shapes",
    message: "sqft.navigation.menu.shapes",
    hasMenu: true,
    subMenu: SIDEBAR_SHAPE_BUTTONS
  }, {
    menu: "layouts",
    message: "sqft.navigation.menu.layouts",
    hasMenu: true
  }, {  // disable summary for caes
    menu: "summary",
    message: "sqft.navigation.menu.summary",
    hasMenu: true
  }, {
    menu: "delete",
    message: "sqft.navigation.menu.delete",
    title: "Remove an object from the workspace", //todo translation
    additionalClassNames: "dot-delete"
  },
  // {
  //   menu: "settings",
  //   message: "sqft.navigation.menu.settings"
  // },
];

export const SIDEBAR_TYPE_AREA_BUTTONS = [
  {
    menu: "move",
    message: "sqft.navigation.menu.move",
    hasMenu: true,
    subMenu: SIDEBAR_NAVIGATION_BUTTONS
  }, {
    menu: "shapes",
    message: "sqft.navigation.menu.shapes",
    hasMenu: true,
    subMenu: SIDEBAR_SHAPE_BUTTONS
  }, {  // disable summary for caes
    menu: "summary",
    message: "sqft.navigation.menu.summary",
    hasMenu: true
  }, {
    menu: "delete",
    message: "sqft.navigation.menu.delete",
    title: "Remove an object from the workspace", //todo translation
    additionalClassNames: "dot-delete"
  },
];

export const SIDEBAR_CABINET_BUTTONS = [
  {
    menu: "move",
    message: "sqft.navigation.menu.move",
    hasMenu: true,
    subMenu: SIDEBAR_NAVIGATION_CABINET_BUTTONS
  }, {  // disable summary for caes
    menu: "summary",
    message: "sqft.navigation.menu.summary",
    hasMenu: true
  }, {
    menu: "delete",
    message: "sqft.navigation.menu.delete",
    title: "Remove an object from the workspace", //todo translation
    additionalClassNames: "dot-delete"
  },...(isDevMode() ? [{
    menu: "cabinetset",
    message: "Cabinet Set",
  }] : []),
  // {
  //   menu: "settings",
  //   message: "sqft.navigation.menu.settings"
  // },
];

export const SIDEBAR_3D_BUTTONS = [
  {
    menu: "move",
    message: "sqft.navigation.menu.move",
    hasMenu: true,
    subMenu: SIDEBAR_NAVIGATION_CABINET_BUTTONS
  }, ...(isDevMode() ? [{
    menu: "cabinetset",
    message: "Cabinet Set",
  }] : []),
];

export const SIDEBAR_WITH_FEATURES_SUBMENU = [
  SIDEBAR_NAVIGATION_BUTTONS.end_cap,
  SIDEBAR_NAVIGATION_CABINET_BUTTONS.end_panel,
  SIDEBAR_NAVIGATION_CABINET_BUTTONS.centerIsland,
  SIDEBAR_NAVIGATION_CABINET_BUTTONS.wall,
  SIDEBAR_NAVIGATION_CABINET_BUTTONS.handles,
  SIDEBAR_NAVIGATION_CABINET_BUTTONS.hinge,
  SIDEBAR_NAVIGATION_CABINET_BUTTONS.crown_molding,
  SQFT_FEATURES.top_cabinet,
  SQFT_FEATURES.bottom_cabinet,
  SQFT_FEATURES.tall_cabinet,
];

export const RIGHT_SIDEBAR_WITH_FEATURES_SUBMENU = [
  SIDEBAR_NAVIGATION_BUTTONS.end_cap,
  SIDEBAR_NAVIGATION_CABINET_BUTTONS.end_panel,
  SIDEBAR_NAVIGATION_CABINET_BUTTONS.centerIsland,
  SIDEBAR_NAVIGATION_CABINET_BUTTONS.wall,
  SIDEBAR_NAVIGATION_CABINET_BUTTONS.handles,
  SIDEBAR_NAVIGATION_CABINET_BUTTONS.hinge,
  SIDEBAR_NAVIGATION_CABINET_BUTTONS.crown_molding,
];

export const SHOULD_DISPLAY_FEATURES_ONLY_WITH_AR3DUrls = [
  SIDEBAR_NAVIGATION_CABINET_BUTTONS.wall,
  SIDEBAR_NAVIGATION_CABINET_BUTTONS.handles,
  SIDEBAR_NAVIGATION_CABINET_BUTTONS.crown_molding,
  SQFT_FEATURES.top_cabinet,
  SQFT_FEATURES.bottom_cabinet,
  SQFT_FEATURES.tall_cabinet,
  SQFT_FEATURES.upper_cabinet_boxes,
  SQFT_FEATURES.lower_cabinet_boxes,
  SQFT_FEATURES.tall_cabinet_boxes,
];

export const SIDEBAR_HIDDEN_BUTTONS = {
  mitered: "mitered",
  toolWaterfall: "toolWaterfall",
  toolUnderlayment: "toolUnderlayment",
  buttonMitered: "buttonMitered",
  buttonCustomBacksplash: "buttonCustomBacksplash",
  edgePeninsulaUnderwrap: "edgePeninsulaUnderwrap",
};

/*
* Hide shapes after removing them in popup window
*/
export const isDisabledInPopupShouldBeHidden = () => {
  return hardCodeIsCaesarStone() //enabled only for caesarstone
}

export const SIDEBAR_LAYOUTS_BUTTONS = [
  "S", "SP", "SI", "SPI", "SN", "SPN", "SNI", "SPNI", "L", "LI", "LN", "LNI"
];

export const SQFT_APPLIANCES = {
  hood: "hood",
  refrigerator: "refrigerator",
  range: "range",
  sink: "sink",
  doubleSink: "doubleSink",
  dishwasher: "dishwasher",
  iceMachine: "ice machine",
  oven: "oven",
  stovetop: "stovetop",
  trashCompactor: "trash compactor",
  wineFridge: "wine fridge"
};

export const SQFT_APPLIANCES_BATHROOM = {
  tub: "tub",
  toilet: "toilet",
  vanity: "vanity",
  wet_space: "wet space"
};

export const SQFT_APPLIANCES_CAES = {
  hood: "hood",
  sink: "sink",
  stovetop: "stovetop",
};

export const CABINET_LABELS = {
  top_cabinet: 'top_cabinet',
  bottom_cabinet: 'bottom_cabinet',
  tall_cabinet: 'tall_cabinet',
  crown_molding: 'crown_molding',
  tall_cabinet_boxes: 'tall_cabinet_boxes',
  lower_cabinet_boxes: 'lower_cabinet_boxes',
  upper_cabinet_boxes: 'upper_cabinet_boxes',
  handle: 'handle',
};

export const CABINET_BATHROOM_LABELS = {
  vanity_cabinet: 'vanity_cabinet',
  vanitie_cabinet_boxes: 'vanitie_cabinet_boxes',
  vanity_cabinet_boxes: 'vanity_cabinet_boxes',
};

export const CABINET_BOXES = [
  SHAPE_PART_ID.lower_cabinet_boxes,
  SHAPE_PART_ID.upper_cabinet_boxes,
  SHAPE_PART_ID.tall_cabinet_boxes,
];

export const SQFT_CABINET_APPLIANCES = {
  //hood: "hood",
  //microwave: "microwave",
};

export const SQFT_APPLIANCES_WITH_SUBMENU = [
  SQFT_APPLIANCES.oven,
  SQFT_APPLIANCES.hood,
  SQFT_APPLIANCES.dishwasher,
  SQFT_APPLIANCES.stovetop,
  SQFT_APPLIANCES.refrigerator,
  SQFT_APPLIANCES.range,
  SQFT_CABINET_APPLIANCES.microwave,
  //partIds which names are mismatched
  SHAPE_PART_ID.stove,
  SHAPE_PART_ID.fridge,
]

export const SQFT_SHAPES_THAT_ADD_OVERHANG = [
  SQFT_APPLIANCES.oven,
  SQFT_APPLIANCES.range,
  SQFT_APPLIANCES.hood,
  SQFT_APPLIANCES.dishwasher,
  SQFT_APPLIANCES.stovetop,
  SQFT_APPLIANCES.refrigerator,
  CABINET_LABELS.tall_cabinet_boxes,
  //CABINET_LABELS.lower_cabinet_boxes,
  //partIds which names are mismatched
  SHAPE_PART_ID.stove,
  SHAPE_PART_ID.fridge,
]

export const SQFT_MODE = {
  regular: "regular",
  slab: "slab",
};

export const SQFT_VIEW_MODE = {
  twoDMode: "2d Mode",
  threeDMode: "3d Mode",
  threeDModeDoors: "3d Mode Doors",
  threeDModeFramed: "Framed",
  threeDModeFrameless: "Frameless",
  augmentedReality: "Augmented Reality",
  augmentedRealityCabinet: "Augmented Reality Cabinet",
  augmentedRealityDoorsOnly: "Augmented Reality Doors Only"
}

export const SQFT_VIEW_3D_MODES = [
  SQFT_VIEW_MODE.threeDMode,
  SQFT_VIEW_MODE.threeDModeDoors,
  SQFT_VIEW_MODE.threeDModeFramed,
  SQFT_VIEW_MODE.threeDModeFrameless,
];

export const SQFT_VIEW_AR_MODES = [
  SQFT_VIEW_MODE.augmentedReality,
  SQFT_VIEW_MODE.augmentedRealityCabinet,
  SQFT_VIEW_MODE.augmentedRealityDoorsOnly,
]

export const MANUAL_CALCULATION_ROW_TYPES = {
  countertopRows: "countertopRows",
  backsplashRows: "backsplashRows",
  edgeRows: "edgeRows",
};

export const DIRECTION = {
  north: "north",
  east: "east",
  south: "south",
  west: "west",
};

export const MANUAL_CALCULATION_MEASURE = {
  length: "length",
  height: "height",
  width: "width",
  selectedFeature: "selectedFeature",
};

export const SQFT_BACKSPLASH_TYPES = ["4", "6", "18"];
export const SQFT_BACKSPLASH_TYPES_METRIC = ["100", "150", "600"];
export const SQFT_WALL_TYPES = ["wall"];
export const SQFT_MEASURE_UNIT = {
  imperial: "Imperial",
  metric: "Metric",
};
export const FREE_DRAW_TYPE = {
  shape: "shape",
  shapeFreeForm: "shapeFreeForm",
  wall: "wall",
};

export const CONTEXT_MENU_TYPE = {
  list: "list",
  buttons: "buttons",
};

export const DEFAULT_EXPORTED_SQFT_FEATURES = [
  SQFT_FEATURES.crown_molding,
  SQFT_FEATURES.radius,
  SQFT_FEATURES.corners,
  SQFT_FEATURES.underlayment,
  SQFT_FEATURES.bumpouts,
]

export const PARENT_KEYS_WITH_COMBINED_FEATURES_IN_CART = [
  'edges',
  'edge',
  'backsplash',
  'backsplashes',
  'countertop',
  'center_island_countertop',
  'radius',
  'corners',
  'slabs',
  'vanity_countertop',
  'vanity_backsplash',
  'shower_wall',
  'shower_interior_wall',
  'shower_interior_wall_accent',
  'accent_wall',
  'shower_floor',
  'bathroom_floor',
  'kitchen_floor',
  'wall_a',
  'wall_b',
  'wall_c',
  'front_wall',
];

export const END_CAP_CABINETS_PART_IDS = [
  SQFT_FEATURES.wall_door_end_accessory,
  SQFT_FEATURES.base_door,
  SQFT_FEATURES.island_panel,
  SQFT_FEATURES.refridgerator_panel,
];

export const END_CAP_AREA_PART_IDS = [
  SQFT_FEATURES.end_cap,
];

export const END_CAP_PART_IDS = [
  ...END_CAP_CABINETS_PART_IDS,
  ...END_CAP_AREA_PART_IDS,
];

export const SQFT_PARENT_FEATURE_GROUP_PART_IDS = {
  upper_cabinet_boxes: 'top_cabinet',
  tall_cabinet_boxes: 'tall_cabinet',
  lower_cabinet_boxes: 'bottom_cabinet',
}

export const SQFT_CHILD_FEATURE_GROUP_PART_IDS = {
  top_cabinet: 'upper_cabinet_boxes',
  tall_cabinet: 'tall_cabinet_boxes',
  bottom_cabinet: 'lower_cabinet_boxes',
}

export const SQFT_AREA_TYPE_PART_IDS = {
  shower_wall: 'shower_wall',
  shower_floor: 'shower_floor',
  kitchen_floor: 'kitchen_floor',
  shower_interior_wall: 'shower_interior_wall',
  shower_interior_wall_accent: 'shower_interior_wall_accent',
  shower_wall_accent: 'shower_wall_accent',
  accent_wall: 'accent_wall',
  bathroom_floor: 'bathroom_floor',
  wall_a: 'wall_a',
  wall_b: 'wall_b',
  wall_c: 'wall_c',
};

export const COUNTERTOP_LABELS = {
  center_island_countertop: 'center_island_countertop',
  countertop: 'countertop',
  vanity_countertop: 'vanity_countertop',
  vanity_accent: 'vanity_accent',
  shower_wall: 'shower_wall',
  shower_wall_accent: 'shower_wall_accent',
  shower_interior_wall: 'shower_interior_wall',
  shower_interior_wall_accent: 'shower_interior_wall_accent',
  accent_wall: 'accent_wall',
  shower_floor: 'shower_floor',
  bathroom_floor: 'bathroom_floor',
  kitchen_floor: 'kitchen_floor',
  wall_a: 'wall_a',
  wall_b: 'wall_b',
  wall_c: 'wall_c',
  front_wall: 'front_wall',
};

export const CABINET_PART_IDS_THAT_CAN_HAVE_HANDLES = [
  SHAPE_PART_ID.tall_cabinet_boxes,
  SHAPE_PART_ID.upper_cabinet_boxes,
  SHAPE_PART_ID.lower_cabinet_boxes,
]

export const HANDLE_TO_CABINETS = {
  [SQFT_FEATURES.top_handle]: [SQFT_FEATURES.upper_cabinet_boxes],
  [SQFT_FEATURES.bottom_handle]: [SQFT_FEATURES.lower_cabinet_boxes, SQFT_FEATURES.tall_cabinet_boxes],
  [SQFT_FEATURES.handle]: [SQFT_FEATURES.upper_cabinet_boxes, SQFT_FEATURES.lower_cabinet_boxes],
};

export const CABINETS_TO_HANDLE = {
  [SQFT_FEATURES.upper_cabinet_boxes]: SQFT_FEATURES.top_handle,
  [SQFT_FEATURES.lower_cabinet_boxes]: SQFT_FEATURES.bottom_handle,
  [SQFT_FEATURES.tall_cabinet_boxes]: SQFT_FEATURES.bottom_handle,
};

export const CABINET_PART_IDS_WITH_HALF_PRICE = [
  SHAPE_PART_ID.top_cabinet,
  SHAPE_PART_ID.bottom_cabinet,
  SHAPE_PART_ID.tall_cabinet,
]

export const CABINET_COMMON_COLOR_PART_IDS = [
  SHAPE_PART_ID.top_cabinet,
  SHAPE_PART_ID.bottom_cabinet,
  SHAPE_PART_ID.tall_cabinet,
  SHAPE_PART_ID.tall_cabinet_boxes,
  SHAPE_PART_ID.upper_cabinet_boxes,
  SHAPE_PART_ID.lower_cabinet_boxes,
];

export const FEATURE_QUANTITY_UNITS = [
  SHAPE_PART_ID.upper_cabinet_boxes,
  SHAPE_PART_ID.lower_cabinet_boxes,
  SHAPE_PART_ID.tall_cabinet_boxes,
  SHAPE_PART_ID.vanitie_cabinet_boxes,
  SHAPE_PART_ID.vanity_cabinet_boxes,
];

export const BACKSPLASH_LABELS = {
  backsplash: 'backsplash',
  backsplashes: 'backsplashes',
  vanity_backsplash: 'vanity_backsplash',
};

export const EDGE_LABELS = {
  edge: 'edge',
  edge_profile: 'edge_profile',
  center_island_edge: 'center_island_edge',
};

export const CORNER_LABELS = {
  radius: 'radius',
  corner: 'corner',
};

// export const FEATURES_WITH_0_VALUE_FOR_THE_SLABS = [
//   SQFT_FEATURES.backsplashes,
//   SQFT_FEATURES.countertop,
//   SQFT_FEATURES.center_island_countertop,
//   SQFT_FEATURES.shower_wall,
//   SQFT_FEATURES.shower_floor,
//   SQFT_FEATURES.kitchen_floor,
//   SQFT_FEATURES.vanity_countertop,
//   SQFT_FEATURES.vanity_backsplash,
//   SQFT_FEATURES.shower_interior_wall,
//   SQFT_FEATURES.shower_interior_wall_accent,
//   SQFT_FEATURES.bathroom_floor,
//   SQFT_FEATURES.wall_a,
//   SQFT_FEATURES.wall_b,
//   SQFT_FEATURES.wall_c
// ];

export const SHAPE_PART_IDS_USING_SAME_COLOR = {
  ...COUNTERTOP_LABELS,
  ...BACKSPLASH_LABELS,
  waterfallPiece: SHAPE_PART_ID.waterfallPiece,
  backsplashPiece: SHAPE_PART_ID.backsplashPiece,
  seamPiece: SHAPE_PART_ID.seamPiece,
}

export const FEATURES_WITH_0_VALUE_FOR_THE_SLABS = {
  ...COUNTERTOP_LABELS,
  ...BACKSPLASH_LABELS,
}

export const ALLOWED_LABEL_NAV_ITEMS = {
  ...COUNTERTOP_LABELS,
  ...BACKSPLASH_LABELS,
  ...CABINET_LABELS,
  ...CABINET_BATHROOM_LABELS,
  ...SQFT_AREA_TYPE_PART_IDS,
  ...END_CAP_PART_IDS
}

export const POINT_PROPERTY = {
  angle: 'angle',         // 45 degCorner
  arcLength: 'arcLength', // Radius
}

export const RESOURCE_TYPE = {
  attachedToLine: 'attachedToLine',
  waterfallSectionsData: 'waterfallSectionsData',
  underlaymentSections: 'underlaymentSections',
  selectedFeature: null
}

export const RESOURCE_ATTACHED_TO_TYPE = {
  edge: 'edge',
  backsplash: 'backsplash',
  wall: 'wall',
  mitered: 'mitered',
  underlayment: 'underlayment',
  bumpout: 'bumpout',
  waterfall: 'waterfall',
  crown_molding: 'crown_molding',
  end_cap: 'end_cap',
}

export const RESOURCE_ATTACHED_TO_NAME = {
  waterfall: 'Waterfall',
}

export const WORKSPACE_RESOURCES = {
  spacers: 'spacers',
  handles: 'handles',
  hinge: 'hinge',
  crownMolding: 'crownMolding',
  walls: 'walls',
  shapeColors: 'shapeColors',
  waterfall: 'waterfall',
  removedFeatures: 'removedFeatures',
  snappedShapeGroups: 'snappedShapeGroups',
  selectedShapes: 'selectedShapes',
  images3d: 'images3d',
}

/**
 * Should be unique
 * @type {{peninsulaUnderwrap: string, underlayment: string, waterfall: string, cabinetReturn: string, overhangReturn: string}}
 */
export const WATERFALL_SHAPES_KEY = {
  cabinetReturn: 'Cabinet Return',
  waterfall: 'Waterfall Panel',
  overhangReturn: 'Overhang Return',
  underlayment: 'Underlayment',
  peninsulaUnderwrap: 'Ppeninsula Underwrap',
}

export const WATERFALL_SHAPES_NAME = {
  cabinetReturn: 'Cabinet Return',
  waterfall: 'Waterfall Panel',
  overhangReturn: 'Overhang Return',
  underlayment: 'Underlayment',
  peninsulaUnderwrap: 'Underlayment',
}

export const SQFT_GROUP = {
  area: 'area',
  cabinets: 'cabinets',
  default: 'default',
}

export const SQFT_AR3D_POPUP_CONTENT_TYPE = {
  ar: 'ar',
  threeD: 'threeD',
}

export const SQFT_AR3D_GLB_VIEWER = {
  singleModel: 'singleModel',
  separateModels: 'separateModels',
}

export const MITER_UNDERWRAP_EDGE_NAMES = [
  "miter underwrap"
];

export const MITER_EDGE_NAMES = [
  'Miter 1 1/2"',
  'Miter 2"-3"',
  'Miter 4"-6"',
  'Miter Edge',
  'Mitered Edge',
  'Rimrock - 981',
  'Ingletado',
  'Inglete',
  'Inglete.',
]

export const WATERFALL_OVERLAY_TYPE = {
  waterfall: 'waterfall',
  peninsulaUnderwrap: 'peninsulaUnderwrap',
}

export const MITERED_OVERLAY_TYPE = {
  mitered: "mitered",
  underlayment: "underlayment",
}

export const APPLIANCES_THAT_SHOULD_RENDER_MEASUREMENTS_INSIDE_THE_SHAPE = [
  SQFT_APPLIANCES.sink,
  SQFT_APPLIANCES.doubleSink,
  SQFT_APPLIANCES.stovetop
]

export const CABINET_FILTER_NAMES = {
  knobs: 'Number_of_Knobs',
  hinges: 'Number_of_Hinges',
  slideSets: 'Numbe_of_Slide_Sets',
  doors: 'Number_of_Doors',
  drawers: 'Number_of_Drawers',
}

export const FEATURE_PICKER_TYPE = {
  handles: 'HANDLES_CHANGE',
  hinges: 'HINGE_CHANGE',
  shape: 'SHAPE_CHANGE',
}

export const ALLOWED_CABINET_PROFILES = [
  'london 10900',
  'shaker shallow',
  'london 900',
  'london 10500',
  'aspen',
  'shaker slim',
]

export const ALLOWED_CABINET_COLOURS = [
  'snow white',
  'white lacquer',
  'stratus supermatte',
  'morning dew supermatte',
  'white smartmatte',
  'rustic light oak',
  'sage supermatte',
  'nizza',
  'bisque',
  'winter fun',
  'aloe supermatte',
  'midnight supermatte',
  'haze supermatte',
  'silt supermatte',
]

export const CABINET_SET5_KITCHEN_MAGIK = {
  "bumpouts": [],
  "canvasImage": "",
  "sqFtSlabImage": "",
  "sqFtSlabCalcImage": "",
  "sqftApplianceImages": "",
  "images3D": "",
  "slabImages": [],
  "measureUnit": "Imperial",
  "sinks": [],
  "radii": [],
  "corners": [],
  "totalInches": 14112,
  "shapeLength": 14,
  "objIds": 14,
  "removedFeatures": [],
  "textBoxes": [],
  "slabAdditionalShapesList": [],
  "slabImagesTotalArea": [],
  "squareFeet": 98,
  "countertops": [
    {
      "pos": {
        "x": -107.1333333333333,
        "y": -33.86666666666668
      },
      "slabPos": {
        "x": -21,
        "y": -106.66666666666667
      },
      "id": 1,
      "featureId": 370760075,
      "features": [
        {
          "featureId": 370760075,
          "partId": "lower_cabinet_boxes"
        },
        {
          "featureId": 371311823,
          "partId": "bottom_cabinet"
        }
      ],
      "colorSet": null,
      "isHidden": false,
      "shapePieces": [],
      "seamCutPointsAndLines": [],
      "shapeParentId": null,
      "lines": [
        {
          "id": "72b63da4-66c7-45f0-b329-3bff89eb9538",
          "from": {
            "id": "59c85421-bfea-4676-8b14-de8a67824aea",
            "x": 0,
            "y": 0,
            "pos": {
              "x": 0,
              "y": 0
            },
            "posSlab": {
              "x": 0,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "lefttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "0e38b507-572e-43ae-9f6d-9d36c9df126c",
            "x": 42,
            "y": 0,
            "pos": {
              "x": 42,
              "y": 0
            },
            "posSlab": {
              "x": 42,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "righttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "c073ef20-b926-415f-a47f-ca973a8fcd9f",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "ba913124-6c95-4435-bb48-3098a10ac70c",
          "from": {
            "id": "0e38b507-572e-43ae-9f6d-9d36c9df126c",
            "x": 42,
            "y": 0,
            "pos": {
              "x": 42,
              "y": 0
            },
            "posSlab": {
              "x": 42,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "righttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "366cda51-8a77-4bc6-a9d3-4222231c0bcd",
            "x": 42,
            "y": 24,
            "pos": {
              "x": 42,
              "y": 24
            },
            "posSlab": {
              "x": 42,
              "y": 24
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "rightbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "5d6ed938-b222-425a-b545-01ab6ab09041",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "565ce0e6-42af-4613-9f1e-b03284b5f927",
          "from": {
            "id": "366cda51-8a77-4bc6-a9d3-4222231c0bcd",
            "x": 42,
            "y": 24,
            "pos": {
              "x": 42,
              "y": 24
            },
            "posSlab": {
              "x": 42,
              "y": 24
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "rightbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "9a523566-69cb-4054-89c1-b8e29e300154",
            "x": 0,
            "y": 24,
            "pos": {
              "x": 0,
              "y": 24
            },
            "posSlab": {
              "x": 0,
              "y": 24
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "leftbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "e8371e5a-145d-4e51-a51d-6a703e14e963",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "1bcb2a79-dc8e-431b-9ea8-d8da20b14d25",
          "from": {
            "id": "9a523566-69cb-4054-89c1-b8e29e300154",
            "x": 0,
            "y": 24,
            "pos": {
              "x": 0,
              "y": 24
            },
            "posSlab": {
              "x": 0,
              "y": 24
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "leftbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "59c85421-bfea-4676-8b14-de8a67824aea",
            "x": 0,
            "y": 0,
            "pos": {
              "x": 0,
              "y": 0
            },
            "posSlab": {
              "x": 0,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "lefttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "98cd22c5-01ce-47ac-a7b6-083cb28dc7be",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        }
      ],
      "shapeType": "square",
      "rotatedDegrees": 0,
      "rotatedDegreesSlab": 0,
      "partId": "lower_cabinet_boxes",
      "qtCatName": "Kitchen",
      "fromLayout": null,
      "squareFeet": 1,
      "quantity": 1,
      "quantitySubParts": {
        "doors": 0,
        "drawers": 0,
        "cabinetDoorsAndDrawersQuantity": 0,
        "cabinetDoorsSQFT": 9.92,
        "cabinetDoorsLNFT": 0
      },
      "isDisabledInPopup": false,
      "rotateAngleParts": [],
      "isPointsChanged": true,
      "isPositionChanged": true,
      "isResetSlabModePopupWasDisplayed": false,
      "shapeSlab": {
        "absolutePosition": null
      },
      "shapeCabinet": {
        "width": 42,
        "height": 34,
        "depth": 24
      },
      "shapeAbsolute": {
        "absolutePosition": {
          "x": -104.73333333333329,
          "y": -35.999999999999986
        },
        "intersectionPoints": [],
        "snappedWithShape": 10,
        "snappedShapeGroup": 62
      },
      "shapeParams": {
        "shapeCabinet": true,
        "canSnap": true,
        "width": 42,
        "height": 34,
        "depth": 24,
        "diamondLength": 0,
        "thirdPartyAR3DMetaData": {
          "ActualDisplayedName": [
            "Aspen 5127 SM-B42"
          ],
          "DisplayedName": [
            "Aspen 5127 SM-B42"
          ],
          "Width": [
            "42"
          ],
          "Height": [
            "34"
          ],
          "Depth": [
            "24"
          ],
          "SKU": [
            "SM-B42"
          ],
          "Shape": [
            "SM-B42"
          ],
          "DoorStyle": [
            "Aspen 5127"
          ],
          "Door": [
            "2"
          ],
          "Drawer": [
            "2"
          ],
          "filters": {
            "Style": [
              "Aspen 5127"
            ],
            "Width": [
              "42"
            ],
            "Height": [
              "34"
            ],
            "Depth": [
              "24"
            ]
          }
        },
        "shapeLayout": "rectangle"
      },
      "relatedParentFeatureId": 371311823,
      "slabModeCoreParentId": null,
      "parentPartId": "bottom_cabinet",
      "slabParentPartId": null,
      "shouldUseSlabPricing": false,
      "originalPointsCoords": [
        {
          "x": 0,
          "y": 0,
          "z": 34,
          "id": "59c85421-bfea-4676-8b14-de8a67824aea"
        },
        {
          "x": 42,
          "y": 0,
          "z": 34,
          "id": "0e38b507-572e-43ae-9f6d-9d36c9df126c"
        },
        {
          "x": 42,
          "y": 24,
          "z": 34,
          "id": "366cda51-8a77-4bc6-a9d3-4222231c0bcd"
        },
        {
          "x": 0,
          "y": 24,
          "z": 34,
          "id": "9a523566-69cb-4054-89c1-b8e29e300154"
        }
      ],
      "shouldAddCabinetBox": false,
      "shapeHeight": null
    },
    {
      "pos": {
        "x": -107.13333333333331,
        "y": -152.80000000000015
      },
      "slabPos": {
        "x": -21,
        "y": -106.66666666666667
      },
      "id": 2,
      "featureId": 370760075,
      "features": [
        {
          "featureId": 370760075,
          "partId": "lower_cabinet_boxes"
        },
        {
          "featureId": 371311823,
          "partId": "bottom_cabinet"
        }
      ],
      "colorSet": null,
      "isHidden": false,
      "shapePieces": [],
      "seamCutPointsAndLines": [],
      "shapeParentId": null,
      "lines": [
        {
          "id": "68673bdb-08fe-4be9-b4f1-1911707986f6",
          "from": {
            "id": "aaf5fa2f-5674-4c91-9fe1-3762ffa63d7b",
            "x": 0,
            "y": 0,
            "pos": {
              "x": 0,
              "y": 0
            },
            "posSlab": {
              "x": 0,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "lefttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "8f4a11af-98f1-455d-937f-520051456bb4",
            "x": 42,
            "y": 0,
            "pos": {
              "x": 42,
              "y": 0
            },
            "posSlab": {
              "x": 42,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "righttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "5439eec1-1803-4bb5-8527-8423ad7d34dd",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "2ec696c8-5111-4e47-8912-5e08688bcbce",
          "from": {
            "id": "8f4a11af-98f1-455d-937f-520051456bb4",
            "x": 42,
            "y": 0,
            "pos": {
              "x": 42,
              "y": 0
            },
            "posSlab": {
              "x": 42,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "righttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "59b23754-d47b-44f5-bfb8-6f3adeec93d6",
            "x": 42,
            "y": 24,
            "pos": {
              "x": 42,
              "y": 24
            },
            "posSlab": {
              "x": 42,
              "y": 24
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "rightbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "95760f53-28fc-4cf5-ac10-43842f3c6342",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "1bd911b7-7b53-4625-acab-e054082e583b",
          "from": {
            "id": "59b23754-d47b-44f5-bfb8-6f3adeec93d6",
            "x": 42,
            "y": 24,
            "pos": {
              "x": 42,
              "y": 24
            },
            "posSlab": {
              "x": 42,
              "y": 24
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "rightbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "ab93e8a0-a13c-4314-9783-49067aec500f",
            "x": 0,
            "y": 24,
            "pos": {
              "x": 0,
              "y": 24
            },
            "posSlab": {
              "x": 0,
              "y": 24
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "leftbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "4706ed39-e8ae-447f-9ed6-087090dac54f",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "e966bca8-3f8e-41ba-8893-12f6bb5d0f9f",
          "from": {
            "id": "ab93e8a0-a13c-4314-9783-49067aec500f",
            "x": 0,
            "y": 24,
            "pos": {
              "x": 0,
              "y": 24
            },
            "posSlab": {
              "x": 0,
              "y": 24
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "leftbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "aaf5fa2f-5674-4c91-9fe1-3762ffa63d7b",
            "x": 0,
            "y": 0,
            "pos": {
              "x": 0,
              "y": 0
            },
            "posSlab": {
              "x": 0,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "lefttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "4bec7227-bdb1-42f5-9696-679798cbd682",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        }
      ],
      "shapeType": "square",
      "rotatedDegrees": 0,
      "rotatedDegreesSlab": 0,
      "partId": "lower_cabinet_boxes",
      "qtCatName": "Kitchen",
      "fromLayout": null,
      "squareFeet": 1,
      "quantity": 1,
      "quantitySubParts": {
        "doors": 0,
        "drawers": 0,
        "cabinetDoorsAndDrawersQuantity": 0,
        "cabinetDoorsSQFT": 9.92,
        "cabinetDoorsLNFT": 0
      },
      "isDisabledInPopup": false,
      "rotateAngleParts": [],
      "isPointsChanged": true,
      "isPositionChanged": true,
      "isResetSlabModePopupWasDisplayed": false,
      "shapeSlab": {
        "absolutePosition": null
      },
      "shapeCabinet": {
        "width": 42,
        "height": 34,
        "depth": 24
      },
      "shapeAbsolute": {
        "absolutePosition": {
          "x": -108.06666666666665,
          "y": -153.86666666666665
        },
        "intersectionPoints": [],
        "snappedWithShape": 14,
        "snappedShapeGroup": 61
      },
      "shapeParams": {
        "shapeCabinet": true,
        "canSnap": true,
        "width": 42,
        "height": 34,
        "depth": 24,
        "diamondLength": 0,
        "thirdPartyAR3DMetaData": {
          "ActualDisplayedName": [
            "Aspen 5127 SM-B42"
          ],
          "DisplayedName": [
            "Aspen 5127 SM-B42"
          ],
          "Width": [
            "42"
          ],
          "Height": [
            "34"
          ],
          "Depth": [
            "24"
          ],
          "SKU": [
            "SM-B42"
          ],
          "Shape": [
            "SM-B42"
          ],
          "DoorStyle": [
            "Aspen 5127"
          ],
          "Door": [
            "2"
          ],
          "Drawer": [
            "2"
          ],
          "filters": {
            "Style": [
              "Aspen 5127"
            ],
            "Width": [
              "42"
            ],
            "Height": [
              "34"
            ],
            "Depth": [
              "24"
            ]
          }
        },
        "shapeLayout": "rectangle"
      },
      "relatedParentFeatureId": 371311823,
      "slabModeCoreParentId": null,
      "parentPartId": "bottom_cabinet",
      "slabParentPartId": null,
      "shouldUseSlabPricing": false,
      "originalPointsCoords": [
        {
          "x": 0,
          "y": 0,
          "z": 34,
          "id": "aaf5fa2f-5674-4c91-9fe1-3762ffa63d7b"
        },
        {
          "x": 42,
          "y": 0,
          "z": 34,
          "id": "8f4a11af-98f1-455d-937f-520051456bb4"
        },
        {
          "x": 42,
          "y": 24,
          "z": 34,
          "id": "59b23754-d47b-44f5-bfb8-6f3adeec93d6"
        },
        {
          "x": 0,
          "y": 24,
          "z": 34,
          "id": "ab93e8a0-a13c-4314-9783-49067aec500f"
        }
      ],
      "shouldAddCabinetBox": false,
      "shapeHeight": null
    },
    {
      "pos": {
        "x": -18.333333333333492,
        "y": -35.99999999999997
      },
      "slabPos": {
        "x": -21,
        "y": -106.66666666666667
      },
      "id": 3,
      "featureId": 370760075,
      "features": [
        {
          "featureId": 370760075,
          "partId": "lower_cabinet_boxes"
        },
        {
          "featureId": 371311823,
          "partId": "bottom_cabinet"
        }
      ],
      "colorSet": null,
      "isHidden": false,
      "shapePieces": [],
      "seamCutPointsAndLines": [],
      "shapeParentId": null,
      "lines": [
        {
          "id": "3294a4e1-6a22-4e91-b618-5dcd8ee79c9b",
          "from": {
            "id": "e8305809-6d7d-4d14-91c4-e5fb8e97520d",
            "x": 0,
            "y": 0,
            "pos": {
              "x": 0,
              "y": 0
            },
            "posSlab": {
              "x": 0,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "lefttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "ec5e184b-cfbc-4c35-9a9d-67d91ca9d982",
            "x": 42,
            "y": 0,
            "pos": {
              "x": 42,
              "y": 0
            },
            "posSlab": {
              "x": 42,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "righttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "e5ecc07d-f158-4476-bbd5-7512db0d4a79",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "9ae3c326-3e7a-4547-b3d2-7b41fd3e1f00",
          "from": {
            "id": "ec5e184b-cfbc-4c35-9a9d-67d91ca9d982",
            "x": 42,
            "y": 0,
            "pos": {
              "x": 42,
              "y": 0
            },
            "posSlab": {
              "x": 42,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "righttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "f537a66b-010e-4732-bd86-c034248b96e4",
            "x": 42,
            "y": 24,
            "pos": {
              "x": 42,
              "y": 24
            },
            "posSlab": {
              "x": 42,
              "y": 24
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "rightbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "143bc8f1-f740-47c9-baec-c0c66f393821",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "2317431f-d9ea-4001-b9eb-c1613066834d",
          "from": {
            "id": "f537a66b-010e-4732-bd86-c034248b96e4",
            "x": 42,
            "y": 24,
            "pos": {
              "x": 42,
              "y": 24
            },
            "posSlab": {
              "x": 42,
              "y": 24
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "rightbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "4ed58fbf-cf14-412e-80b7-f3d83e8eb260",
            "x": 0,
            "y": 24,
            "pos": {
              "x": 0,
              "y": 24
            },
            "posSlab": {
              "x": 0,
              "y": 24
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "leftbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "17303f8d-96fb-48bf-8866-5494e7530909",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "2493867e-32f2-4ad1-a460-523256892cc9",
          "from": {
            "id": "4ed58fbf-cf14-412e-80b7-f3d83e8eb260",
            "x": 0,
            "y": 24,
            "pos": {
              "x": 0,
              "y": 24
            },
            "posSlab": {
              "x": 0,
              "y": 24
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "leftbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "e8305809-6d7d-4d14-91c4-e5fb8e97520d",
            "x": 0,
            "y": 0,
            "pos": {
              "x": 0,
              "y": 0
            },
            "posSlab": {
              "x": 0,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "lefttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "093cfff7-741f-48f9-bbad-d11eb3081a71",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        }
      ],
      "shapeType": "square",
      "rotatedDegrees": 0,
      "rotatedDegreesSlab": 0,
      "partId": "lower_cabinet_boxes",
      "qtCatName": "Kitchen",
      "fromLayout": null,
      "squareFeet": 1,
      "quantity": 1,
      "quantitySubParts": {
        "doors": 0,
        "drawers": 0,
        "cabinetDoorsAndDrawersQuantity": 0,
        "cabinetDoorsSQFT": 9.92,
        "cabinetDoorsLNFT": 0
      },
      "isDisabledInPopup": false,
      "rotateAngleParts": [],
      "isPointsChanged": true,
      "isPositionChanged": true,
      "isResetSlabModePopupWasDisplayed": false,
      "shapeSlab": {
        "absolutePosition": null
      },
      "shapeCabinet": {
        "width": 42,
        "height": 34,
        "depth": 24
      },
      "shapeAbsolute": {
        "absolutePosition": {
          "x": -20.733333333333313,
          "y": -35.99999999999997
        },
        "intersectionPoints": [],
        "snappedWithShape": 4,
        "snappedShapeGroup": 62
      },
      "shapeParams": {
        "shapeCabinet": true,
        "canSnap": true,
        "width": 42,
        "height": 34,
        "depth": 24,
        "diamondLength": 0,
        "thirdPartyAR3DMetaData": {
          "ActualDisplayedName": [
            "Aspen 5127 SM-B42"
          ],
          "DisplayedName": [
            "Aspen 5127 SM-B42"
          ],
          "Width": [
            "42"
          ],
          "Height": [
            "34"
          ],
          "Depth": [
            "24"
          ],
          "SKU": [
            "SM-B42"
          ],
          "Shape": [
            "SM-B42"
          ],
          "DoorStyle": [
            "Aspen 5127"
          ],
          "Door": [
            "2"
          ],
          "Drawer": [
            "2"
          ],
          "filters": {
            "Style": [
              "Aspen 5127"
            ],
            "Width": [
              "42"
            ],
            "Height": [
              "34"
            ],
            "Depth": [
              "24"
            ]
          }
        },
        "shapeLayout": "rectangle"
      },
      "relatedParentFeatureId": 371311823,
      "slabModeCoreParentId": null,
      "parentPartId": "bottom_cabinet",
      "slabParentPartId": null,
      "shouldUseSlabPricing": false,
      "originalPointsCoords": [
        {
          "x": 0,
          "y": 0,
          "z": 34,
          "id": "e8305809-6d7d-4d14-91c4-e5fb8e97520d"
        },
        {
          "x": 42,
          "y": 0,
          "z": 34,
          "id": "ec5e184b-cfbc-4c35-9a9d-67d91ca9d982"
        },
        {
          "x": 42,
          "y": 24,
          "z": 34,
          "id": "f537a66b-010e-4732-bd86-c034248b96e4"
        },
        {
          "x": 0,
          "y": 24,
          "z": 34,
          "id": "4ed58fbf-cf14-412e-80b7-f3d83e8eb260"
        }
      ],
      "shouldAddCabinetBox": false,
      "shapeHeight": null
    },
    {
      "pos": {
        "x": 20.33333333333333,
        "y": -35.73333333333338
      },
      "slabPos": {
        "x": -21,
        "y": -106.66666666666667
      },
      "id": 4,
      "featureId": 370760075,
      "features": [
        {
          "featureId": 370760075,
          "partId": "lower_cabinet_boxes"
        },
        {
          "featureId": 371311823,
          "partId": "bottom_cabinet"
        }
      ],
      "colorSet": null,
      "isHidden": false,
      "shapePieces": [],
      "seamCutPointsAndLines": [],
      "shapeParentId": null,
      "lines": [
        {
          "id": "7c6595ad-451f-4b75-a2a4-c464762a372b",
          "from": {
            "id": "3ba5954d-76a8-47b4-992c-35839a53e7a6",
            "x": 0,
            "y": 0,
            "pos": {
              "x": 0,
              "y": 0
            },
            "posSlab": {
              "x": 0,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "lefttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "0d145e92-98e7-4920-ae04-865e9c5cc34d",
            "x": 42,
            "y": 0,
            "pos": {
              "x": 42,
              "y": 0
            },
            "posSlab": {
              "x": 42,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "righttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "6519e405-e974-4013-9390-c9031e46739a",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "599fcec7-6b66-4d25-821a-562867681288",
          "from": {
            "id": "0d145e92-98e7-4920-ae04-865e9c5cc34d",
            "x": 42,
            "y": 0,
            "pos": {
              "x": 42,
              "y": 0
            },
            "posSlab": {
              "x": 42,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "righttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "abdacd35-acc9-4256-8b29-89db93907ef8",
            "x": 42,
            "y": 24,
            "pos": {
              "x": 42,
              "y": 24
            },
            "posSlab": {
              "x": 42,
              "y": 24
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "rightbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "ce64cd56-ce53-4e30-a423-26d2bbebaf95",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "a79a7a4b-3e8c-4eb0-8ca6-d6bd5cd759aa",
          "from": {
            "id": "abdacd35-acc9-4256-8b29-89db93907ef8",
            "x": 42,
            "y": 24,
            "pos": {
              "x": 42,
              "y": 24
            },
            "posSlab": {
              "x": 42,
              "y": 24
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "rightbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "f813063b-7137-4006-81ee-6ed1625ef725",
            "x": 0,
            "y": 24,
            "pos": {
              "x": 0,
              "y": 24
            },
            "posSlab": {
              "x": 0,
              "y": 24
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "leftbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "59d38ae1-26c1-40a7-a936-5cd8be41c3b4",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "fed03798-8e89-42fc-a79f-bff4676a4af7",
          "from": {
            "id": "f813063b-7137-4006-81ee-6ed1625ef725",
            "x": 0,
            "y": 24,
            "pos": {
              "x": 0,
              "y": 24
            },
            "posSlab": {
              "x": 0,
              "y": 24
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "leftbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "3ba5954d-76a8-47b4-992c-35839a53e7a6",
            "x": 0,
            "y": 0,
            "pos": {
              "x": 0,
              "y": 0
            },
            "posSlab": {
              "x": 0,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "lefttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "a82014dd-b1b0-4c61-aff2-a950e71d9f99",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        }
      ],
      "shapeType": "square",
      "rotatedDegrees": 0,
      "rotatedDegreesSlab": 0,
      "partId": "lower_cabinet_boxes",
      "qtCatName": "Kitchen",
      "fromLayout": null,
      "squareFeet": 1,
      "quantity": 1,
      "quantitySubParts": {
        "doors": 0,
        "drawers": 0,
        "cabinetDoorsAndDrawersQuantity": 0,
        "cabinetDoorsSQFT": 9.92,
        "cabinetDoorsLNFT": 0
      },
      "isDisabledInPopup": false,
      "rotateAngleParts": [],
      "isPointsChanged": true,
      "isPositionChanged": true,
      "isResetSlabModePopupWasDisplayed": false,
      "shapeSlab": {
        "absolutePosition": null
      },
      "shapeCabinet": {
        "width": 42,
        "height": 34,
        "depth": 24
      },
      "shapeAbsolute": {
        "absolutePosition": {
          "x": 21.26666666666669,
          "y": -35.99999999999995
        },
        "intersectionPoints": [],
        "snappedWithShape": 3,
        "snappedShapeGroup": 62
      },
      "shapeParams": {
        "shapeCabinet": true,
        "canSnap": true,
        "width": 42,
        "height": 34,
        "depth": 24,
        "diamondLength": 0,
        "thirdPartyAR3DMetaData": {
          "ActualDisplayedName": [
            "Aspen 5127 SM-B42"
          ],
          "DisplayedName": [
            "Aspen 5127 SM-B42"
          ],
          "Width": [
            "42"
          ],
          "Height": [
            "34"
          ],
          "Depth": [
            "24"
          ],
          "SKU": [
            "SM-B42"
          ],
          "Shape": [
            "SM-B42"
          ],
          "DoorStyle": [
            "Aspen 5127"
          ],
          "Door": [
            "2"
          ],
          "Drawer": [
            "2"
          ],
          "filters": {
            "Style": [
              "Aspen 5127"
            ],
            "Width": [
              "42"
            ],
            "Height": [
              "34"
            ],
            "Depth": [
              "24"
            ]
          }
        },
        "shapeLayout": "rectangle"
      },
      "relatedParentFeatureId": 371311823,
      "slabModeCoreParentId": null,
      "parentPartId": "bottom_cabinet",
      "slabParentPartId": null,
      "shouldUseSlabPricing": false,
      "originalPointsCoords": [
        {
          "x": 0,
          "y": 0,
          "z": 34,
          "id": "3ba5954d-76a8-47b4-992c-35839a53e7a6"
        },
        {
          "x": 42,
          "y": 0,
          "z": 34,
          "id": "0d145e92-98e7-4920-ae04-865e9c5cc34d"
        },
        {
          "x": 42,
          "y": 24,
          "z": 34,
          "id": "abdacd35-acc9-4256-8b29-89db93907ef8"
        },
        {
          "x": 0,
          "y": 24,
          "z": 34,
          "id": "f813063b-7137-4006-81ee-6ed1625ef725"
        }
      ],
      "shouldAddCabinetBox": false,
      "shapeHeight": null
    },
    {
      "pos": {
        "x": 49.93333333333339,
        "y": -97.33333333333336
      },
      "slabPos": {
        "x": -21,
        "y": -106.66666666666667
      },
      "id": 5,
      "featureId": 370760075,
      "features": [
        {
          "featureId": 370760075,
          "partId": "lower_cabinet_boxes"
        },
        {
          "featureId": 371311823,
          "partId": "bottom_cabinet"
        }
      ],
      "colorSet": null,
      "isHidden": false,
      "shapePieces": [],
      "seamCutPointsAndLines": [],
      "shapeParentId": null,
      "lines": [
        {
          "id": "e98fea7e-3018-477c-bb06-3c1f928ad35f",
          "from": {
            "id": "b3e1b39c-2077-48d9-a403-4b0dac45b57d",
            "x": 0,
            "y": 0,
            "pos": {
              "x": 0,
              "y": 0
            },
            "posSlab": {
              "x": 0,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "lefttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "607363ec-050b-4566-b0b0-d6f0c7d484a6",
            "x": 42,
            "y": 0,
            "pos": {
              "x": 42,
              "y": 0
            },
            "posSlab": {
              "x": 42,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "righttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "25b10bc2-9d0e-4799-a9b9-7028bec2c184",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "2bcd3fb6-743a-4a7a-96ba-a039281c0cb8",
          "from": {
            "id": "607363ec-050b-4566-b0b0-d6f0c7d484a6",
            "x": 42,
            "y": 0,
            "pos": {
              "x": 42,
              "y": 0
            },
            "posSlab": {
              "x": 42,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "righttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "7c903ca6-422f-4cb2-97a6-544894818085",
            "x": 42,
            "y": 24,
            "pos": {
              "x": 42,
              "y": 24
            },
            "posSlab": {
              "x": 42,
              "y": 24
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "rightbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "e4f2da2c-44ab-4f4a-ba56-66f82d8a8eaa",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "00d68c28-f79f-489d-ad3c-00ee4133c65f",
          "from": {
            "id": "7c903ca6-422f-4cb2-97a6-544894818085",
            "x": 42,
            "y": 24,
            "pos": {
              "x": 42,
              "y": 24
            },
            "posSlab": {
              "x": 42,
              "y": 24
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "rightbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "2d2ef3ad-0c91-4ea1-a478-f86c258530f4",
            "x": 0,
            "y": 24,
            "pos": {
              "x": 0,
              "y": 24
            },
            "posSlab": {
              "x": 0,
              "y": 24
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "leftbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "221e9f54-ec20-49cf-bd39-0dc6bdeec691",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "48cc27ab-bee5-44a5-94f7-996850f85f28",
          "from": {
            "id": "2d2ef3ad-0c91-4ea1-a478-f86c258530f4",
            "x": 0,
            "y": 24,
            "pos": {
              "x": 0,
              "y": 24
            },
            "posSlab": {
              "x": 0,
              "y": 24
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "leftbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "b3e1b39c-2077-48d9-a403-4b0dac45b57d",
            "x": 0,
            "y": 0,
            "pos": {
              "x": 0,
              "y": 0
            },
            "posSlab": {
              "x": 0,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "lefttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "6ac7562d-deb9-42a7-bc56-84b3cb6d8563",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        }
      ],
      "shapeType": "square",
      "rotatedDegrees": 0,
      "rotatedDegreesSlab": 0,
      "partId": "lower_cabinet_boxes",
      "qtCatName": "Kitchen",
      "fromLayout": null,
      "squareFeet": 1,
      "quantity": 1,
      "quantitySubParts": {
        "doors": 0,
        "drawers": 0,
        "cabinetDoorsAndDrawersQuantity": 0,
        "cabinetDoorsSQFT": 9.92,
        "cabinetDoorsLNFT": 0
      },
      "isDisabledInPopup": false,
      "rotateAngleParts": [],
      "isPointsChanged": true,
      "isPositionChanged": true,
      "isResetSlabModePopupWasDisplayed": false,
      "shapeSlab": {
        "absolutePosition": null
      },
      "shapeCabinet": {
        "width": 42,
        "height": 34,
        "depth": 24
      },
      "shapeAbsolute": {
        "absolutePosition": {
          "x": 49.93333333333332,
          "y": -98.13333333333331
        },
        "intersectionPoints": [],
        "snappedWithShape": 6,
        "snappedShapeGroup": 60
      },
      "shapeParams": {
        "shapeCabinet": true,
        "canSnap": true,
        "width": 42,
        "height": 34,
        "depth": 24,
        "diamondLength": 0,
        "thirdPartyAR3DMetaData": {
          "ActualDisplayedName": [
            "Aspen 5127 SM-B42"
          ],
          "DisplayedName": [
            "Aspen 5127 SM-B42"
          ],
          "Width": [
            "42"
          ],
          "Height": [
            "34"
          ],
          "Depth": [
            "24"
          ],
          "SKU": [
            "SM-B42"
          ],
          "Shape": [
            "SM-B42"
          ],
          "DoorStyle": [
            "Aspen 5127"
          ],
          "Door": [
            "2"
          ],
          "Drawer": [
            "2"
          ],
          "filters": {
            "Style": [
              "Aspen 5127"
            ],
            "Width": [
              "42"
            ],
            "Height": [
              "34"
            ],
            "Depth": [
              "24"
            ]
          }
        },
        "shapeLayout": "rectangle"
      },
      "relatedParentFeatureId": 371311823,
      "slabModeCoreParentId": null,
      "parentPartId": "bottom_cabinet",
      "slabParentPartId": null,
      "shouldUseSlabPricing": false,
      "originalPointsCoords": [
        {
          "x": 0,
          "y": 0,
          "z": 34,
          "id": "b3e1b39c-2077-48d9-a403-4b0dac45b57d"
        },
        {
          "x": 42,
          "y": 0,
          "z": 34,
          "id": "607363ec-050b-4566-b0b0-d6f0c7d484a6"
        },
        {
          "x": 42,
          "y": 24,
          "z": 34,
          "id": "7c903ca6-422f-4cb2-97a6-544894818085"
        },
        {
          "x": 0,
          "y": 24,
          "z": 34,
          "id": "2d2ef3ad-0c91-4ea1-a478-f86c258530f4"
        }
      ],
      "shouldAddCabinetBox": false,
      "shapeHeight": null
    },
    {
      "pos": {
        "x": 7.799999999999996,
        "y": -96.2666666666667
      },
      "slabPos": {
        "x": -21,
        "y": -106.66666666666667
      },
      "id": 6,
      "featureId": 370760075,
      "features": [
        {
          "featureId": 370760075,
          "partId": "lower_cabinet_boxes"
        },
        {
          "featureId": 371311823,
          "partId": "bottom_cabinet"
        }
      ],
      "colorSet": null,
      "isHidden": false,
      "shapePieces": [],
      "seamCutPointsAndLines": [],
      "shapeParentId": null,
      "lines": [
        {
          "id": "e0119535-700b-4fd6-a310-9900d972bc5f",
          "from": {
            "id": "bc788d51-38fa-498e-86da-c6d2851ef497",
            "x": 0,
            "y": 0,
            "pos": {
              "x": 0,
              "y": 0
            },
            "posSlab": {
              "x": 0,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "lefttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "0203f8f9-e347-4697-8bf6-190f8c206141",
            "x": 42,
            "y": 0,
            "pos": {
              "x": 42,
              "y": 0
            },
            "posSlab": {
              "x": 42,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "righttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "1ee43218-a96d-4df7-9cc0-134e43c1e94c",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "41814718-ea3e-4155-b57c-14333279d568",
          "from": {
            "id": "0203f8f9-e347-4697-8bf6-190f8c206141",
            "x": 42,
            "y": 0,
            "pos": {
              "x": 42,
              "y": 0
            },
            "posSlab": {
              "x": 42,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "righttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "8ac6525d-95a9-41e0-a53e-19d75b508f6b",
            "x": 42,
            "y": 24,
            "pos": {
              "x": 42,
              "y": 24
            },
            "posSlab": {
              "x": 42,
              "y": 24
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "rightbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "b22a6327-417c-4c09-8a00-c1b436c3c002",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "ebf213a7-2cd0-41b9-a900-8803a8526a97",
          "from": {
            "id": "8ac6525d-95a9-41e0-a53e-19d75b508f6b",
            "x": 42,
            "y": 24,
            "pos": {
              "x": 42,
              "y": 24
            },
            "posSlab": {
              "x": 42,
              "y": 24
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "rightbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "1fb26e9e-03e8-4d8b-95fa-b927fffd4349",
            "x": 0,
            "y": 24,
            "pos": {
              "x": 0,
              "y": 24
            },
            "posSlab": {
              "x": 0,
              "y": 24
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "leftbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "cb44504d-3184-4f99-95b0-93846d9c37b9",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "f5df7ca4-8809-480d-9d50-bc860554eb77",
          "from": {
            "id": "1fb26e9e-03e8-4d8b-95fa-b927fffd4349",
            "x": 0,
            "y": 24,
            "pos": {
              "x": 0,
              "y": 24
            },
            "posSlab": {
              "x": 0,
              "y": 24
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "leftbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "bc788d51-38fa-498e-86da-c6d2851ef497",
            "x": 0,
            "y": 0,
            "pos": {
              "x": 0,
              "y": 0
            },
            "posSlab": {
              "x": 0,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "lefttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "ad3b5984-008c-4d10-b8ed-0e1df3bfd36b",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        }
      ],
      "shapeType": "square",
      "rotatedDegrees": 0,
      "rotatedDegreesSlab": 0,
      "partId": "lower_cabinet_boxes",
      "qtCatName": "Kitchen",
      "fromLayout": null,
      "squareFeet": 1,
      "quantity": 1,
      "quantitySubParts": {
        "doors": 0,
        "drawers": 0,
        "cabinetDoorsAndDrawersQuantity": 0,
        "cabinetDoorsSQFT": 9.92,
        "cabinetDoorsLNFT": 0
      },
      "isDisabledInPopup": false,
      "rotateAngleParts": [],
      "isPointsChanged": true,
      "isPositionChanged": true,
      "isResetSlabModePopupWasDisplayed": false,
      "shapeSlab": {
        "absolutePosition": null
      },
      "shapeCabinet": {
        "width": 42,
        "height": 34,
        "depth": 24
      },
      "shapeAbsolute": {
        "absolutePosition": {
          "x": 7.93333333333333,
          "y": -98.13333333333331
        },
        "intersectionPoints": [],
        "snappedWithShape": 5,
        "snappedShapeGroup": 60
      },
      "shapeParams": {
        "shapeCabinet": true,
        "canSnap": true,
        "width": 42,
        "height": 34,
        "depth": 24,
        "diamondLength": 0,
        "thirdPartyAR3DMetaData": {
          "ActualDisplayedName": [
            "Aspen 5127 SM-B42"
          ],
          "DisplayedName": [
            "Aspen 5127 SM-B42"
          ],
          "Width": [
            "42"
          ],
          "Height": [
            "34"
          ],
          "Depth": [
            "24"
          ],
          "SKU": [
            "SM-B42"
          ],
          "Shape": [
            "SM-B42"
          ],
          "DoorStyle": [
            "Aspen 5127"
          ],
          "Door": [
            "2"
          ],
          "Drawer": [
            "2"
          ],
          "filters": {
            "Style": [
              "Aspen 5127"
            ],
            "Width": [
              "42"
            ],
            "Height": [
              "34"
            ],
            "Depth": [
              "24"
            ]
          }
        },
        "shapeLayout": "rectangle"
      },
      "relatedParentFeatureId": 371311823,
      "slabModeCoreParentId": null,
      "parentPartId": "bottom_cabinet",
      "slabParentPartId": null,
      "shouldUseSlabPricing": false,
      "originalPointsCoords": [
        {
          "x": 0,
          "y": 0,
          "z": 34,
          "id": "bc788d51-38fa-498e-86da-c6d2851ef497"
        },
        {
          "x": 42,
          "y": 0,
          "z": 34,
          "id": "0203f8f9-e347-4697-8bf6-190f8c206141"
        },
        {
          "x": 42,
          "y": 24,
          "z": 34,
          "id": "8ac6525d-95a9-41e0-a53e-19d75b508f6b"
        },
        {
          "x": 0,
          "y": 24,
          "z": 34,
          "id": "1fb26e9e-03e8-4d8b-95fa-b927fffd4349"
        }
      ],
      "shouldAddCabinetBox": false,
      "shapeHeight": null
    },
    {
      "pos": {
        "x": -33.8,
        "y": -98.13333333333335
      },
      "slabPos": {
        "x": -21,
        "y": -106.66666666666667
      },
      "id": 7,
      "featureId": 370760075,
      "features": [
        {
          "featureId": 370760075,
          "partId": "lower_cabinet_boxes"
        },
        {
          "featureId": 371311823,
          "partId": "bottom_cabinet"
        }
      ],
      "colorSet": null,
      "isHidden": false,
      "shapePieces": [],
      "seamCutPointsAndLines": [],
      "shapeParentId": null,
      "lines": [
        {
          "id": "dc8df901-efbc-4dcd-9c0d-b21e49935d03",
          "from": {
            "id": "13158ed3-4f96-410c-b585-f077a6b51724",
            "x": 0,
            "y": 0,
            "pos": {
              "x": 0,
              "y": 0
            },
            "posSlab": {
              "x": 0,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "lefttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "9a6c4ef9-6a54-4cb7-b774-5c5c36497e7f",
            "x": 42,
            "y": 0,
            "pos": {
              "x": 42,
              "y": 0
            },
            "posSlab": {
              "x": 42,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "righttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "7882e95a-ee99-438f-92d8-712005702630",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "056bc07a-0086-4df6-868c-d44437b2d963",
          "from": {
            "id": "9a6c4ef9-6a54-4cb7-b774-5c5c36497e7f",
            "x": 42,
            "y": 0,
            "pos": {
              "x": 42,
              "y": 0
            },
            "posSlab": {
              "x": 42,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "righttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "0a549c4d-f9bf-429e-a69c-8fb996e4d44a",
            "x": 42,
            "y": 24,
            "pos": {
              "x": 42,
              "y": 24
            },
            "posSlab": {
              "x": 42,
              "y": 24
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "rightbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "63963176-66f0-4ff5-a733-915a3d3fb2eb",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "e56741b5-c4b7-4444-89a3-8bb2a784f638",
          "from": {
            "id": "0a549c4d-f9bf-429e-a69c-8fb996e4d44a",
            "x": 42,
            "y": 24,
            "pos": {
              "x": 42,
              "y": 24
            },
            "posSlab": {
              "x": 42,
              "y": 24
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "rightbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "d9e0ffae-6cf7-45f6-9746-df115bd8774e",
            "x": 0,
            "y": 24,
            "pos": {
              "x": 0,
              "y": 24
            },
            "posSlab": {
              "x": 0,
              "y": 24
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "leftbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "18b451d1-6f57-4aca-a1b1-906e2aa46f47",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "fe56168e-fda9-4cce-b108-412271cc7daf",
          "from": {
            "id": "d9e0ffae-6cf7-45f6-9746-df115bd8774e",
            "x": 0,
            "y": 24,
            "pos": {
              "x": 0,
              "y": 24
            },
            "posSlab": {
              "x": 0,
              "y": 24
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "leftbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "13158ed3-4f96-410c-b585-f077a6b51724",
            "x": 0,
            "y": 0,
            "pos": {
              "x": 0,
              "y": 0
            },
            "posSlab": {
              "x": 0,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "lefttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "21c9a877-5b03-4ffd-ad6d-17794e5760bf",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        }
      ],
      "shapeType": "square",
      "rotatedDegrees": 0,
      "rotatedDegreesSlab": 0,
      "partId": "lower_cabinet_boxes",
      "qtCatName": "Kitchen",
      "fromLayout": null,
      "squareFeet": 1,
      "quantity": 1,
      "quantitySubParts": {
        "doors": 0,
        "drawers": 0,
        "cabinetDoorsAndDrawersQuantity": 0,
        "cabinetDoorsSQFT": 9.92,
        "cabinetDoorsLNFT": 0
      },
      "isDisabledInPopup": false,
      "rotateAngleParts": [],
      "isPointsChanged": true,
      "isPositionChanged": true,
      "isResetSlabModePopupWasDisplayed": false,
      "shapeSlab": {
        "absolutePosition": null
      },
      "shapeCabinet": {
        "width": 42,
        "height": 34,
        "depth": 24
      },
      "shapeAbsolute": {
        "absolutePosition": {
          "x": -34.06666666666666,
          "y": -98.13333333333331
        },
        "intersectionPoints": [],
        "snappedWithShape": 8,
        "snappedShapeGroup": 60
      },
      "shapeParams": {
        "shapeCabinet": true,
        "canSnap": true,
        "width": 42,
        "height": 34,
        "depth": 24,
        "diamondLength": 0,
        "thirdPartyAR3DMetaData": {
          "ActualDisplayedName": [
            "Aspen 5127 SM-B42"
          ],
          "DisplayedName": [
            "Aspen 5127 SM-B42"
          ],
          "Width": [
            "42"
          ],
          "Height": [
            "34"
          ],
          "Depth": [
            "24"
          ],
          "SKU": [
            "SM-B42"
          ],
          "Shape": [
            "SM-B42"
          ],
          "DoorStyle": [
            "Aspen 5127"
          ],
          "Door": [
            "2"
          ],
          "Drawer": [
            "2"
          ],
          "filters": {
            "Style": [
              "Aspen 5127"
            ],
            "Width": [
              "42"
            ],
            "Height": [
              "34"
            ],
            "Depth": [
              "24"
            ]
          }
        },
        "shapeLayout": "rectangle"
      },
      "relatedParentFeatureId": 371311823,
      "slabModeCoreParentId": null,
      "parentPartId": "bottom_cabinet",
      "slabParentPartId": null,
      "shouldUseSlabPricing": false,
      "originalPointsCoords": [
        {
          "x": 0,
          "y": 0,
          "z": 34,
          "id": "13158ed3-4f96-410c-b585-f077a6b51724"
        },
        {
          "x": 42,
          "y": 0,
          "z": 34,
          "id": "9a6c4ef9-6a54-4cb7-b774-5c5c36497e7f"
        },
        {
          "x": 42,
          "y": 24,
          "z": 34,
          "id": "0a549c4d-f9bf-429e-a69c-8fb996e4d44a"
        },
        {
          "x": 0,
          "y": 24,
          "z": 34,
          "id": "d9e0ffae-6cf7-45f6-9746-df115bd8774e"
        }
      ],
      "shouldAddCabinetBox": false,
      "shapeHeight": null
    },
    {
      "pos": {
        "x": -76.99999999999999,
        "y": -98.4
      },
      "slabPos": {
        "x": -21,
        "y": -106.66666666666667
      },
      "id": 8,
      "featureId": 370760075,
      "features": [
        {
          "featureId": 370760075,
          "partId": "lower_cabinet_boxes"
        },
        {
          "featureId": 371311823,
          "partId": "bottom_cabinet"
        }
      ],
      "colorSet": null,
      "isHidden": false,
      "shapePieces": [],
      "seamCutPointsAndLines": [],
      "shapeParentId": null,
      "lines": [
        {
          "id": "dab0d19c-bf07-41de-83c1-117197ddf0b0",
          "from": {
            "id": "4d4e39b8-6234-45e0-9ecc-86dbfee018cb",
            "x": 0,
            "y": 0,
            "pos": {
              "x": 0,
              "y": 0
            },
            "posSlab": {
              "x": 0,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "lefttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "073c5e6a-6377-40c1-b502-64c7f24c7935",
            "x": 42,
            "y": 0,
            "pos": {
              "x": 42,
              "y": 0
            },
            "posSlab": {
              "x": 42,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "righttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "db2c9cb3-47fd-4ada-aaa6-ad80114ecd58",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "78b14a01-e50b-42ad-a204-8b3a3af74aaa",
          "from": {
            "id": "073c5e6a-6377-40c1-b502-64c7f24c7935",
            "x": 42,
            "y": 0,
            "pos": {
              "x": 42,
              "y": 0
            },
            "posSlab": {
              "x": 42,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "righttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "807a58c7-4097-4be5-a197-1d4980168423",
            "x": 42,
            "y": 24,
            "pos": {
              "x": 42,
              "y": 24
            },
            "posSlab": {
              "x": 42,
              "y": 24
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "rightbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "8cc8af75-301a-4a17-ba1f-46626d769b37",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "7ed0c1aa-0b46-439a-99cb-150a54dbd484",
          "from": {
            "id": "807a58c7-4097-4be5-a197-1d4980168423",
            "x": 42,
            "y": 24,
            "pos": {
              "x": 42,
              "y": 24
            },
            "posSlab": {
              "x": 42,
              "y": 24
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "rightbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "b78b40c3-b87a-4dd5-b95f-34472c53feb9",
            "x": 0,
            "y": 24,
            "pos": {
              "x": 0,
              "y": 24
            },
            "posSlab": {
              "x": 0,
              "y": 24
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "leftbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "e0fd84d3-2423-4055-9edf-792fe9f81687",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "565c0f9b-a963-472a-af4f-2c6ab50e8b44",
          "from": {
            "id": "b78b40c3-b87a-4dd5-b95f-34472c53feb9",
            "x": 0,
            "y": 24,
            "pos": {
              "x": 0,
              "y": 24
            },
            "posSlab": {
              "x": 0,
              "y": 24
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "leftbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "4d4e39b8-6234-45e0-9ecc-86dbfee018cb",
            "x": 0,
            "y": 0,
            "pos": {
              "x": 0,
              "y": 0
            },
            "posSlab": {
              "x": 0,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "lefttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "ebe4ff6a-cf08-4c53-8ba5-0dbf4a55bf78",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        }
      ],
      "shapeType": "square",
      "rotatedDegrees": 0,
      "rotatedDegreesSlab": 0,
      "partId": "lower_cabinet_boxes",
      "qtCatName": "Kitchen",
      "fromLayout": null,
      "squareFeet": 1,
      "quantity": 1,
      "quantitySubParts": {
        "doors": 0,
        "drawers": 0,
        "cabinetDoorsAndDrawersQuantity": 0,
        "cabinetDoorsSQFT": 9.92,
        "cabinetDoorsLNFT": 0
      },
      "isDisabledInPopup": false,
      "rotateAngleParts": [],
      "isPointsChanged": true,
      "isPositionChanged": true,
      "isResetSlabModePopupWasDisplayed": false,
      "shapeSlab": {
        "absolutePosition": null
      },
      "shapeCabinet": {
        "width": 42,
        "height": 34,
        "depth": 24
      },
      "shapeAbsolute": {
        "absolutePosition": {
          "x": -76.06666666666665,
          "y": -98.1333333333333
        },
        "intersectionPoints": [],
        "snappedWithShape": 7,
        "snappedShapeGroup": 60
      },
      "shapeParams": {
        "shapeCabinet": true,
        "canSnap": true,
        "width": 42,
        "height": 34,
        "depth": 24,
        "diamondLength": 0,
        "thirdPartyAR3DMetaData": {
          "ActualDisplayedName": [
            "Aspen 5127 SM-B42"
          ],
          "DisplayedName": [
            "Aspen 5127 SM-B42"
          ],
          "Width": [
            "42"
          ],
          "Height": [
            "34"
          ],
          "Depth": [
            "24"
          ],
          "SKU": [
            "SM-B42"
          ],
          "Shape": [
            "SM-B42"
          ],
          "DoorStyle": [
            "Aspen 5127"
          ],
          "Door": [
            "2"
          ],
          "Drawer": [
            "2"
          ],
          "filters": {
            "Style": [
              "Aspen 5127"
            ],
            "Width": [
              "42"
            ],
            "Height": [
              "34"
            ],
            "Depth": [
              "24"
            ]
          }
        },
        "shapeLayout": "rectangle"
      },
      "relatedParentFeatureId": 371311823,
      "slabModeCoreParentId": null,
      "parentPartId": "bottom_cabinet",
      "slabParentPartId": null,
      "shouldUseSlabPricing": false,
      "originalPointsCoords": [
        {
          "x": 0,
          "y": 0,
          "z": 34,
          "id": "4d4e39b8-6234-45e0-9ecc-86dbfee018cb"
        },
        {
          "x": 42,
          "y": 0,
          "z": 34,
          "id": "073c5e6a-6377-40c1-b502-64c7f24c7935"
        },
        {
          "x": 42,
          "y": 24,
          "z": 34,
          "id": "807a58c7-4097-4be5-a197-1d4980168423"
        },
        {
          "x": 0,
          "y": 24,
          "z": 34,
          "id": "b78b40c3-b87a-4dd5-b95f-34472c53feb9"
        }
      ],
      "shouldAddCabinetBox": false,
      "shapeHeight": null
    },
    {
      "pos": {
        "x": -118.06666666666665,
        "y": -98.13333333333328
      },
      "slabPos": {
        "x": -21,
        "y": -106.66666666666667
      },
      "id": 9,
      "featureId": 370760075,
      "features": [
        {
          "featureId": 370760075,
          "partId": "lower_cabinet_boxes"
        },
        {
          "featureId": 371311823,
          "partId": "bottom_cabinet"
        }
      ],
      "colorSet": null,
      "isHidden": false,
      "shapePieces": [],
      "seamCutPointsAndLines": [],
      "shapeParentId": null,
      "lines": [
        {
          "id": "8c18e1eb-944b-4482-9fb1-5f465061a374",
          "from": {
            "id": "e46e425c-b680-4208-ad92-6cad3abd555b",
            "x": 0,
            "y": 0,
            "pos": {
              "x": 0,
              "y": 0
            },
            "posSlab": {
              "x": 0,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "lefttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "c74dbd94-ad31-4bb6-9f08-b7b1152a0b36",
            "x": 42,
            "y": 0,
            "pos": {
              "x": 42,
              "y": 0
            },
            "posSlab": {
              "x": 42,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "righttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "c938a14c-0f83-4256-9119-62258168f418",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "0cdb2f4f-0edb-492f-b90f-76cc9d452cab",
          "from": {
            "id": "c74dbd94-ad31-4bb6-9f08-b7b1152a0b36",
            "x": 42,
            "y": 0,
            "pos": {
              "x": 42,
              "y": 0
            },
            "posSlab": {
              "x": 42,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "righttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "dea979ab-baea-4d38-aa56-d3283f2ad084",
            "x": 42,
            "y": 24,
            "pos": {
              "x": 42,
              "y": 24
            },
            "posSlab": {
              "x": 42,
              "y": 24
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "rightbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "fbf09684-64d0-4ddd-84c1-db21766b2e43",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "624e1570-5491-491a-a425-118cce461fe2",
          "from": {
            "id": "dea979ab-baea-4d38-aa56-d3283f2ad084",
            "x": 42,
            "y": 24,
            "pos": {
              "x": 42,
              "y": 24
            },
            "posSlab": {
              "x": 42,
              "y": 24
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "rightbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "a429d8e1-c111-4be5-9204-363a4eee4345",
            "x": 0,
            "y": 24,
            "pos": {
              "x": 0,
              "y": 24
            },
            "posSlab": {
              "x": 0,
              "y": 24
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "leftbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "467d015c-a459-48cb-af42-afda6bc460c1",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "8544fbdc-6bc2-488c-bd13-2a61bc6ae2cb",
          "from": {
            "id": "a429d8e1-c111-4be5-9204-363a4eee4345",
            "x": 0,
            "y": 24,
            "pos": {
              "x": 0,
              "y": 24
            },
            "posSlab": {
              "x": 0,
              "y": 24
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "leftbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "e46e425c-b680-4208-ad92-6cad3abd555b",
            "x": 0,
            "y": 0,
            "pos": {
              "x": 0,
              "y": 0
            },
            "posSlab": {
              "x": 0,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "lefttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "fddaf1fb-0f50-4631-ba7d-5a32d087ca73",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        }
      ],
      "shapeType": "square",
      "rotatedDegrees": 0,
      "rotatedDegreesSlab": 0,
      "partId": "lower_cabinet_boxes",
      "qtCatName": "Kitchen",
      "fromLayout": null,
      "squareFeet": 1,
      "quantity": 1,
      "quantitySubParts": {
        "doors": 0,
        "drawers": 0,
        "cabinetDoorsAndDrawersQuantity": 0,
        "cabinetDoorsSQFT": 9.92,
        "cabinetDoorsLNFT": 0
      },
      "isDisabledInPopup": false,
      "rotateAngleParts": [],
      "isPointsChanged": true,
      "isPositionChanged": true,
      "isResetSlabModePopupWasDisplayed": false,
      "shapeSlab": {
        "absolutePosition": null
      },
      "shapeCabinet": {
        "width": 42,
        "height": 34,
        "depth": 24
      },
      "shapeAbsolute": {
        "absolutePosition": null,
        "intersectionPoints": [],
        "snappedWithShape": 8,
        "snappedShapeGroup": 60
      },
      "shapeParams": {
        "shapeCabinet": true,
        "canSnap": true,
        "width": 42,
        "height": 34,
        "depth": 24,
        "diamondLength": 0,
        "thirdPartyAR3DMetaData": {
          "ActualDisplayedName": [
            "Aspen 5127 SM-B42"
          ],
          "DisplayedName": [
            "Aspen 5127 SM-B42"
          ],
          "Width": [
            "42"
          ],
          "Height": [
            "34"
          ],
          "Depth": [
            "24"
          ],
          "SKU": [
            "SM-B42"
          ],
          "Shape": [
            "SM-B42"
          ],
          "DoorStyle": [
            "Aspen 5127"
          ],
          "Door": [
            "2"
          ],
          "Drawer": [
            "2"
          ],
          "filters": {
            "Style": [
              "Aspen 5127"
            ],
            "Width": [
              "42"
            ],
            "Height": [
              "34"
            ],
            "Depth": [
              "24"
            ]
          }
        },
        "shapeLayout": "rectangle"
      },
      "relatedParentFeatureId": 371311823,
      "slabModeCoreParentId": null,
      "parentPartId": "bottom_cabinet",
      "slabParentPartId": null,
      "shouldUseSlabPricing": false,
      "originalPointsCoords": [
        {
          "x": 0,
          "y": 0,
          "z": 34,
          "id": "e46e425c-b680-4208-ad92-6cad3abd555b"
        },
        {
          "x": 42,
          "y": 0,
          "z": 34,
          "id": "c74dbd94-ad31-4bb6-9f08-b7b1152a0b36"
        },
        {
          "x": 42,
          "y": 24,
          "z": 34,
          "id": "dea979ab-baea-4d38-aa56-d3283f2ad084"
        },
        {
          "x": 0,
          "y": 24,
          "z": 34,
          "id": "a429d8e1-c111-4be5-9204-363a4eee4345"
        }
      ],
      "shouldAddCabinetBox": false,
      "shapeHeight": null
    },
    {
      "pos": {
        "x": -63.66666666666667,
        "y": -35.73333333333334
      },
      "slabPos": {
        "x": -21,
        "y": -106.66666666666667
      },
      "id": 10,
      "featureId": 370760075,
      "features": [
        {
          "featureId": 370760075,
          "partId": "lower_cabinet_boxes"
        },
        {
          "featureId": 371311823,
          "partId": "bottom_cabinet"
        }
      ],
      "colorSet": null,
      "isHidden": false,
      "shapePieces": [],
      "seamCutPointsAndLines": [],
      "shapeParentId": null,
      "lines": [
        {
          "id": "d727b069-c2ab-48d2-9ea9-b05ec82c6588",
          "from": {
            "id": "01b3cedf-69b9-4ec5-bc19-7c934aa6c2ba",
            "x": 0,
            "y": 0,
            "pos": {
              "x": 0,
              "y": 0
            },
            "posSlab": {
              "x": 0,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "lefttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "4f583cba-bcc6-4953-b11f-9bc1fb9e7d37",
            "x": 42,
            "y": 0,
            "pos": {
              "x": 42,
              "y": 0
            },
            "posSlab": {
              "x": 42,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "righttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "af8df081-83e7-44ea-8974-9eb4e9d25e37",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "1d618bc6-9a7f-4fde-8faf-71a8de10b890",
          "from": {
            "id": "4f583cba-bcc6-4953-b11f-9bc1fb9e7d37",
            "x": 42,
            "y": 0,
            "pos": {
              "x": 42,
              "y": 0
            },
            "posSlab": {
              "x": 42,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "righttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "87c1ea7c-06fb-46d6-97f0-c076c6099c8b",
            "x": 42,
            "y": 24,
            "pos": {
              "x": 42,
              "y": 24
            },
            "posSlab": {
              "x": 42,
              "y": 24
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "rightbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "9c2e13e7-5ee2-4118-9440-efe25922effd",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "28cadc5e-29d6-4bd9-80d2-8a23ea02a156",
          "from": {
            "id": "87c1ea7c-06fb-46d6-97f0-c076c6099c8b",
            "x": 42,
            "y": 24,
            "pos": {
              "x": 42,
              "y": 24
            },
            "posSlab": {
              "x": 42,
              "y": 24
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "rightbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "24c51695-94e4-475f-9f56-2c4757300e0b",
            "x": 0,
            "y": 24,
            "pos": {
              "x": 0,
              "y": 24
            },
            "posSlab": {
              "x": 0,
              "y": 24
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "leftbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "cc277364-e377-415c-8fee-01f9896fccd7",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "163b7d53-dc23-4164-8f39-b638887083ba",
          "from": {
            "id": "24c51695-94e4-475f-9f56-2c4757300e0b",
            "x": 0,
            "y": 24,
            "pos": {
              "x": 0,
              "y": 24
            },
            "posSlab": {
              "x": 0,
              "y": 24
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "leftbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "01b3cedf-69b9-4ec5-bc19-7c934aa6c2ba",
            "x": 0,
            "y": 0,
            "pos": {
              "x": 0,
              "y": 0
            },
            "posSlab": {
              "x": 0,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "lefttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "5b859230-28eb-4f9d-8649-d892906537b0",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        }
      ],
      "shapeType": "square",
      "rotatedDegrees": 0,
      "rotatedDegreesSlab": 0,
      "partId": "lower_cabinet_boxes",
      "qtCatName": "Kitchen",
      "fromLayout": null,
      "squareFeet": 1,
      "quantity": 1,
      "quantitySubParts": {
        "doors": 0,
        "drawers": 0,
        "cabinetDoorsAndDrawersQuantity": 0,
        "cabinetDoorsSQFT": 9.92,
        "cabinetDoorsLNFT": 0
      },
      "isDisabledInPopup": false,
      "rotateAngleParts": [],
      "isPointsChanged": true,
      "isPositionChanged": true,
      "isResetSlabModePopupWasDisplayed": false,
      "shapeSlab": {
        "absolutePosition": null
      },
      "shapeCabinet": {
        "width": 42,
        "height": 34,
        "depth": 24
      },
      "shapeAbsolute": {
        "absolutePosition": {
          "x": -62.733333333333306,
          "y": -35.99999999999998
        },
        "intersectionPoints": [],
        "snappedWithShape": 3,
        "snappedShapeGroup": 62
      },
      "shapeParams": {
        "shapeCabinet": true,
        "canSnap": true,
        "width": 42,
        "height": 34,
        "depth": 24,
        "diamondLength": 0,
        "thirdPartyAR3DMetaData": {
          "ActualDisplayedName": [
            "Aspen 5127 SM-B42"
          ],
          "DisplayedName": [
            "Aspen 5127 SM-B42"
          ],
          "Width": [
            "42"
          ],
          "Height": [
            "34"
          ],
          "Depth": [
            "24"
          ],
          "SKU": [
            "SM-B42"
          ],
          "Shape": [
            "SM-B42"
          ],
          "DoorStyle": [
            "Aspen 5127"
          ],
          "Door": [
            "2"
          ],
          "Drawer": [
            "2"
          ],
          "filters": {
            "Style": [
              "Aspen 5127"
            ],
            "Width": [
              "42"
            ],
            "Height": [
              "34"
            ],
            "Depth": [
              "24"
            ]
          }
        },
        "shapeLayout": "rectangle"
      },
      "relatedParentFeatureId": 371311823,
      "slabModeCoreParentId": null,
      "parentPartId": "bottom_cabinet",
      "slabParentPartId": null,
      "shouldUseSlabPricing": false,
      "originalPointsCoords": [
        {
          "x": 0,
          "y": 0,
          "z": 34,
          "id": "01b3cedf-69b9-4ec5-bc19-7c934aa6c2ba"
        },
        {
          "x": 42,
          "y": 0,
          "z": 34,
          "id": "4f583cba-bcc6-4953-b11f-9bc1fb9e7d37"
        },
        {
          "x": 42,
          "y": 24,
          "z": 34,
          "id": "87c1ea7c-06fb-46d6-97f0-c076c6099c8b"
        },
        {
          "x": 0,
          "y": 24,
          "z": 34,
          "id": "24c51695-94e4-475f-9f56-2c4757300e0b"
        }
      ],
      "shouldAddCabinetBox": false,
      "shapeHeight": null
    },
    {
      "pos": {
        "x": 59.266666666666666,
        "y": -155.73333333333343
      },
      "slabPos": {
        "x": -21,
        "y": -106.66666666666667
      },
      "id": 11,
      "featureId": 370760075,
      "features": [
        {
          "featureId": 370760075,
          "partId": "lower_cabinet_boxes"
        },
        {
          "featureId": 371311823,
          "partId": "bottom_cabinet"
        }
      ],
      "colorSet": null,
      "isHidden": false,
      "shapePieces": [],
      "seamCutPointsAndLines": [],
      "shapeParentId": null,
      "lines": [
        {
          "id": "379cf499-c46c-4bb8-9dbb-ccd85746a6d9",
          "from": {
            "id": "3e625b1b-0df8-4763-8078-57074aea19b6",
            "x": 0,
            "y": 0,
            "pos": {
              "x": 0,
              "y": 0
            },
            "posSlab": {
              "x": 0,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "lefttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "1090853e-0100-493d-93c8-dce307d266ea",
            "x": 42,
            "y": 0,
            "pos": {
              "x": 42,
              "y": 0
            },
            "posSlab": {
              "x": 42,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "righttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "760c9c37-ab7c-4a75-aa7a-8179f89b412f",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "a1470c27-d237-474c-be2c-78a8ef1afed5",
          "from": {
            "id": "1090853e-0100-493d-93c8-dce307d266ea",
            "x": 42,
            "y": 0,
            "pos": {
              "x": 42,
              "y": 0
            },
            "posSlab": {
              "x": 42,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "righttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "c0097547-0863-48c4-a96b-bfde1565229c",
            "x": 42,
            "y": 24,
            "pos": {
              "x": 42,
              "y": 24
            },
            "posSlab": {
              "x": 42,
              "y": 24
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "rightbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "d6ef00e0-8dff-44d9-af66-ae257d4531b0",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "0ca2a835-b705-41e3-bca2-cb99ecf1f2cf",
          "from": {
            "id": "c0097547-0863-48c4-a96b-bfde1565229c",
            "x": 42,
            "y": 24,
            "pos": {
              "x": 42,
              "y": 24
            },
            "posSlab": {
              "x": 42,
              "y": 24
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "rightbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "41088237-c63f-4e83-a1c8-c8edef8d699f",
            "x": 0,
            "y": 24,
            "pos": {
              "x": 0,
              "y": 24
            },
            "posSlab": {
              "x": 0,
              "y": 24
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "leftbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "13f478c7-88d1-4e82-b4ef-a1f90b73ee2d",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "09581b95-ce1d-4a49-824c-f4162dabb8ee",
          "from": {
            "id": "41088237-c63f-4e83-a1c8-c8edef8d699f",
            "x": 0,
            "y": 24,
            "pos": {
              "x": 0,
              "y": 24
            },
            "posSlab": {
              "x": 0,
              "y": 24
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "leftbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "3e625b1b-0df8-4763-8078-57074aea19b6",
            "x": 0,
            "y": 0,
            "pos": {
              "x": 0,
              "y": 0
            },
            "posSlab": {
              "x": 0,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "lefttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "8886e3b4-0399-4621-962e-b059fa98810e",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        }
      ],
      "shapeType": "square",
      "rotatedDegrees": 0,
      "rotatedDegreesSlab": 0,
      "partId": "lower_cabinet_boxes",
      "qtCatName": "Kitchen",
      "fromLayout": null,
      "squareFeet": 1,
      "quantity": 1,
      "quantitySubParts": {
        "doors": 0,
        "drawers": 0,
        "cabinetDoorsAndDrawersQuantity": 0,
        "cabinetDoorsSQFT": 9.92,
        "cabinetDoorsLNFT": 0
      },
      "isDisabledInPopup": false,
      "rotateAngleParts": [],
      "isPointsChanged": true,
      "isPositionChanged": true,
      "isResetSlabModePopupWasDisplayed": false,
      "shapeSlab": {
        "absolutePosition": null
      },
      "shapeCabinet": {
        "width": 42,
        "height": 34,
        "depth": 24
      },
      "shapeAbsolute": {
        "absolutePosition": {
          "x": 59.93333333333333,
          "y": -153.86666666666665
        },
        "intersectionPoints": [],
        "snappedWithShape": 12,
        "snappedShapeGroup": 61
      },
      "shapeParams": {
        "shapeCabinet": true,
        "canSnap": true,
        "width": 42,
        "height": 34,
        "depth": 24,
        "diamondLength": 0,
        "thirdPartyAR3DMetaData": {
          "ActualDisplayedName": [
            "Aspen 5127 SM-B42"
          ],
          "DisplayedName": [
            "Aspen 5127 SM-B42"
          ],
          "Width": [
            "42"
          ],
          "Height": [
            "34"
          ],
          "Depth": [
            "24"
          ],
          "SKU": [
            "SM-B42"
          ],
          "Shape": [
            "SM-B42"
          ],
          "DoorStyle": [
            "Aspen 5127"
          ],
          "Door": [
            "2"
          ],
          "Drawer": [
            "2"
          ],
          "filters": {
            "Style": [
              "Aspen 5127"
            ],
            "Width": [
              "42"
            ],
            "Height": [
              "34"
            ],
            "Depth": [
              "24"
            ]
          }
        },
        "shapeLayout": "rectangle"
      },
      "relatedParentFeatureId": 371311823,
      "slabModeCoreParentId": null,
      "parentPartId": "bottom_cabinet",
      "slabParentPartId": null,
      "shouldUseSlabPricing": false,
      "originalPointsCoords": [
        {
          "x": 0,
          "y": 0,
          "z": 34,
          "id": "3e625b1b-0df8-4763-8078-57074aea19b6"
        },
        {
          "x": 42,
          "y": 0,
          "z": 34,
          "id": "1090853e-0100-493d-93c8-dce307d266ea"
        },
        {
          "x": 42,
          "y": 24,
          "z": 34,
          "id": "c0097547-0863-48c4-a96b-bfde1565229c"
        },
        {
          "x": 0,
          "y": 24,
          "z": 34,
          "id": "41088237-c63f-4e83-a1c8-c8edef8d699f"
        }
      ],
      "shouldAddCabinetBox": false,
      "shapeHeight": null
    },
    {
      "pos": {
        "x": 15,
        "y": -154.6666666666668
      },
      "slabPos": {
        "x": -21,
        "y": -106.66666666666667
      },
      "id": 12,
      "featureId": 370760075,
      "features": [
        {
          "featureId": 370760075,
          "partId": "lower_cabinet_boxes"
        },
        {
          "featureId": 371311823,
          "partId": "bottom_cabinet"
        }
      ],
      "colorSet": null,
      "isHidden": false,
      "shapePieces": [],
      "seamCutPointsAndLines": [],
      "shapeParentId": null,
      "lines": [
        {
          "id": "5c5d1b18-9ae3-4f55-8fc1-095181050f44",
          "from": {
            "id": "b6df1f8f-1f92-4723-86ea-3278b90624f7",
            "x": 0,
            "y": 0,
            "pos": {
              "x": 0,
              "y": 0
            },
            "posSlab": {
              "x": 0,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "lefttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "d6538f7a-a5b3-458f-a8a6-173c79d5d773",
            "x": 42,
            "y": 0,
            "pos": {
              "x": 42,
              "y": 0
            },
            "posSlab": {
              "x": 42,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "righttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "bce04f38-226f-48e4-8a6e-b763b8c2c923",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "4c99d655-52a6-4184-bebc-8655388c6744",
          "from": {
            "id": "d6538f7a-a5b3-458f-a8a6-173c79d5d773",
            "x": 42,
            "y": 0,
            "pos": {
              "x": 42,
              "y": 0
            },
            "posSlab": {
              "x": 42,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "righttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "5c562bd9-754a-4511-89fb-1f0f98ec23c3",
            "x": 42,
            "y": 24,
            "pos": {
              "x": 42,
              "y": 24
            },
            "posSlab": {
              "x": 42,
              "y": 24
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "rightbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "da7411a2-6f0b-429f-ae23-40568f90dae3",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "64eef1c6-cb48-46d1-afb4-a8fc7f5f3f1d",
          "from": {
            "id": "5c562bd9-754a-4511-89fb-1f0f98ec23c3",
            "x": 42,
            "y": 24,
            "pos": {
              "x": 42,
              "y": 24
            },
            "posSlab": {
              "x": 42,
              "y": 24
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "rightbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "35de0083-4c8b-4e27-aebb-e7ee8424c458",
            "x": 0,
            "y": 24,
            "pos": {
              "x": 0,
              "y": 24
            },
            "posSlab": {
              "x": 0,
              "y": 24
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "leftbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "8dd9f446-be38-4eeb-a8e8-6283a932d896",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "28a7be72-19df-444e-a16a-076a6a2f25e9",
          "from": {
            "id": "35de0083-4c8b-4e27-aebb-e7ee8424c458",
            "x": 0,
            "y": 24,
            "pos": {
              "x": 0,
              "y": 24
            },
            "posSlab": {
              "x": 0,
              "y": 24
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "leftbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "b6df1f8f-1f92-4723-86ea-3278b90624f7",
            "x": 0,
            "y": 0,
            "pos": {
              "x": 0,
              "y": 0
            },
            "posSlab": {
              "x": 0,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "lefttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "341e8c1d-adc4-495f-b1d4-1d3b63dfa548",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        }
      ],
      "shapeType": "square",
      "rotatedDegrees": 0,
      "rotatedDegreesSlab": 0,
      "partId": "lower_cabinet_boxes",
      "qtCatName": "Kitchen",
      "fromLayout": null,
      "squareFeet": 1,
      "quantity": 1,
      "quantitySubParts": {
        "doors": 0,
        "drawers": 0,
        "cabinetDoorsAndDrawersQuantity": 0,
        "cabinetDoorsSQFT": 9.92,
        "cabinetDoorsLNFT": 0
      },
      "isDisabledInPopup": false,
      "rotateAngleParts": [],
      "isPointsChanged": true,
      "isPositionChanged": true,
      "isResetSlabModePopupWasDisplayed": false,
      "shapeSlab": {
        "absolutePosition": null
      },
      "shapeCabinet": {
        "width": 42,
        "height": 34,
        "depth": 24
      },
      "shapeAbsolute": {
        "absolutePosition": {
          "x": 17.933333333333334,
          "y": -153.86666666666665
        },
        "intersectionPoints": [],
        "snappedWithShape": 11,
        "snappedShapeGroup": 61
      },
      "shapeParams": {
        "shapeCabinet": true,
        "canSnap": true,
        "width": 42,
        "height": 34,
        "depth": 24,
        "diamondLength": 0,
        "thirdPartyAR3DMetaData": {
          "ActualDisplayedName": [
            "Aspen 5127 SM-B42"
          ],
          "DisplayedName": [
            "Aspen 5127 SM-B42"
          ],
          "Width": [
            "42"
          ],
          "Height": [
            "34"
          ],
          "Depth": [
            "24"
          ],
          "SKU": [
            "SM-B42"
          ],
          "Shape": [
            "SM-B42"
          ],
          "DoorStyle": [
            "Aspen 5127"
          ],
          "Door": [
            "2"
          ],
          "Drawer": [
            "2"
          ],
          "filters": {
            "Style": [
              "Aspen 5127"
            ],
            "Width": [
              "42"
            ],
            "Height": [
              "34"
            ],
            "Depth": [
              "24"
            ]
          }
        },
        "shapeLayout": "rectangle"
      },
      "relatedParentFeatureId": 371311823,
      "slabModeCoreParentId": null,
      "parentPartId": "bottom_cabinet",
      "slabParentPartId": null,
      "shouldUseSlabPricing": false,
      "originalPointsCoords": [
        {
          "x": 0,
          "y": 0,
          "z": 34,
          "id": "b6df1f8f-1f92-4723-86ea-3278b90624f7"
        },
        {
          "x": 42,
          "y": 0,
          "z": 34,
          "id": "d6538f7a-a5b3-458f-a8a6-173c79d5d773"
        },
        {
          "x": 42,
          "y": 24,
          "z": 34,
          "id": "5c562bd9-754a-4511-89fb-1f0f98ec23c3"
        },
        {
          "x": 0,
          "y": 24,
          "z": 34,
          "id": "35de0083-4c8b-4e27-aebb-e7ee8424c458"
        }
      ],
      "shouldAddCabinetBox": false,
      "shapeHeight": null
    },
    {
      "pos": {
        "x": -24.2,
        "y": -153.33333333333337
      },
      "slabPos": {
        "x": -21,
        "y": -106.66666666666667
      },
      "id": 13,
      "featureId": 370760075,
      "features": [
        {
          "featureId": 370760075,
          "partId": "lower_cabinet_boxes"
        },
        {
          "featureId": 371311823,
          "partId": "bottom_cabinet"
        }
      ],
      "colorSet": null,
      "isHidden": false,
      "shapePieces": [],
      "seamCutPointsAndLines": [],
      "shapeParentId": null,
      "lines": [
        {
          "id": "86c61155-7955-4add-a3c6-60eec9084bc3",
          "from": {
            "id": "c498ff03-1784-4870-be66-722d8d2f8417",
            "x": 0,
            "y": 0,
            "pos": {
              "x": 0,
              "y": 0
            },
            "posSlab": {
              "x": 0,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "lefttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "3fc84807-452e-4b8f-adf1-c8bfcb6048da",
            "x": 42,
            "y": 0,
            "pos": {
              "x": 42,
              "y": 0
            },
            "posSlab": {
              "x": 42,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "righttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "39163e1b-1f6a-4f97-8302-f076d8e33cee",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "ffdf56a8-348e-4b61-bf9c-9020954a773a",
          "from": {
            "id": "3fc84807-452e-4b8f-adf1-c8bfcb6048da",
            "x": 42,
            "y": 0,
            "pos": {
              "x": 42,
              "y": 0
            },
            "posSlab": {
              "x": 42,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "righttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "4ee7b621-10fe-4523-bda3-cea61413aa13",
            "x": 42,
            "y": 24,
            "pos": {
              "x": 42,
              "y": 24
            },
            "posSlab": {
              "x": 42,
              "y": 24
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "rightbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "47c8bebf-0ac6-42e0-9b83-cb90d6e2dea4",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "627cb9a3-cfb5-470c-b87a-7ea04eb72229",
          "from": {
            "id": "4ee7b621-10fe-4523-bda3-cea61413aa13",
            "x": 42,
            "y": 24,
            "pos": {
              "x": 42,
              "y": 24
            },
            "posSlab": {
              "x": 42,
              "y": 24
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "rightbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "3414da45-363c-46c2-b3e9-392f5169d48e",
            "x": 0,
            "y": 24,
            "pos": {
              "x": 0,
              "y": 24
            },
            "posSlab": {
              "x": 0,
              "y": 24
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "leftbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "f171bd6a-d44c-465e-a6bc-d064ac09b931",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "21b36def-ee23-47c5-b9db-9bf3ba1ec39a",
          "from": {
            "id": "3414da45-363c-46c2-b3e9-392f5169d48e",
            "x": 0,
            "y": 24,
            "pos": {
              "x": 0,
              "y": 24
            },
            "posSlab": {
              "x": 0,
              "y": 24
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "leftbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "c498ff03-1784-4870-be66-722d8d2f8417",
            "x": 0,
            "y": 0,
            "pos": {
              "x": 0,
              "y": 0
            },
            "posSlab": {
              "x": 0,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "lefttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "700af38e-23ec-4bcd-8856-beceb0d2b6d6",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        }
      ],
      "shapeType": "square",
      "rotatedDegrees": 0,
      "rotatedDegreesSlab": 0,
      "partId": "lower_cabinet_boxes",
      "qtCatName": "Kitchen",
      "fromLayout": null,
      "squareFeet": 1,
      "quantity": 1,
      "quantitySubParts": {
        "doors": 0,
        "drawers": 0,
        "cabinetDoorsAndDrawersQuantity": 0,
        "cabinetDoorsSQFT": 9.92,
        "cabinetDoorsLNFT": 0
      },
      "isDisabledInPopup": false,
      "rotateAngleParts": [],
      "isPointsChanged": true,
      "isPositionChanged": true,
      "isResetSlabModePopupWasDisplayed": false,
      "shapeSlab": {
        "absolutePosition": null
      },
      "shapeCabinet": {
        "width": 42,
        "height": 34,
        "depth": 24
      },
      "shapeAbsolute": {
        "absolutePosition": {
          "x": -24.066666666666666,
          "y": -153.86666666666665
        },
        "intersectionPoints": [],
        "snappedWithShape": 12,
        "snappedShapeGroup": 61
      },
      "shapeParams": {
        "shapeCabinet": true,
        "canSnap": true,
        "width": 42,
        "height": 34,
        "depth": 24,
        "diamondLength": 0,
        "thirdPartyAR3DMetaData": {
          "ActualDisplayedName": [
            "Aspen 5127 SM-B42"
          ],
          "DisplayedName": [
            "Aspen 5127 SM-B42"
          ],
          "Width": [
            "42"
          ],
          "Height": [
            "34"
          ],
          "Depth": [
            "24"
          ],
          "SKU": [
            "SM-B42"
          ],
          "Shape": [
            "SM-B42"
          ],
          "DoorStyle": [
            "Aspen 5127"
          ],
          "Door": [
            "2"
          ],
          "Drawer": [
            "2"
          ],
          "filters": {
            "Style": [
              "Aspen 5127"
            ],
            "Width": [
              "42"
            ],
            "Height": [
              "34"
            ],
            "Depth": [
              "24"
            ]
          }
        },
        "shapeLayout": "rectangle"
      },
      "relatedParentFeatureId": 371311823,
      "slabModeCoreParentId": null,
      "parentPartId": "bottom_cabinet",
      "slabParentPartId": null,
      "shouldUseSlabPricing": false,
      "originalPointsCoords": [
        {
          "x": 0,
          "y": 0,
          "z": 34,
          "id": "c498ff03-1784-4870-be66-722d8d2f8417"
        },
        {
          "x": 42,
          "y": 0,
          "z": 34,
          "id": "3fc84807-452e-4b8f-adf1-c8bfcb6048da"
        },
        {
          "x": 42,
          "y": 24,
          "z": 34,
          "id": "4ee7b621-10fe-4523-bda3-cea61413aa13"
        },
        {
          "x": 0,
          "y": 24,
          "z": 34,
          "id": "3414da45-363c-46c2-b3e9-392f5169d48e"
        }
      ],
      "shouldAddCabinetBox": false,
      "shapeHeight": null
    },
    {
      "pos": {
        "x": -66.06666666666665,
        "y": -153.86666666666667
      },
      "slabPos": {
        "x": -21,
        "y": -106.66666666666667
      },
      "id": 14,
      "featureId": 370760075,
      "features": [
        {
          "featureId": 370760075,
          "partId": "lower_cabinet_boxes"
        },
        {
          "featureId": 371311823,
          "partId": "bottom_cabinet"
        }
      ],
      "colorSet": null,
      "isHidden": false,
      "shapePieces": [],
      "seamCutPointsAndLines": [],
      "shapeParentId": null,
      "lines": [
        {
          "id": "4402c4c5-a638-468d-ab4e-0ea95450803f",
          "from": {
            "id": "015ed91a-2772-43b1-97c6-90bacaa6b8cc",
            "x": 0,
            "y": 0,
            "pos": {
              "x": 0,
              "y": 0
            },
            "posSlab": {
              "x": 0,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "lefttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "5cc6e2e9-656a-4bdc-921a-6cb309f9073a",
            "x": 42,
            "y": 0,
            "pos": {
              "x": 42,
              "y": 0
            },
            "posSlab": {
              "x": 42,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "righttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "c745fbad-a1b7-4754-b139-4f226978c3fa",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "a2f85fd6-4a45-454f-8cb5-232e15bb2aaf",
          "from": {
            "id": "5cc6e2e9-656a-4bdc-921a-6cb309f9073a",
            "x": 42,
            "y": 0,
            "pos": {
              "x": 42,
              "y": 0
            },
            "posSlab": {
              "x": 42,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "righttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "66ba7a49-b06f-4efa-a95d-8b62c18b9bb2",
            "x": 42,
            "y": 24,
            "pos": {
              "x": 42,
              "y": 24
            },
            "posSlab": {
              "x": 42,
              "y": 24
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "rightbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "e9e64aff-3ed3-4862-9569-9b019dc312e8",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "0f955639-1909-4d85-9156-55490f37739f",
          "from": {
            "id": "66ba7a49-b06f-4efa-a95d-8b62c18b9bb2",
            "x": 42,
            "y": 24,
            "pos": {
              "x": 42,
              "y": 24
            },
            "posSlab": {
              "x": 42,
              "y": 24
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "rightbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "ef17d82b-4ba9-4fbf-9192-4ce544ca0b89",
            "x": 0,
            "y": 24,
            "pos": {
              "x": 0,
              "y": 24
            },
            "posSlab": {
              "x": 0,
              "y": 24
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "leftbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "25795a12-d606-4b2b-9c6b-1bb20e3034e3",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "69583501-cd01-454b-9349-4179ff4e4d15",
          "from": {
            "id": "ef17d82b-4ba9-4fbf-9192-4ce544ca0b89",
            "x": 0,
            "y": 24,
            "pos": {
              "x": 0,
              "y": 24
            },
            "posSlab": {
              "x": 0,
              "y": 24
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "leftbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "015ed91a-2772-43b1-97c6-90bacaa6b8cc",
            "x": 0,
            "y": 0,
            "pos": {
              "x": 0,
              "y": 0
            },
            "posSlab": {
              "x": 0,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "lefttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "c93a6694-33e5-4cfd-813e-ff0490e2099d",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        }
      ],
      "shapeType": "square",
      "rotatedDegrees": 0,
      "rotatedDegreesSlab": 0,
      "partId": "lower_cabinet_boxes",
      "qtCatName": "Kitchen",
      "fromLayout": null,
      "squareFeet": 1,
      "quantity": 1,
      "quantitySubParts": {
        "doors": 0,
        "drawers": 0,
        "cabinetDoorsAndDrawersQuantity": 0,
        "cabinetDoorsSQFT": 9.92,
        "cabinetDoorsLNFT": 0
      },
      "isDisabledInPopup": false,
      "rotateAngleParts": [],
      "isPointsChanged": true,
      "isPositionChanged": true,
      "isResetSlabModePopupWasDisplayed": false,
      "shapeSlab": {
        "absolutePosition": null
      },
      "shapeCabinet": {
        "width": 42,
        "height": 34,
        "depth": 24
      },
      "shapeAbsolute": {
        "absolutePosition": null,
        "intersectionPoints": [],
        "snappedWithShape": 2,
        "snappedShapeGroup": 61
      },
      "shapeParams": {
        "shapeCabinet": true,
        "canSnap": true,
        "width": 42,
        "height": 34,
        "depth": 24,
        "diamondLength": 0,
        "thirdPartyAR3DMetaData": {
          "ActualDisplayedName": [
            "Aspen 5127 SM-B42"
          ],
          "DisplayedName": [
            "Aspen 5127 SM-B42"
          ],
          "Width": [
            "42"
          ],
          "Height": [
            "34"
          ],
          "Depth": [
            "24"
          ],
          "SKU": [
            "SM-B42"
          ],
          "Shape": [
            "SM-B42"
          ],
          "DoorStyle": [
            "Aspen 5127"
          ],
          "Door": [
            "2"
          ],
          "Drawer": [
            "2"
          ],
          "filters": {
            "Style": [
              "Aspen 5127"
            ],
            "Width": [
              "42"
            ],
            "Height": [
              "34"
            ],
            "Depth": [
              "24"
            ]
          }
        },
        "shapeLayout": "rectangle"
      },
      "relatedParentFeatureId": 371311823,
      "slabModeCoreParentId": null,
      "parentPartId": "bottom_cabinet",
      "slabParentPartId": null,
      "shouldUseSlabPricing": false,
      "originalPointsCoords": [
        {
          "x": 0,
          "y": 0,
          "z": 34,
          "id": "015ed91a-2772-43b1-97c6-90bacaa6b8cc"
        },
        {
          "x": 42,
          "y": 0,
          "z": 34,
          "id": "5cc6e2e9-656a-4bdc-921a-6cb309f9073a"
        },
        {
          "x": 42,
          "y": 24,
          "z": 34,
          "id": "66ba7a49-b06f-4efa-a95d-8b62c18b9bb2"
        },
        {
          "x": 0,
          "y": 24,
          "z": 34,
          "id": "ef17d82b-4ba9-4fbf-9192-4ce544ca0b89"
        }
      ],
      "shouldAddCabinetBox": false,
      "shapeHeight": null
    }
  ],
  "manualCalculate": false,
  "controllers": {
    "walls": [],
    "snappedShapeGroups": [
      0,
      1,
      2,
      3,
      4,
      5,
      6,
      7,
      8,
      9,
      10,
      11,
      12,
      13,
      14,
      15,
      16,
      17,
      18,
      19,
      20,
      21,
      22,
      23,
      24,
      25,
      26,
      27,
      28,
      29,
      30,
      31,
      32,
      33,
      34,
      35,
      36,
      37,
      38,
      39,
      40,
      41,
      42,
      43,
      44,
      45,
      46,
      47,
      48,
      49,
      50,
      51,
      52,
      53,
      54,
      55,
      56,
      57,
      58,
      59,
      60,
      61,
      62
    ],
    "handles": [],
    "hinge": []
  },
  "underlayment": []
}

export const CABINET_SET4 = {
  "bumpouts": [],
  "canvasImage": "",
  "sqFtSlabImage": "",
  "sqFtSlabCalcImage": "",
  "sqftApplianceImages": "",
  "images3D": "",
  "slabImages": [],
  "measureUnit": "Imperial",
  "sinks": [],
  "radii": [],
  "corners": [],
  "totalInches": 8320.738232835298,
  "shapeLength": 10,
  "objIds": 10,
  "removedFeatures": [],
  "textBoxes": [],
  "slabAdditionalShapesList": [],
  "slabImagesTotalArea": [],
  "squareFeet": 58,
  "countertops": [
    {
      "pos": {
        "x": -6.103603603603609,
        "y": 26.689189189189165
      },
      "slabPos": {
        "x": -6.103603603603609,
        "y": 26.689189189189165
      },
      "id": 1,
      "featureId": 382994644,
      "features": [
        {
          "featureId": 382994644,
          "partId": "lower_cabinet_boxes"
        },
        {
          "featureId": 526185013,
          "partId": "bottom_cabinet"
        }
      ],
      "colorSet": null,
      "isHidden": false,
      "shapePieces": [],
      "seamCutPointsAndLines": [],
      "shapeParentId": null,
      "lines": [
        {
          "id": "f2e4c7b2-84af-43d7-ab17-746c8640381d",
          "from": {
            "id": "1415b375-abbd-4215-b3e9-5749b73e5d2f",
            "x": 0,
            "y": 0,
            "pos": {
              "x": 0,
              "y": 0
            },
            "posSlab": {
              "x": 0,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "lefttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "243c146e-af89-4c0f-9e18-38792b22ae4d",
            "x": 45,
            "y": 0,
            "pos": {
              "x": 45,
              "y": 0
            },
            "posSlab": {
              "x": 45,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "righttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "f83f1d6c-3625-4433-9932-ebc73d8ea5b2",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "05fc4459-7981-464d-886c-bd29f3e6c255",
          "from": {
            "id": "243c146e-af89-4c0f-9e18-38792b22ae4d",
            "x": 45,
            "y": 0,
            "pos": {
              "x": 45,
              "y": 0
            },
            "posSlab": {
              "x": 45,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "righttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "791d06a8-3203-4336-a1ed-79f950d4d4c8",
            "x": 45,
            "y": 24,
            "pos": {
              "x": 45,
              "y": 24
            },
            "posSlab": {
              "x": 45,
              "y": 24
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "rightbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "dffea30b-492a-46b4-8066-acf64128b285",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "02853a25-e322-42da-98e0-d8b3c593f0ed",
          "from": {
            "id": "791d06a8-3203-4336-a1ed-79f950d4d4c8",
            "x": 45,
            "y": 24,
            "pos": {
              "x": 45,
              "y": 24
            },
            "posSlab": {
              "x": 45,
              "y": 24
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "rightbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "6161ef15-4264-4d1a-9274-8130672830bc",
            "x": 24,
            "y": 24,
            "pos": {
              "x": 24,
              "y": 24
            },
            "posSlab": {
              "x": 24,
              "y": 24
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "rightbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "04a77d37-c76f-48e1-bb15-ad315ac9bdbd",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "12444ac3-ff12-4601-9968-cca4cebd061a",
          "from": {
            "id": "6161ef15-4264-4d1a-9274-8130672830bc",
            "x": 24,
            "y": 24,
            "pos": {
              "x": 24,
              "y": 24
            },
            "posSlab": {
              "x": 24,
              "y": 24
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "rightbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "6e211d92-5fc4-4cf6-a571-3cf1e05a7d68",
            "x": 24,
            "y": 45,
            "pos": {
              "x": 24,
              "y": 45
            },
            "posSlab": {
              "x": 24,
              "y": 45
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "rightbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "b08186fe-1c46-43c9-85c2-9efb795c9dfa",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "14e2e157-2f91-432f-99d6-0192b56f1eb2",
          "from": {
            "id": "6e211d92-5fc4-4cf6-a571-3cf1e05a7d68",
            "x": 24,
            "y": 45,
            "pos": {
              "x": 24,
              "y": 45
            },
            "posSlab": {
              "x": 24,
              "y": 45
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "rightbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "6b59aa48-942f-41c5-8a4f-0fbd25d0b321",
            "x": 0,
            "y": 45,
            "pos": {
              "x": 0,
              "y": 45
            },
            "posSlab": {
              "x": 0,
              "y": 45
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "leftbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "fd505442-f79b-47a3-82b1-d8e9d3c43b75",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "c570039a-cc87-4bc7-b646-92ca4a3fc7ab",
          "from": {
            "id": "6b59aa48-942f-41c5-8a4f-0fbd25d0b321",
            "x": 0,
            "y": 45,
            "pos": {
              "x": 0,
              "y": 45
            },
            "posSlab": {
              "x": 0,
              "y": 45
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "leftbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "1415b375-abbd-4215-b3e9-5749b73e5d2f",
            "x": 0,
            "y": 0,
            "pos": {
              "x": 0,
              "y": 0
            },
            "posSlab": {
              "x": 0,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "lefttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "05b00b54-791c-4bce-8617-56184eb72581",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        }
      ],
      "shapeType": "square",
      "rotatedDegrees": 0,
      "rotatedDegreesSlab": 0,
      "partId": "lower_cabinet_boxes",
      "qtCatName": "Kitchen",
      "fromLayout": null,
      "squareFeet": 1,
      "quantity": 1,
      "quantitySubParts": {
        "doors": 2,
        "drawers": 0,
        "cabinetDoorsAndDrawersQuantity": 2,
        "cabinetDoorsSQFT": 0,
        "cabinetDoorsLNFT": 0
      },
      "isDisabledInPopup": false,
      "rotateAngleParts": [],
      "isPointsChanged": true,
      "isPositionChanged": true,
      "isResetSlabModePopupWasDisplayed": false,
      "shapeSlab": {
        "absolutePosition": null
      },
      "shapeCabinet": {
        "width": 45,
        "height": 34,
        "depth": 45
      },
      "shapeAbsolute": {
        "absolutePosition": null,
        "intersectionPoints": [],
        "snappedWithShape": 4,
        "snappedShapeGroup": 24
      },
      "shapeParams": {
        "shapeCabinet": true,
        "canSnap": true,
        "width": 45,
        "height": 34,
        "depth": 24,
        "diamondLength": 0,
        "thirdPartyAR3DMetaData": {
          "ActualDisplayedName": [
            "Bryant BBC45-48FHLRB"
          ],
          "DisplayedName": [
            "Bryant BBC45-48FHLRB"
          ],
          "Width": [
            "45"
          ],
          "Height": [
            "34"
          ],
          "Depth": [
            "24"
          ],
          "SKU": [
            "BBC45-48FHLRB"
          ],
          "Shape": [
            "BBC45-48FHLRB"
          ],
          "DoorStyle": [
            "Bryant"
          ],
          "Door": [
            "2"
          ],
          "Drawer": [
            "0"
          ],
          "SpecialShape": [
            "LowerLCorner"
          ],
          "filters": {
            "Style": [
              "Bryant"
            ],
            "Width": [
              "45"
            ],
            "Height": [
              "34"
            ],
            "Depth": [
              "24"
            ]
          }
        },
        "shapeLayout": "LowerLCorner"
      },
      "relatedParentFeatureId": 526185013,
      "slabModeCoreParentId": null,
      "parentPartId": "bottom_cabinet",
      "slabParentPartId": null,
      "shouldUseSlabPricing": false,
      "originalPointsCoords": [
        {
          "x": 0,
          "y": 0,
          "z": 34,
          "id": "1415b375-abbd-4215-b3e9-5749b73e5d2f"
        },
        {
          "x": 45,
          "y": 0,
          "z": 34,
          "id": "243c146e-af89-4c0f-9e18-38792b22ae4d"
        },
        {
          "x": 45,
          "y": 24,
          "z": 34,
          "id": "791d06a8-3203-4336-a1ed-79f950d4d4c8"
        },
        {
          "x": 24,
          "y": 24,
          "z": 34,
          "id": "6161ef15-4264-4d1a-9274-8130672830bc"
        },
        {
          "x": 24,
          "y": 45,
          "z": 34,
          "id": "6e211d92-5fc4-4cf6-a571-3cf1e05a7d68"
        },
        {
          "x": 0,
          "y": 45,
          "z": 34,
          "id": "6b59aa48-942f-41c5-8a4f-0fbd25d0b321"
        }
      ],
      "shouldAddCabinetBox": false,
      "shapeHeight": null
    },
    {
      "pos": {
        "x": 83.3963963963964,
        "y": 28.855855855855832
      },
      "slabPos": {
        "x": -4.603603603603609,
        "y": 37.189189189189165
      },
      "id": 2,
      "featureId": 382499177,
      "features": [
        {
          "featureId": 382499177,
          "partId": "lower_cabinet_boxes"
        },
        {
          "featureId": 526185013,
          "partId": "bottom_cabinet"
        }
      ],
      "colorSet": null,
      "isHidden": false,
      "shapePieces": [],
      "seamCutPointsAndLines": [],
      "shapeParentId": null,
      "lines": [
        {
          "id": "c44d4f3c-63a0-4375-9fca-5e6995b4fb77",
          "from": {
            "id": "f5345b3b-ee34-4558-85f7-8e54a38aef29",
            "x": 0,
            "y": 0,
            "pos": {
              "x": 0,
              "y": 0
            },
            "posSlab": {
              "x": 0,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "lefttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "08c7b4fc-7472-43d7-b3cf-57b28854c78e",
            "x": 42,
            "y": 0,
            "pos": {
              "x": 42,
              "y": 0
            },
            "posSlab": {
              "x": 42,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "righttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "7eff228f-5d14-4664-945c-13f88d02b0bc",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "7a924d17-7e49-485f-9626-586a35757ecd",
          "from": {
            "id": "08c7b4fc-7472-43d7-b3cf-57b28854c78e",
            "x": 42,
            "y": 0,
            "pos": {
              "x": 42,
              "y": 0
            },
            "posSlab": {
              "x": 42,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "righttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "e69ec81f-e6c4-48dc-a40a-b6f5bf00937c",
            "x": 42,
            "y": 24,
            "pos": {
              "x": 42,
              "y": 24
            },
            "posSlab": {
              "x": 42,
              "y": 24
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "rightbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "5b815685-0af2-4340-9bf9-d6bfbc8ff84b",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "e363999d-fb0e-4627-aead-c6f01e07ef8f",
          "from": {
            "id": "e69ec81f-e6c4-48dc-a40a-b6f5bf00937c",
            "x": 42,
            "y": 24,
            "pos": {
              "x": 42,
              "y": 24
            },
            "posSlab": {
              "x": 42,
              "y": 24
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "rightbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "e31155b1-f967-4042-8017-1fd3bf271460",
            "x": 0,
            "y": 24,
            "pos": {
              "x": 0,
              "y": 24
            },
            "posSlab": {
              "x": 0,
              "y": 24
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "leftbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "81c9213e-22ec-4c2e-8538-0aef6f49fd5e",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "9805fdf5-d82a-4e31-9884-24ef659993b6",
          "from": {
            "id": "e31155b1-f967-4042-8017-1fd3bf271460",
            "x": 0,
            "y": 24,
            "pos": {
              "x": 0,
              "y": 24
            },
            "posSlab": {
              "x": 0,
              "y": 24
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "leftbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "f5345b3b-ee34-4558-85f7-8e54a38aef29",
            "x": 0,
            "y": 0,
            "pos": {
              "x": 0,
              "y": 0
            },
            "posSlab": {
              "x": 0,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "lefttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "6b68a166-8da5-4662-b7b5-cad4d04cdc71",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        }
      ],
      "shapeType": "square",
      "rotatedDegrees": 0,
      "rotatedDegreesSlab": 0,
      "partId": "lower_cabinet_boxes",
      "qtCatName": "Kitchen",
      "fromLayout": null,
      "squareFeet": 1,
      "quantity": 1,
      "quantitySubParts": {
        "doors": 2,
        "drawers": 2,
        "cabinetDoorsAndDrawersQuantity": 4,
        "cabinetDoorsSQFT": 0,
        "cabinetDoorsLNFT": 0
      },
      "isDisabledInPopup": false,
      "rotateAngleParts": [],
      "isPointsChanged": true,
      "isPositionChanged": true,
      "isResetSlabModePopupWasDisplayed": false,
      "shapeSlab": {
        "absolutePosition": null
      },
      "shapeCabinet": {
        "width": 42,
        "height": 34,
        "depth": 24
      },
      "shapeAbsolute": {
        "absolutePosition": {
          "x": 80.8963963963964,
          "y": 26.689189189189165
        },
        "intersectionPoints": [],
        "snappedWithShape": 4,
        "snappedShapeGroup": 24
      },
      "shapeParams": {
        "shapeCabinet": true,
        "canSnap": true,
        "width": 42,
        "height": 34,
        "depth": 24,
        "diamondLength": 0,
        "thirdPartyAR3DMetaData": {
          "ActualDisplayedName": [
            "Bryant SM-B42"
          ],
          "DisplayedName": [
            "Bryant SM-B42"
          ],
          "Width": [
            "42"
          ],
          "Height": [
            "34"
          ],
          "Depth": [
            "24"
          ],
          "SKU": [
            "SM-B42"
          ],
          "Shape": [
            "SM-B42"
          ],
          "DoorStyle": [
            "Bryant"
          ],
          "Door": [
            "2"
          ],
          "Drawer": [
            "2"
          ],
          "filters": {
            "Style": [
              "Bryant"
            ],
            "Width": [
              "42"
            ],
            "Height": [
              "34"
            ],
            "Depth": [
              "24"
            ]
          }
        },
        "shapeLayout": "rectangle"
      },
      "relatedParentFeatureId": 526185013,
      "slabModeCoreParentId": null,
      "parentPartId": "bottom_cabinet",
      "slabParentPartId": null,
      "shouldUseSlabPricing": false,
      "originalPointsCoords": [
        {
          "x": 0,
          "y": 0,
          "z": 34,
          "id": "f5345b3b-ee34-4558-85f7-8e54a38aef29"
        },
        {
          "x": 42,
          "y": 0,
          "z": 34,
          "id": "08c7b4fc-7472-43d7-b3cf-57b28854c78e"
        },
        {
          "x": 42,
          "y": 24,
          "z": 34,
          "id": "e69ec81f-e6c4-48dc-a40a-b6f5bf00937c"
        },
        {
          "x": 0,
          "y": 24,
          "z": 34,
          "id": "e31155b1-f967-4042-8017-1fd3bf271460"
        }
      ],
      "shouldAddCabinetBox": false,
      "shapeHeight": null
    },
    {
      "pos": {
        "x": -15.10360360360361,
        "y": 80.68918918918916
      },
      "slabPos": {
        "x": -4.603603603603609,
        "y": 37.189189189189165
      },
      "id": 3,
      "featureId": 382499177,
      "features": [
        {
          "featureId": 382499177,
          "partId": "lower_cabinet_boxes"
        },
        {
          "featureId": 526185013,
          "partId": "bottom_cabinet"
        }
      ],
      "colorSet": null,
      "isHidden": false,
      "shapePieces": [],
      "seamCutPointsAndLines": [],
      "shapeParentId": null,
      "lines": [
        {
          "id": "165960c4-2c92-4896-93e7-06e48c9f04c8",
          "from": {
            "id": "9ef4552e-0f22-4cf5-bb4b-bd9a82f54c03",
            "x": 9,
            "y": 33,
            "pos": {
              "x": 9,
              "y": 33
            },
            "posSlab": {
              "x": 0,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "leftbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "a0579193-4329-4cf9-bc66-731daefe4aad",
            "x": 9,
            "y": -9,
            "pos": {
              "x": 9,
              "y": -9
            },
            "posSlab": {
              "x": 42,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "lefttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "cc6a953c-6077-4d19-a4bc-0bdfa7c3813f",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "70a4aae2-b936-4411-8a2a-fc9eb758d31f",
          "from": {
            "id": "a0579193-4329-4cf9-bc66-731daefe4aad",
            "x": 9,
            "y": -9,
            "pos": {
              "x": 9,
              "y": -9
            },
            "posSlab": {
              "x": 42,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "lefttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "d26a05e9-2c50-4b41-bc03-65c90b3619a5",
            "x": 33,
            "y": -9,
            "pos": {
              "x": 33,
              "y": -9
            },
            "posSlab": {
              "x": 42,
              "y": 24
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "righttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "4458c4b3-ea91-495b-9d02-7f83da73da0e",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "2bf979f2-51a4-48a9-8735-fe50548b2dbd",
          "from": {
            "id": "d26a05e9-2c50-4b41-bc03-65c90b3619a5",
            "x": 33,
            "y": -9,
            "pos": {
              "x": 33,
              "y": -9
            },
            "posSlab": {
              "x": 42,
              "y": 24
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "righttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "94e21842-2e66-4bac-ac94-e80bb93295e8",
            "x": 33,
            "y": 33,
            "pos": {
              "x": 33,
              "y": 33
            },
            "posSlab": {
              "x": 0,
              "y": 24
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "rightbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "0a309a2b-ac3f-4983-b7cf-3f4d9e3a8e20",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "d93a1304-5f3e-46e1-b300-d77e08a893ac",
          "from": {
            "id": "94e21842-2e66-4bac-ac94-e80bb93295e8",
            "x": 33,
            "y": 33,
            "pos": {
              "x": 33,
              "y": 33
            },
            "posSlab": {
              "x": 0,
              "y": 24
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "rightbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "9ef4552e-0f22-4cf5-bb4b-bd9a82f54c03",
            "x": 9,
            "y": 33,
            "pos": {
              "x": 9,
              "y": 33
            },
            "posSlab": {
              "x": 0,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "leftbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "84a54d5b-11b5-4ef1-9f34-ddcb37c104c6",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        }
      ],
      "shapeType": "square",
      "rotatedDegrees": 90,
      "rotatedDegreesSlab": 0,
      "partId": "lower_cabinet_boxes",
      "qtCatName": "Kitchen",
      "fromLayout": null,
      "squareFeet": 1,
      "quantity": 1,
      "quantitySubParts": {
        "doors": 2,
        "drawers": 2,
        "cabinetDoorsAndDrawersQuantity": 4,
        "cabinetDoorsSQFT": 0,
        "cabinetDoorsLNFT": 0
      },
      "isDisabledInPopup": false,
      "rotateAngleParts": [],
      "isPointsChanged": true,
      "isPositionChanged": true,
      "isResetSlabModePopupWasDisplayed": false,
      "shapeSlab": {
        "absolutePosition": null
      },
      "shapeCabinet": {
        "width": 24,
        "height": 34,
        "depth": 42
      },
      "shapeAbsolute": {
        "absolutePosition": {
          "x": -15.10360360360361,
          "y": 80.68918918918916
        },
        "intersectionPoints": [],
        "snappedWithShape": 1,
        "snappedShapeGroup": 24
      },
      "shapeParams": {
        "shapeCabinet": true,
        "canSnap": true,
        "width": 42,
        "height": 34,
        "depth": 24,
        "diamondLength": 0,
        "thirdPartyAR3DMetaData": {
          "ActualDisplayedName": [
            "Bryant SM-B42"
          ],
          "DisplayedName": [
            "Bryant SM-B42"
          ],
          "Width": [
            "42"
          ],
          "Height": [
            "34"
          ],
          "Depth": [
            "24"
          ],
          "SKU": [
            "SM-B42"
          ],
          "Shape": [
            "SM-B42"
          ],
          "DoorStyle": [
            "Bryant"
          ],
          "Door": [
            "2"
          ],
          "Drawer": [
            "2"
          ],
          "filters": {
            "Style": [
              "Bryant"
            ],
            "Width": [
              "42"
            ],
            "Height": [
              "34"
            ],
            "Depth": [
              "24"
            ]
          }
        },
        "shapeLayout": "rectangle"
      },
      "relatedParentFeatureId": 526185013,
      "slabModeCoreParentId": null,
      "parentPartId": "bottom_cabinet",
      "slabParentPartId": null,
      "shouldUseSlabPricing": false,
      "originalPointsCoords": [
        {
          "x": 9,
          "y": 33,
          "z": 34,
          "id": "9ef4552e-0f22-4cf5-bb4b-bd9a82f54c03"
        },
        {
          "x": 9,
          "y": -9,
          "z": 34,
          "id": "a0579193-4329-4cf9-bc66-731daefe4aad"
        },
        {
          "x": 33,
          "y": -9,
          "z": 34,
          "id": "d26a05e9-2c50-4b41-bc03-65c90b3619a5"
        },
        {
          "x": 33,
          "y": 33,
          "z": 34,
          "id": "94e21842-2e66-4bac-ac94-e80bb93295e8"
        }
      ],
      "shouldAddCabinetBox": false,
      "shapeHeight": null
    },
    {
      "pos": {
        "x": 38.41441441441436,
        "y": 25.495495495495472
      },
      "slabPos": {
        "x": -4.603603603603609,
        "y": 37.189189189189165
      },
      "id": 4,
      "featureId": 382499177,
      "features": [
        {
          "featureId": 382499177,
          "partId": "lower_cabinet_boxes"
        },
        {
          "featureId": 526185013,
          "partId": "bottom_cabinet"
        }
      ],
      "colorSet": null,
      "isHidden": false,
      "shapePieces": [],
      "seamCutPointsAndLines": [],
      "shapeParentId": null,
      "lines": [
        {
          "id": "38b26dce-3cc4-488a-b3a6-9d0077abe6b8",
          "from": {
            "id": "44adcf7e-e03c-4078-9b85-8059a5972a53",
            "x": 0,
            "y": 0,
            "pos": {
              "x": 0,
              "y": 0
            },
            "posSlab": {
              "x": 0,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "lefttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "fd92d491-6260-49fa-91f8-3fecb202b14f",
            "x": 42,
            "y": 0,
            "pos": {
              "x": 42,
              "y": 0
            },
            "posSlab": {
              "x": 42,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "righttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "81ed1f84-3034-4f92-ab44-d0326ebdb105",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "e7b37c60-3239-4588-9902-ca8008b36a07",
          "from": {
            "id": "fd92d491-6260-49fa-91f8-3fecb202b14f",
            "x": 42,
            "y": 0,
            "pos": {
              "x": 42,
              "y": 0
            },
            "posSlab": {
              "x": 42,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "righttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "448ec928-feb9-43bf-8e3a-d9076bbc827f",
            "x": 42,
            "y": 24,
            "pos": {
              "x": 42,
              "y": 24
            },
            "posSlab": {
              "x": 42,
              "y": 24
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "rightbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "213cccd5-7889-49b2-b340-b0f9549afed5",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "ee9a5da1-b892-4b00-916e-5ad20ff6b100",
          "from": {
            "id": "448ec928-feb9-43bf-8e3a-d9076bbc827f",
            "x": 42,
            "y": 24,
            "pos": {
              "x": 42,
              "y": 24
            },
            "posSlab": {
              "x": 42,
              "y": 24
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "rightbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "da44ece8-1c4e-4ec6-8f4b-a42a9670402f",
            "x": 0,
            "y": 24,
            "pos": {
              "x": 0,
              "y": 24
            },
            "posSlab": {
              "x": 0,
              "y": 24
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "leftbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "a54f74dd-78bb-41af-9aee-e72b3a2a5dfc",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "1448cbe8-c171-4d1b-9708-e5f1dab73a75",
          "from": {
            "id": "da44ece8-1c4e-4ec6-8f4b-a42a9670402f",
            "x": 0,
            "y": 24,
            "pos": {
              "x": 0,
              "y": 24
            },
            "posSlab": {
              "x": 0,
              "y": 24
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "leftbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "44adcf7e-e03c-4078-9b85-8059a5972a53",
            "x": 0,
            "y": 0,
            "pos": {
              "x": 0,
              "y": 0
            },
            "posSlab": {
              "x": 0,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "lefttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "404ff619-a8eb-476f-ab19-ccab32b69ebc",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        }
      ],
      "shapeType": "square",
      "rotatedDegrees": 0,
      "rotatedDegreesSlab": 0,
      "partId": "lower_cabinet_boxes",
      "qtCatName": "Kitchen",
      "fromLayout": null,
      "squareFeet": 1,
      "quantity": 1,
      "quantitySubParts": {
        "doors": 2,
        "drawers": 2,
        "cabinetDoorsAndDrawersQuantity": 4,
        "cabinetDoorsSQFT": 0,
        "cabinetDoorsLNFT": 0
      },
      "isDisabledInPopup": false,
      "rotateAngleParts": [],
      "isPointsChanged": true,
      "isPositionChanged": true,
      "isResetSlabModePopupWasDisplayed": false,
      "shapeSlab": {
        "absolutePosition": null
      },
      "shapeCabinet": {
        "width": 42,
        "height": 34,
        "depth": 24
      },
      "shapeAbsolute": {
        "absolutePosition": {
          "x": 38.896396396396376,
          "y": 26.68918918918917
        },
        "intersectionPoints": [],
        "snappedWithShape": 2,
        "snappedShapeGroup": 24
      },
      "shapeParams": {
        "shapeCabinet": true,
        "canSnap": true,
        "width": 42,
        "height": 34,
        "depth": 24,
        "diamondLength": 0,
        "thirdPartyAR3DMetaData": {
          "ActualDisplayedName": [
            "Bryant SM-B42"
          ],
          "DisplayedName": [
            "Bryant SM-B42"
          ],
          "Width": [
            "42"
          ],
          "Height": [
            "34"
          ],
          "Depth": [
            "24"
          ],
          "SKU": [
            "SM-B42"
          ],
          "Shape": [
            "SM-B42"
          ],
          "DoorStyle": [
            "Bryant"
          ],
          "Door": [
            "2"
          ],
          "Drawer": [
            "2"
          ],
          "filters": {
            "Style": [
              "Bryant"
            ],
            "Width": [
              "42"
            ],
            "Height": [
              "34"
            ],
            "Depth": [
              "24"
            ]
          }
        },
        "shapeLayout": "rectangle"
      },
      "relatedParentFeatureId": 526185013,
      "slabModeCoreParentId": null,
      "parentPartId": "bottom_cabinet",
      "slabParentPartId": null,
      "shouldUseSlabPricing": false,
      "originalPointsCoords": [
        {
          "x": 0,
          "y": 0,
          "z": 34,
          "id": "44adcf7e-e03c-4078-9b85-8059a5972a53"
        },
        {
          "x": 42,
          "y": 0,
          "z": 34,
          "id": "fd92d491-6260-49fa-91f8-3fecb202b14f"
        },
        {
          "x": 42,
          "y": 24,
          "z": 34,
          "id": "448ec928-feb9-43bf-8e3a-d9076bbc827f"
        },
        {
          "x": 0,
          "y": 24,
          "z": 34,
          "id": "da44ece8-1c4e-4ec6-8f4b-a42a9670402f"
        }
      ],
      "shouldAddCabinetBox": false,
      "shapeHeight": null
    },
    {
      "pos": {
        "x": -18.10360360360361,
        "y": 101.68918918918916
      },
      "slabPos": {
        "x": 44.66666666666668,
        "y": 90.00000000000001
      },
      "id": 5,
      "featureId": 382499168,
      "features": [
        {
          "featureId": 382499168,
          "partId": "upper_cabinet_boxes"
        },
        {
          "featureId": 526185040,
          "partId": "top_cabinet"
        }
      ],
      "colorSet": null,
      "isHidden": false,
      "shapePieces": [],
      "seamCutPointsAndLines": [],
      "shapeParentId": null,
      "lines": [
        {
          "id": "d3912f65-1bc3-46fc-af02-d2e84f569cb0",
          "from": {
            "id": "3f2c46c1-a1e9-4f66-a582-3e35879c84e5",
            "x": 12,
            "y": 24,
            "pos": {
              "x": 12,
              "y": 24
            },
            "posSlab": {
              "x": 0,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "leftbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "b6b87dc1-147b-4073-b7c1-b7dc27934d2e",
            "x": 12,
            "y": -12,
            "pos": {
              "x": 12,
              "y": -12
            },
            "posSlab": {
              "x": 36,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "lefttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "059a6368-b8bf-44a0-b6c3-1e28fc0c63f5",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "1d9b203c-47ae-4f1c-bd79-76654e51a945",
          "from": {
            "id": "b6b87dc1-147b-4073-b7c1-b7dc27934d2e",
            "x": 12,
            "y": -12,
            "pos": {
              "x": 12,
              "y": -12
            },
            "posSlab": {
              "x": 36,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "lefttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "45b86a09-38d8-4cbe-bff5-58726cdc4e48",
            "x": 24,
            "y": -12,
            "pos": {
              "x": 24,
              "y": -12
            },
            "posSlab": {
              "x": 36,
              "y": 12
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "righttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "0ed5c322-4679-47a1-87d6-270620e48f27",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "f1d9b483-75dd-4277-98a1-03d1fae1591a",
          "from": {
            "id": "45b86a09-38d8-4cbe-bff5-58726cdc4e48",
            "x": 24,
            "y": -12,
            "pos": {
              "x": 24,
              "y": -12
            },
            "posSlab": {
              "x": 36,
              "y": 12
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "righttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "a748b138-df4c-416b-8712-81947d6fe86d",
            "x": 24,
            "y": 24,
            "pos": {
              "x": 24,
              "y": 24
            },
            "posSlab": {
              "x": 0,
              "y": 12
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "rightbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "3f7a5aa4-d03b-4d12-9612-2d3efe1ca927",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "71ca89b3-1d14-45f8-b707-d86eddd14a4d",
          "from": {
            "id": "a748b138-df4c-416b-8712-81947d6fe86d",
            "x": 24,
            "y": 24,
            "pos": {
              "x": 24,
              "y": 24
            },
            "posSlab": {
              "x": 0,
              "y": 12
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "rightbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "3f2c46c1-a1e9-4f66-a582-3e35879c84e5",
            "x": 12,
            "y": 24,
            "pos": {
              "x": 12,
              "y": 24
            },
            "posSlab": {
              "x": 0,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "leftbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "a52f8d15-70bf-48ea-a26b-62988a9480a1",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        }
      ],
      "shapeType": "square",
      "rotatedDegrees": 90,
      "rotatedDegreesSlab": 0,
      "partId": "upper_cabinet_boxes",
      "qtCatName": "Kitchen",
      "fromLayout": null,
      "squareFeet": 1,
      "quantity": 1,
      "quantitySubParts": {
        "doors": 2,
        "drawers": 0,
        "cabinetDoorsAndDrawersQuantity": 2,
        "cabinetDoorsSQFT": 0,
        "cabinetDoorsLNFT": 0
      },
      "isDisabledInPopup": false,
      "rotateAngleParts": [],
      "isPointsChanged": true,
      "isPositionChanged": true,
      "isResetSlabModePopupWasDisplayed": false,
      "shapeSlab": {
        "absolutePosition": null
      },
      "shapeCabinet": {
        "width": 12,
        "height": 42,
        "depth": 36
      },
      "shapeAbsolute": {
        "absolutePosition": {
          "x": -18.10360360360361,
          "y": 101.68918918918916
        },
        "intersectionPoints": [],
        "snappedWithShape": 8,
        "snappedShapeGroup": 24
      },
      "shapeParams": {
        "shapeCabinet": true,
        "canSnap": true,
        "width": 36,
        "height": 42,
        "depth": 12,
        "diamondLength": 0,
        "thirdPartyAR3DMetaData": {
          "ActualDisplayedName": [
            "Bryant SM-W3642"
          ],
          "DisplayedName": [
            "Bryant SM-W3642"
          ],
          "Width": [
            "36"
          ],
          "Height": [
            "42"
          ],
          "Depth": [
            "12"
          ],
          "SKU": [
            "SM-W3642"
          ],
          "Shape": [
            "SM-W3642"
          ],
          "DoorStyle": [
            "Bryant"
          ],
          "Door": [
            "2"
          ],
          "Drawer": [
            "0"
          ],
          "filters": {
            "Style": [
              "Bryant"
            ],
            "Width": [
              "36"
            ],
            "Height": [
              "42"
            ],
            "Depth": [
              "12"
            ]
          }
        },
        "shapeLayout": "rectangle"
      },
      "relatedParentFeatureId": 526185040,
      "slabModeCoreParentId": null,
      "parentPartId": "top_cabinet",
      "slabParentPartId": null,
      "shouldUseSlabPricing": false,
      "originalPointsCoords": [
        {
          "x": 12,
          "y": 24,
          "z": 42,
          "id": "3f2c46c1-a1e9-4f66-a582-3e35879c84e5"
        },
        {
          "x": 12,
          "y": -12,
          "z": 42,
          "id": "b6b87dc1-147b-4073-b7c1-b7dc27934d2e"
        },
        {
          "x": 24,
          "y": -12,
          "z": 42,
          "id": "45b86a09-38d8-4cbe-bff5-58726cdc4e48"
        },
        {
          "x": 24,
          "y": 24,
          "z": 42,
          "id": "a748b138-df4c-416b-8712-81947d6fe86d"
        }
      ],
      "shouldAddCabinetBox": false,
      "shapeHeight": null
    },
    {
      "pos": {
        "x": 86.33333333333339,
        "y": 24.66666666666668
      },
      "slabPos": {
        "x": 38.66666666666668,
        "y": 90.00000000000001
      },
      "id": 6,
      "featureId": 382994627,
      "features": [
        {
          "featureId": 382994627,
          "partId": "upper_cabinet_boxes"
        },
        {
          "featureId": 526185040,
          "partId": "top_cabinet"
        }
      ],
      "colorSet": null,
      "isHidden": false,
      "shapePieces": [],
      "seamCutPointsAndLines": [],
      "shapeParentId": null,
      "lines": [
        {
          "id": "28c4d044-0888-43d3-a99b-a07210e9e514",
          "from": {
            "id": "d8ebf8a5-f35f-43f0-bc1b-69818c263681",
            "x": 0,
            "y": 0,
            "pos": {
              "x": 0,
              "y": 0
            },
            "posSlab": {
              "x": 0,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "lefttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "5a53e198-0750-414b-813c-041c97ec9317",
            "x": 48,
            "y": 0,
            "pos": {
              "x": 48,
              "y": 0
            },
            "posSlab": {
              "x": 48,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "righttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "c9556759-9d58-40b0-8b17-6c10075e6113",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "282c23a4-385b-4f53-b03d-6530c0bd7647",
          "from": {
            "id": "5a53e198-0750-414b-813c-041c97ec9317",
            "x": 48,
            "y": 0,
            "pos": {
              "x": 48,
              "y": 0
            },
            "posSlab": {
              "x": 48,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "righttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "7f09b4eb-4155-465e-ab35-9205642308e4",
            "x": 48,
            "y": 12,
            "pos": {
              "x": 48,
              "y": 12
            },
            "posSlab": {
              "x": 48,
              "y": 12
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "rightbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "33208f9a-5f43-4666-bf66-99e33d14d2ee",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "fe59333d-73d4-4652-bdb2-c9a83426cbab",
          "from": {
            "id": "7f09b4eb-4155-465e-ab35-9205642308e4",
            "x": 48,
            "y": 12,
            "pos": {
              "x": 48,
              "y": 12
            },
            "posSlab": {
              "x": 48,
              "y": 12
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "rightbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "a61bb1e7-74ae-4e53-9fbe-c92e598da1bb",
            "x": 0,
            "y": 12,
            "pos": {
              "x": 0,
              "y": 12
            },
            "posSlab": {
              "x": 0,
              "y": 12
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "leftbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "9e16e728-dcad-4d70-86d7-4b7b6fbb1ffb",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "6292b4d5-9787-4784-8b22-6580aeb884d3",
          "from": {
            "id": "a61bb1e7-74ae-4e53-9fbe-c92e598da1bb",
            "x": 0,
            "y": 12,
            "pos": {
              "x": 0,
              "y": 12
            },
            "posSlab": {
              "x": 0,
              "y": 12
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "leftbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "d8ebf8a5-f35f-43f0-bc1b-69818c263681",
            "x": 0,
            "y": 0,
            "pos": {
              "x": 0,
              "y": 0
            },
            "posSlab": {
              "x": 0,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "lefttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "6957bb5e-5176-4ea0-b10c-372ebac7e25b",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        }
      ],
      "shapeType": "square",
      "rotatedDegrees": 0,
      "rotatedDegreesSlab": 0,
      "partId": "upper_cabinet_boxes",
      "qtCatName": "Kitchen",
      "fromLayout": null,
      "squareFeet": 1,
      "quantity": 1,
      "quantitySubParts": {
        "doors": 2,
        "drawers": 0,
        "cabinetDoorsAndDrawersQuantity": 2,
        "cabinetDoorsSQFT": 0,
        "cabinetDoorsLNFT": 0
      },
      "isDisabledInPopup": false,
      "rotateAngleParts": [],
      "isPointsChanged": true,
      "isPositionChanged": true,
      "isResetSlabModePopupWasDisplayed": false,
      "shapeSlab": {
        "absolutePosition": null
      },
      "shapeCabinet": {
        "width": 48,
        "height": 12,
        "depth": 12
      },
      "shapeAbsolute": {
        "absolutePosition": {
          "x": 86.8963963963964,
          "y": 26.689189189189168
        },
        "intersectionPoints": [],
        "snappedWithShape": 7,
        "snappedShapeGroup": 24
      },
      "shapeParams": {
        "shapeCabinet": true,
        "canSnap": true,
        "width": 48,
        "height": 12,
        "depth": 12,
        "diamondLength": 0,
        "thirdPartyAR3DMetaData": {
          "ActualDisplayedName": [
            "Bryant H4812"
          ],
          "DisplayedName": [
            "Bryant H4812"
          ],
          "Width": [
            "48"
          ],
          "Height": [
            "12"
          ],
          "Depth": [
            "12"
          ],
          "SKU": [
            "H4812"
          ],
          "Shape": [
            "H4812"
          ],
          "DoorStyle": [
            "Bryant"
          ],
          "Door": [
            "2"
          ],
          "Drawer": [
            "0"
          ],
          "Category": [
            "Hood"
          ],
          "filters": {
            "Style": [
              "Bryant"
            ],
            "Width": [
              "48"
            ],
            "Height": [
              "12"
            ],
            "Depth": [
              "12"
            ]
          }
        },
        "shapeLayout": "rectangle"
      },
      "relatedParentFeatureId": 526185040,
      "slabModeCoreParentId": null,
      "parentPartId": "top_cabinet",
      "slabParentPartId": null,
      "shouldUseSlabPricing": false,
      "originalPointsCoords": [
        {
          "x": 0,
          "y": 0,
          "z": 12,
          "id": "d8ebf8a5-f35f-43f0-bc1b-69818c263681"
        },
        {
          "x": 48,
          "y": 0,
          "z": 12,
          "id": "5a53e198-0750-414b-813c-041c97ec9317"
        },
        {
          "x": 48,
          "y": 12,
          "z": 12,
          "id": "7f09b4eb-4155-465e-ab35-9205642308e4"
        },
        {
          "x": 0,
          "y": 12,
          "z": 12,
          "id": "a61bb1e7-74ae-4e53-9fbe-c92e598da1bb"
        }
      ],
      "shouldAddCabinetBox": false,
      "shapeHeight": null
    },
    {
      "pos": {
        "x": 50.00000000000001,
        "y": 25.99999999999999
      },
      "slabPos": {
        "x": 44.66666666666668,
        "y": 90.00000000000001
      },
      "id": 7,
      "featureId": 382499172,
      "features": [
        {
          "featureId": 382499172,
          "partId": "upper_cabinet_boxes"
        },
        {
          "featureId": 526185040,
          "partId": "top_cabinet"
        }
      ],
      "colorSet": null,
      "isHidden": false,
      "shapePieces": [],
      "seamCutPointsAndLines": [],
      "shapeParentId": null,
      "lines": [
        {
          "id": "137ed60a-7ea4-4e72-842c-4644d4f985fa",
          "from": {
            "id": "0c6a4916-b2b4-49c0-8f90-eea1bd833447",
            "x": 0,
            "y": 0,
            "pos": {
              "x": 0,
              "y": 0
            },
            "posSlab": {
              "x": 0,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "lefttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "5621d643-9be0-4fa3-bea4-a904fa8d0122",
            "x": 36,
            "y": 0,
            "pos": {
              "x": 36,
              "y": 0
            },
            "posSlab": {
              "x": 36,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "righttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "96492edc-cd7f-4eb3-a615-5d71b1f63ae5",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "af7b0c69-d2b6-479b-a0e4-1a31cf4ebb8d",
          "from": {
            "id": "5621d643-9be0-4fa3-bea4-a904fa8d0122",
            "x": 36,
            "y": 0,
            "pos": {
              "x": 36,
              "y": 0
            },
            "posSlab": {
              "x": 36,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "righttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "7780e74c-8488-43b1-952c-25947c2166c9",
            "x": 36,
            "y": 12,
            "pos": {
              "x": 36,
              "y": 12
            },
            "posSlab": {
              "x": 36,
              "y": 12
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "rightbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "3517d9e3-1c4a-495b-942b-4c8e3ce3a0b7",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "e7fc75f5-7ff1-4009-bebb-a4d3a26fb617",
          "from": {
            "id": "7780e74c-8488-43b1-952c-25947c2166c9",
            "x": 36,
            "y": 12,
            "pos": {
              "x": 36,
              "y": 12
            },
            "posSlab": {
              "x": 36,
              "y": 12
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "rightbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "3a5d2ef4-18b9-4732-bc53-c6b62d06105b",
            "x": 0,
            "y": 12,
            "pos": {
              "x": 0,
              "y": 12
            },
            "posSlab": {
              "x": 0,
              "y": 12
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "leftbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "be9b128c-9e3b-4ea4-b099-476abb08af0d",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "cd5f9b84-d538-4d3c-a1fb-ceab82281625",
          "from": {
            "id": "3a5d2ef4-18b9-4732-bc53-c6b62d06105b",
            "x": 0,
            "y": 12,
            "pos": {
              "x": 0,
              "y": 12
            },
            "posSlab": {
              "x": 0,
              "y": 12
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "leftbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "0c6a4916-b2b4-49c0-8f90-eea1bd833447",
            "x": 0,
            "y": 0,
            "pos": {
              "x": 0,
              "y": 0
            },
            "posSlab": {
              "x": 0,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "lefttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "af941f74-2f04-4b3b-8e3f-999ca73760f9",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        }
      ],
      "shapeType": "square",
      "rotatedDegrees": 0,
      "rotatedDegreesSlab": 0,
      "partId": "upper_cabinet_boxes",
      "qtCatName": "Kitchen",
      "fromLayout": null,
      "squareFeet": 1,
      "quantity": 1,
      "quantitySubParts": {
        "doors": 2,
        "drawers": 0,
        "cabinetDoorsAndDrawersQuantity": 2,
        "cabinetDoorsSQFT": 0,
        "cabinetDoorsLNFT": 0
      },
      "isDisabledInPopup": false,
      "rotateAngleParts": [],
      "isPointsChanged": true,
      "isPositionChanged": true,
      "isResetSlabModePopupWasDisplayed": false,
      "shapeSlab": {
        "absolutePosition": null
      },
      "shapeCabinet": {
        "width": 36,
        "height": 36,
        "depth": 12
      },
      "shapeAbsolute": {
        "absolutePosition": {
          "x": 50.8963963963964,
          "y": 26.68918918918917
        },
        "intersectionPoints": [],
        "snappedWithShape": 6,
        "snappedShapeGroup": 24
      },
      "shapeParams": {
        "shapeCabinet": true,
        "canSnap": true,
        "width": 36,
        "height": 36,
        "depth": 12,
        "diamondLength": 0,
        "thirdPartyAR3DMetaData": {
          "ActualDisplayedName": [
            "Bryant SM-W3636"
          ],
          "DisplayedName": [
            "Bryant SM-W3636"
          ],
          "Width": [
            "36"
          ],
          "Height": [
            "36"
          ],
          "Depth": [
            "12"
          ],
          "SKU": [
            "SM-W3636"
          ],
          "Shape": [
            "SM-W3636"
          ],
          "DoorStyle": [
            "Bryant"
          ],
          "Door": [
            "2"
          ],
          "Drawer": [
            "0"
          ],
          "filters": {
            "Style": [
              "Bryant"
            ],
            "Width": [
              "36"
            ],
            "Height": [
              "36"
            ],
            "Depth": [
              "12"
            ]
          }
        },
        "shapeLayout": "rectangle"
      },
      "relatedParentFeatureId": 526185040,
      "slabModeCoreParentId": null,
      "parentPartId": "top_cabinet",
      "slabParentPartId": null,
      "shouldUseSlabPricing": false,
      "originalPointsCoords": [
        {
          "x": 0,
          "y": 0,
          "z": 36,
          "id": "0c6a4916-b2b4-49c0-8f90-eea1bd833447"
        },
        {
          "x": 36,
          "y": 0,
          "z": 36,
          "id": "5621d643-9be0-4fa3-bea4-a904fa8d0122"
        },
        {
          "x": 36,
          "y": 12,
          "z": 36,
          "id": "7780e74c-8488-43b1-952c-25947c2166c9"
        },
        {
          "x": 0,
          "y": 12,
          "z": 36,
          "id": "3a5d2ef4-18b9-4732-bc53-c6b62d06105b"
        }
      ],
      "shouldAddCabinetBox": false,
      "shapeHeight": null
    },
    {
      "pos": {
        "x": -18.10360360360361,
        "y": 65.68918918918916
      },
      "slabPos": {
        "x": 44.66666666666668,
        "y": 90.00000000000001
      },
      "id": 8,
      "featureId": 382499174,
      "features": [
        {
          "featureId": 382499174,
          "partId": "upper_cabinet_boxes"
        },
        {
          "featureId": 526185040,
          "partId": "top_cabinet"
        }
      ],
      "colorSet": null,
      "isHidden": false,
      "shapePieces": [],
      "seamCutPointsAndLines": [],
      "shapeParentId": null,
      "lines": [
        {
          "id": "f95e9102-44ee-4fe1-b4c5-347ce109b09f",
          "from": {
            "id": "772fad2d-4a36-470c-91c0-8b70f29009ee",
            "x": 12,
            "y": 24,
            "pos": {
              "x": 12,
              "y": 24
            },
            "posSlab": {
              "x": 0,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "leftbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "6961280f-969f-4447-8803-c943f26b5dc6",
            "x": 12,
            "y": -12,
            "pos": {
              "x": 12,
              "y": -12
            },
            "posSlab": {
              "x": 36,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "lefttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "4db5e7a6-31d1-48bc-b580-83a3a3bcaa87",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "7b25745d-abcd-4dab-b7fe-7b8128eb22df",
          "from": {
            "id": "6961280f-969f-4447-8803-c943f26b5dc6",
            "x": 12,
            "y": -12,
            "pos": {
              "x": 12,
              "y": -12
            },
            "posSlab": {
              "x": 36,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "lefttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "84f0b568-1e55-45eb-b29e-4cffce851317",
            "x": 24,
            "y": -12,
            "pos": {
              "x": 24,
              "y": -12
            },
            "posSlab": {
              "x": 36,
              "y": 12
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "righttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "e7eb7c74-b112-4aea-9041-756f0157301d",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "690f55da-d810-4953-9e0e-f5d9532c4ab0",
          "from": {
            "id": "84f0b568-1e55-45eb-b29e-4cffce851317",
            "x": 24,
            "y": -12,
            "pos": {
              "x": 24,
              "y": -12
            },
            "posSlab": {
              "x": 36,
              "y": 12
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "righttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "bbb2bd3b-2404-4120-a63b-7480d66fff88",
            "x": 24,
            "y": 24,
            "pos": {
              "x": 24,
              "y": 24
            },
            "posSlab": {
              "x": 0,
              "y": 12
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "rightbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "6ae1e607-cbcc-4435-8fec-4af8e9b3fcad",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "55f1f8d1-f9c1-4447-bf59-33a63b4cc955",
          "from": {
            "id": "bbb2bd3b-2404-4120-a63b-7480d66fff88",
            "x": 24,
            "y": 24,
            "pos": {
              "x": 24,
              "y": 24
            },
            "posSlab": {
              "x": 0,
              "y": 12
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "rightbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "772fad2d-4a36-470c-91c0-8b70f29009ee",
            "x": 12,
            "y": 24,
            "pos": {
              "x": 12,
              "y": 24
            },
            "posSlab": {
              "x": 0,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "leftbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "2e71d25c-e1b4-4aa4-924a-62d3db24f875",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        }
      ],
      "shapeType": "square",
      "rotatedDegrees": 90,
      "rotatedDegreesSlab": 0,
      "partId": "upper_cabinet_boxes",
      "qtCatName": "Kitchen",
      "fromLayout": null,
      "squareFeet": 1,
      "quantity": 1,
      "quantitySubParts": {
        "doors": 1,
        "drawers": 0,
        "cabinetDoorsAndDrawersQuantity": 1,
        "cabinetDoorsSQFT": 0,
        "cabinetDoorsLNFT": 0
      },
      "isDisabledInPopup": false,
      "rotateAngleParts": [],
      "isPointsChanged": true,
      "isPositionChanged": true,
      "isResetSlabModePopupWasDisplayed": false,
      "shapeSlab": {
        "absolutePosition": null
      },
      "shapeCabinet": {
        "width": 12,
        "height": 30,
        "depth": 36
      },
      "shapeAbsolute": {
        "absolutePosition": {
          "x": -18.10360360360361,
          "y": 65.68918918918916
        },
        "intersectionPoints": [],
        "snappedWithShape": 10,
        "snappedShapeGroup": 24
      },
      "shapeParams": {
        "shapeCabinet": true,
        "canSnap": true,
        "width": 36,
        "height": 30,
        "depth": 12,
        "diamondLength": 0,
        "thirdPartyAR3DMetaData": {
          "ActualDisplayedName": [
            "Bryant SW-WBC3630"
          ],
          "DisplayedName": [
            "Bryant SW-WBC3630"
          ],
          "Width": [
            "36"
          ],
          "Height": [
            "30"
          ],
          "Depth": [
            "12"
          ],
          "SKU": [
            "SW-WBC3630"
          ],
          "Shape": [
            "SW-WBC3630"
          ],
          "DoorStyle": [
            "Bryant"
          ],
          "Door": [
            "1"
          ],
          "Drawer": [
            "0"
          ],
          "filters": {
            "Style": [
              "Bryant"
            ],
            "Width": [
              "36"
            ],
            "Height": [
              "30"
            ],
            "Depth": [
              "12"
            ]
          }
        },
        "shapeLayout": "rectangle"
      },
      "relatedParentFeatureId": 526185040,
      "slabModeCoreParentId": null,
      "parentPartId": "top_cabinet",
      "slabParentPartId": null,
      "shouldUseSlabPricing": false,
      "originalPointsCoords": [
        {
          "x": 12,
          "y": 24,
          "z": 30,
          "id": "772fad2d-4a36-470c-91c0-8b70f29009ee"
        },
        {
          "x": 12,
          "y": -12,
          "z": 30,
          "id": "6961280f-969f-4447-8803-c943f26b5dc6"
        },
        {
          "x": 24,
          "y": -12,
          "z": 30,
          "id": "84f0b568-1e55-45eb-b29e-4cffce851317"
        },
        {
          "x": 24,
          "y": 24,
          "z": 30,
          "id": "bbb2bd3b-2404-4120-a63b-7480d66fff88"
        }
      ],
      "shouldAddCabinetBox": false,
      "shapeHeight": null
    },
    {
      "pos": {
        "x": 18.333333333333353,
        "y": 25.999999999999996
      },
      "slabPos": {
        "x": 47.66666666666668,
        "y": 90.00000000000001
      },
      "id": 9,
      "featureId": 382499162,
      "features": [
        {
          "featureId": 382499162,
          "partId": "upper_cabinet_boxes"
        },
        {
          "featureId": 526185040,
          "partId": "top_cabinet"
        }
      ],
      "colorSet": null,
      "isHidden": false,
      "shapePieces": [],
      "seamCutPointsAndLines": [],
      "shapeParentId": null,
      "lines": [
        {
          "id": "9faee721-11a1-4977-ad87-77829f08b09b",
          "from": {
            "id": "ce31bc03-a4a9-4517-a1ea-9d5d34a3e8ba",
            "x": 0,
            "y": 0,
            "pos": {
              "x": 0,
              "y": 0
            },
            "posSlab": {
              "x": 0,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "lefttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "8b00f21f-6581-487c-a9fb-881e40ae7b41",
            "x": 30,
            "y": 0,
            "pos": {
              "x": 30,
              "y": 0
            },
            "posSlab": {
              "x": 30,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "righttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "5d7b417c-77ce-4b84-a99f-f49a87e05154",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "a3104a78-398e-4a3a-beff-88705f7a43c4",
          "from": {
            "id": "8b00f21f-6581-487c-a9fb-881e40ae7b41",
            "x": 30,
            "y": 0,
            "pos": {
              "x": 30,
              "y": 0
            },
            "posSlab": {
              "x": 30,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "righttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "b92d0c01-eee9-4703-86c5-2b3037c0f110",
            "x": 30,
            "y": 12,
            "pos": {
              "x": 30,
              "y": 12
            },
            "posSlab": {
              "x": 30,
              "y": 12
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "rightbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "1e22ea04-1a01-4a4d-8328-219258027760",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "55747700-6bd2-4de8-883e-668135aa082e",
          "from": {
            "id": "b92d0c01-eee9-4703-86c5-2b3037c0f110",
            "x": 30,
            "y": 12,
            "pos": {
              "x": 30,
              "y": 12
            },
            "posSlab": {
              "x": 30,
              "y": 12
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "rightbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "bf62b8a2-45c7-42ec-b911-688f42452d19",
            "x": 0,
            "y": 12,
            "pos": {
              "x": 0,
              "y": 12
            },
            "posSlab": {
              "x": 0,
              "y": 12
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "leftbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "2c24bfa0-a2a7-48d4-a0ec-6e5d056c8042",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "6c058918-de76-4157-9e8d-1dedcfecb95a",
          "from": {
            "id": "bf62b8a2-45c7-42ec-b911-688f42452d19",
            "x": 0,
            "y": 12,
            "pos": {
              "x": 0,
              "y": 12
            },
            "posSlab": {
              "x": 0,
              "y": 12
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "leftbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "ce31bc03-a4a9-4517-a1ea-9d5d34a3e8ba",
            "x": 0,
            "y": 0,
            "pos": {
              "x": 0,
              "y": 0
            },
            "posSlab": {
              "x": 0,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "lefttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "9fc42f3e-c903-4ad8-a2d0-59977447bbce",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        }
      ],
      "shapeType": "square",
      "rotatedDegrees": 0,
      "rotatedDegreesSlab": 0,
      "partId": "upper_cabinet_boxes",
      "qtCatName": "Kitchen",
      "fromLayout": null,
      "squareFeet": 1,
      "quantity": 1,
      "quantitySubParts": {
        "doors": 2,
        "drawers": 0,
        "cabinetDoorsAndDrawersQuantity": 2,
        "cabinetDoorsSQFT": 0,
        "cabinetDoorsLNFT": 0
      },
      "isDisabledInPopup": false,
      "rotateAngleParts": [],
      "isPointsChanged": true,
      "isPositionChanged": true,
      "isResetSlabModePopupWasDisplayed": false,
      "shapeSlab": {
        "absolutePosition": null
      },
      "shapeCabinet": {
        "width": 30,
        "height": 36,
        "depth": 12
      },
      "shapeAbsolute": {
        "absolutePosition": {
          "x": 20.89639639639641,
          "y": 26.68918918918917
        },
        "intersectionPoints": [],
        "snappedWithShape": 7,
        "snappedShapeGroup": 24
      },
      "shapeParams": {
        "shapeCabinet": true,
        "canSnap": true,
        "width": 30,
        "height": 36,
        "depth": 12,
        "diamondLength": 0,
        "thirdPartyAR3DMetaData": {
          "ActualDisplayedName": [
            "Bryant SM-W3036"
          ],
          "DisplayedName": [
            "Bryant SM-W3036"
          ],
          "Width": [
            "30"
          ],
          "Height": [
            "36"
          ],
          "Depth": [
            "12"
          ],
          "SKU": [
            "SM-W3036"
          ],
          "Shape": [
            "SM-W3036"
          ],
          "DoorStyle": [
            "Bryant"
          ],
          "Door": [
            "2"
          ],
          "Drawer": [
            "0"
          ],
          "filters": {
            "Style": [
              "Bryant"
            ],
            "Width": [
              "30"
            ],
            "Height": [
              "36"
            ],
            "Depth": [
              "12"
            ]
          }
        },
        "shapeLayout": "rectangle"
      },
      "relatedParentFeatureId": 526185040,
      "slabModeCoreParentId": null,
      "parentPartId": "top_cabinet",
      "slabParentPartId": null,
      "shouldUseSlabPricing": false,
      "originalPointsCoords": [
        {
          "x": 0,
          "y": 0,
          "z": 36,
          "id": "ce31bc03-a4a9-4517-a1ea-9d5d34a3e8ba"
        },
        {
          "x": 30,
          "y": 0,
          "z": 36,
          "id": "8b00f21f-6581-487c-a9fb-881e40ae7b41"
        },
        {
          "x": 30,
          "y": 12,
          "z": 36,
          "id": "b92d0c01-eee9-4703-86c5-2b3037c0f110"
        },
        {
          "x": 0,
          "y": 12,
          "z": 36,
          "id": "bf62b8a2-45c7-42ec-b911-688f42452d19"
        }
      ],
      "shouldAddCabinetBox": false,
      "shapeHeight": null
    },
    {
      "pos": {
        "x": -4.4999999999999964,
        "y": 25.833333333333346
      },
      "slabPos": {
        "x": 49.16666666666668,
        "y": 82.50000000000001
      },
      "id": 10,
      "featureId": 382994749,
      "features": [
        {
          "featureId": 382994749,
          "partId": "upper_cabinet_boxes"
        },
        {
          "featureId": 526185040,
          "partId": "top_cabinet"
        }
      ],
      "colorSet": null,
      "isHidden": false,
      "shapePieces": [],
      "seamCutPointsAndLines": [],
      "shapeParentId": null,
      "lines": [
        {
          "id": "5ecfa898-caab-4828-9d19-b53ecac5c898",
          "from": {
            "id": "1b102801-6c34-47d3-b0b9-39b2c210fb1d",
            "x": 6.8326,
            "y": 0,
            "pos": {
              "x": 6.8326,
              "y": 0
            },
            "posSlab": {
              "x": 6.832599999999999,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "8249e866-07f2-46ba-84c9-0edcdd5ac44c",
            "x": 27,
            "y": 0,
            "pos": {
              "x": 27,
              "y": 0
            },
            "posSlab": {
              "x": 27,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "righttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "f31bad6f-c4f2-4f08-8c64-14d307134e02",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "9015cf26-5560-4369-87f6-172d3d6a0fa8",
          "from": {
            "id": "8249e866-07f2-46ba-84c9-0edcdd5ac44c",
            "x": 27,
            "y": 0,
            "pos": {
              "x": 27,
              "y": 0
            },
            "posSlab": {
              "x": 27,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "righttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "f7006142-ab7d-4b16-94c6-a732e0abcba4",
            "x": 27,
            "y": 12,
            "pos": {
              "x": 27,
              "y": 12
            },
            "posSlab": {
              "x": 27,
              "y": 12
            },
            "arcLength": 0,
            "angle": 0,
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "36831f15-d8d7-4429-a3d5-4c3e379a2b39",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "0e094160-2fcb-48ed-810b-56ebf67dee36",
          "from": {
            "id": "f7006142-ab7d-4b16-94c6-a732e0abcba4",
            "x": 27,
            "y": 12,
            "pos": {
              "x": 27,
              "y": 12
            },
            "posSlab": {
              "x": 27,
              "y": 12
            },
            "arcLength": 0,
            "angle": 0,
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "6ddd3262-af98-4116-afac-d89526c1981e",
            "x": 12,
            "y": 27,
            "pos": {
              "x": 12,
              "y": 27
            },
            "posSlab": {
              "x": 12,
              "y": 27
            },
            "arcLength": 0,
            "angle": 0,
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "2ee50c53-8bbc-43b4-b408-89d734f911e3",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "f3ea01de-4e67-4c69-b0dc-d2c13cf1b404",
          "from": {
            "id": "6ddd3262-af98-4116-afac-d89526c1981e",
            "x": 12,
            "y": 27,
            "pos": {
              "x": 12,
              "y": 27
            },
            "posSlab": {
              "x": 12,
              "y": 27
            },
            "arcLength": 0,
            "angle": 0,
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "7df04c53-a917-4201-b1b5-18baa80acfbd",
            "x": 0,
            "y": 27,
            "pos": {
              "x": 0,
              "y": 27
            },
            "posSlab": {
              "x": 0,
              "y": 27
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "leftbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "6cd1ef8a-9598-4b08-9e20-c2fb87ccd8a2",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "eb0923c0-7b67-4d96-9cdd-78bd1dcc260d",
          "from": {
            "id": "7df04c53-a917-4201-b1b5-18baa80acfbd",
            "x": 0,
            "y": 27,
            "pos": {
              "x": 0,
              "y": 27
            },
            "posSlab": {
              "x": 0,
              "y": 27
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "leftbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "d10bc61a-48ad-4b73-ba73-e7142bb8eda5",
            "x": 0,
            "y": 6.8326,
            "pos": {
              "x": 0,
              "y": 6.8326
            },
            "posSlab": {
              "x": 0,
              "y": 6.832599999999999
            },
            "arcLength": 0,
            "angle": 0,
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "87504e97-3a87-463c-ae80-35d372307c39",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "4df389f0-d89c-4341-be9c-dbeb86fbd560",
          "from": {
            "id": "d10bc61a-48ad-4b73-ba73-e7142bb8eda5",
            "x": 0,
            "y": 6.8326,
            "pos": {
              "x": 0,
              "y": 6.8326
            },
            "posSlab": {
              "x": 0,
              "y": 6.832599999999999
            },
            "arcLength": 0,
            "angle": 0,
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "1b102801-6c34-47d3-b0b9-39b2c210fb1d",
            "x": 6.8326,
            "y": 0,
            "pos": {
              "x": 6.8326,
              "y": 0
            },
            "posSlab": {
              "x": 6.832599999999999,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "accb68f3-92c7-4fea-a85e-6965aa73b100",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        }
      ],
      "shapeType": "square",
      "rotatedDegrees": 0,
      "rotatedDegreesSlab": 0,
      "partId": "upper_cabinet_boxes",
      "qtCatName": "Kitchen",
      "fromLayout": null,
      "squareFeet": 1,
      "quantity": 1,
      "quantitySubParts": {
        "doors": 1,
        "drawers": 0,
        "cabinetDoorsAndDrawersQuantity": 1,
        "cabinetDoorsSQFT": 0,
        "cabinetDoorsLNFT": 0
      },
      "isDisabledInPopup": false,
      "rotateAngleParts": [],
      "isPointsChanged": true,
      "isPositionChanged": true,
      "isResetSlabModePopupWasDisplayed": false,
      "shapeSlab": {
        "absolutePosition": null
      },
      "shapeCabinet": {
        "width": 27,
        "height": 42,
        "depth": 27
      },
      "shapeAbsolute": {
        "absolutePosition": {
          "x": -6.1036036036036085,
          "y": 26.689189189189168
        },
        "intersectionPoints": [],
        "snappedWithShape": 8,
        "snappedShapeGroup": 24
      },
      "shapeParams": {
        "shapeCabinet": true,
        "canSnap": true,
        "width": 27,
        "height": 42,
        "depth": 12,
        "diamondLength": 20.1674,
        "thirdPartyAR3DMetaData": {
          "ActualDisplayedName": [
            "Bryant DCW2742"
          ],
          "DisplayedName": [
            "Bryant DCW2742"
          ],
          "Width": [
            "27"
          ],
          "Height": [
            "42"
          ],
          "Depth": [
            "12"
          ],
          "SKU": [
            "DCW2742"
          ],
          "Shape": [
            "DCW2742"
          ],
          "DoorStyle": [
            "Bryant"
          ],
          "Door": [
            "1"
          ],
          "Drawer": [
            "0"
          ],
          "SpecialShape": [
            "UpperDimondShape"
          ],
          "DiamondLength": [
            "20.1674in"
          ],
          "filters": {
            "Style": [
              "Bryant"
            ],
            "Width": [
              "27"
            ],
            "Height": [
              "42"
            ],
            "Depth": [
              "12"
            ],
            "DiamondLength": [
              "20.1674in"
            ]
          }
        },
        "shapeLayout": "UpperDimondShape"
      },
      "relatedParentFeatureId": 526185040,
      "slabModeCoreParentId": null,
      "parentPartId": "top_cabinet",
      "slabParentPartId": null,
      "shouldUseSlabPricing": false,
      "originalPointsCoords": [
        {
          "x": 6.8326,
          "y": 0,
          "z": 42,
          "id": "1b102801-6c34-47d3-b0b9-39b2c210fb1d"
        },
        {
          "x": 27,
          "y": 0,
          "z": 42,
          "id": "8249e866-07f2-46ba-84c9-0edcdd5ac44c"
        },
        {
          "x": 27,
          "y": 12,
          "z": 42,
          "id": "f7006142-ab7d-4b16-94c6-a732e0abcba4"
        },
        {
          "x": 12,
          "y": 27,
          "z": 42,
          "id": "6ddd3262-af98-4116-afac-d89526c1981e"
        },
        {
          "x": 0,
          "y": 27,
          "z": 42,
          "id": "7df04c53-a917-4201-b1b5-18baa80acfbd"
        },
        {
          "x": 0,
          "y": 6.8326,
          "z": 42,
          "id": "d10bc61a-48ad-4b73-ba73-e7142bb8eda5"
        }
      ],
      "shouldAddCabinetBox": false,
      "shapeHeight": null
    }
  ],
  "manualCalculate": false,
  "controllers": {
    "walls": [],
    "snappedShapeGroups": [
      0,
      1,
      2,
      3,
      4,
      5,
      6,
      7,
      8,
      9,
      10,
      11,
      12,
      13,
      14,
      15,
      16,
      17,
      18,
      19,
      20,
      21,
      22,
      23,
      24
    ],
    "handles": [],
    "hinge": []
  },
  "underlayment": []
}

export const CABINET_SET4_WHITE = {
  "bumpouts": [],
  "canvasImage": "",
  "sqFtSlabImage": "",
  "sqFtSlabCalcImage": "",
  "sqftApplianceImages": "",
  "images3D": "",
  "slabImages": [],
  "measureUnit": "Imperial",
  "sinks": [],
  "radii": [],
  "corners": [],
  "totalInches": 8320.738232835298,
  "shapeLength": 10,
  "objIds": 10,
  "removedFeatures": [],
  "textBoxes": [],
  "slabAdditionalShapesList": [],
  "slabImagesTotalArea": [],
  "squareFeet": 58,
  "countertops": [
    {
      "pos": {
        "x": -6.103603603603609,
        "y": 26.689189189189165
      },
      "slabPos": {
        "x": -6.103603603603609,
        "y": 26.689189189189165
      },
      "id": 1,
      "featureId": 382994644,
      "features": [
        {
          "featureId": 382994644,
          "partId": "lower_cabinet_boxes"
        },
        {
          "featureId": 382932419,
          "partId": "bottom_cabinet"
        }
      ],
      "colorSet": null,
      "isHidden": false,
      "shapePieces": [],
      "seamCutPointsAndLines": [],
      "shapeParentId": null,
      "lines": [
        {
          "id": "f2e4c7b2-84af-43d7-ab17-746c8640381d",
          "from": {
            "id": "1415b375-abbd-4215-b3e9-5749b73e5d2f",
            "x": 0,
            "y": 0,
            "pos": {
              "x": 0,
              "y": 0
            },
            "posSlab": {
              "x": 0,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "lefttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "243c146e-af89-4c0f-9e18-38792b22ae4d",
            "x": 45,
            "y": 0,
            "pos": {
              "x": 45,
              "y": 0
            },
            "posSlab": {
              "x": 45,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "righttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "f83f1d6c-3625-4433-9932-ebc73d8ea5b2",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "05fc4459-7981-464d-886c-bd29f3e6c255",
          "from": {
            "id": "243c146e-af89-4c0f-9e18-38792b22ae4d",
            "x": 45,
            "y": 0,
            "pos": {
              "x": 45,
              "y": 0
            },
            "posSlab": {
              "x": 45,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "righttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "791d06a8-3203-4336-a1ed-79f950d4d4c8",
            "x": 45,
            "y": 24,
            "pos": {
              "x": 45,
              "y": 24
            },
            "posSlab": {
              "x": 45,
              "y": 24
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "rightbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "dffea30b-492a-46b4-8066-acf64128b285",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "02853a25-e322-42da-98e0-d8b3c593f0ed",
          "from": {
            "id": "791d06a8-3203-4336-a1ed-79f950d4d4c8",
            "x": 45,
            "y": 24,
            "pos": {
              "x": 45,
              "y": 24
            },
            "posSlab": {
              "x": 45,
              "y": 24
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "rightbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "6161ef15-4264-4d1a-9274-8130672830bc",
            "x": 24,
            "y": 24,
            "pos": {
              "x": 24,
              "y": 24
            },
            "posSlab": {
              "x": 24,
              "y": 24
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "rightbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "04a77d37-c76f-48e1-bb15-ad315ac9bdbd",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "12444ac3-ff12-4601-9968-cca4cebd061a",
          "from": {
            "id": "6161ef15-4264-4d1a-9274-8130672830bc",
            "x": 24,
            "y": 24,
            "pos": {
              "x": 24,
              "y": 24
            },
            "posSlab": {
              "x": 24,
              "y": 24
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "rightbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "6e211d92-5fc4-4cf6-a571-3cf1e05a7d68",
            "x": 24,
            "y": 45,
            "pos": {
              "x": 24,
              "y": 45
            },
            "posSlab": {
              "x": 24,
              "y": 45
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "rightbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "b08186fe-1c46-43c9-85c2-9efb795c9dfa",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "14e2e157-2f91-432f-99d6-0192b56f1eb2",
          "from": {
            "id": "6e211d92-5fc4-4cf6-a571-3cf1e05a7d68",
            "x": 24,
            "y": 45,
            "pos": {
              "x": 24,
              "y": 45
            },
            "posSlab": {
              "x": 24,
              "y": 45
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "rightbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "6b59aa48-942f-41c5-8a4f-0fbd25d0b321",
            "x": 0,
            "y": 45,
            "pos": {
              "x": 0,
              "y": 45
            },
            "posSlab": {
              "x": 0,
              "y": 45
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "leftbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "fd505442-f79b-47a3-82b1-d8e9d3c43b75",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "c570039a-cc87-4bc7-b646-92ca4a3fc7ab",
          "from": {
            "id": "6b59aa48-942f-41c5-8a4f-0fbd25d0b321",
            "x": 0,
            "y": 45,
            "pos": {
              "x": 0,
              "y": 45
            },
            "posSlab": {
              "x": 0,
              "y": 45
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "leftbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "1415b375-abbd-4215-b3e9-5749b73e5d2f",
            "x": 0,
            "y": 0,
            "pos": {
              "x": 0,
              "y": 0
            },
            "posSlab": {
              "x": 0,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "lefttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "05b00b54-791c-4bce-8617-56184eb72581",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        }
      ],
      "shapeType": "square",
      "rotatedDegrees": 0,
      "rotatedDegreesSlab": 0,
      "partId": "lower_cabinet_boxes",
      "qtCatName": "Kitchen",
      "fromLayout": null,
      "squareFeet": 1,
      "quantity": 1,
      "quantitySubParts": {
        "doors": 2,
        "drawers": 0,
        "cabinetDoorsAndDrawersQuantity": 2,
        "cabinetDoorsSQFT": 0,
        "cabinetDoorsLNFT": 0
      },
      "isDisabledInPopup": false,
      "rotateAngleParts": [],
      "isPointsChanged": true,
      "isPositionChanged": true,
      "isResetSlabModePopupWasDisplayed": false,
      "shapeSlab": {
        "absolutePosition": null
      },
      "shapeCabinet": {
        "width": 45,
        "height": 34,
        "depth": 45
      },
      "shapeAbsolute": {
        "absolutePosition": null,
        "intersectionPoints": [],
        "snappedWithShape": null,
        "snappedShapeGroup": 21
      },
      "shapeParams": {
        "shapeCabinet": true,
        "canSnap": true,
        "width": 45,
        "height": 34,
        "depth": 24,
        "diamondLength": 0,
        "thirdPartyAR3DMetaData": {
          "ActualDisplayedName": [
            "Bryant BBC45-48FHLRB"
          ],
          "DisplayedName": [
            "Bryant BBC45-48FHLRB"
          ],
          "Width": [
            "45"
          ],
          "Height": [
            "34"
          ],
          "Depth": [
            "24"
          ],
          "SKU": [
            "BBC45-48FHLRB"
          ],
          "Shape": [
            "BBC45-48FHLRB"
          ],
          "DoorStyle": [
            "Bryant"
          ],
          "Door": [
            "2"
          ],
          "Drawer": [
            "0"
          ],
          "SpecialShape": [
            "LowerLCorner"
          ],
          "filters": {
            "Style": [
              "Bryant"
            ],
            "Width": [
              "45"
            ],
            "Height": [
              "34"
            ],
            "Depth": [
              "24"
            ]
          }
        },
        "shapeLayout": "LowerLCorner"
      },
      "relatedParentFeatureId": 382932419,
      "slabModeCoreParentId": null,
      "parentPartId": "bottom_cabinet",
      "slabParentPartId": null,
      "shouldUseSlabPricing": false,
      "originalPointsCoords": [
        {
          "x": 0,
          "y": 0,
          "z": 34,
          "id": "1415b375-abbd-4215-b3e9-5749b73e5d2f"
        },
        {
          "x": 45,
          "y": 0,
          "z": 34,
          "id": "243c146e-af89-4c0f-9e18-38792b22ae4d"
        },
        {
          "x": 45,
          "y": 24,
          "z": 34,
          "id": "791d06a8-3203-4336-a1ed-79f950d4d4c8"
        },
        {
          "x": 24,
          "y": 24,
          "z": 34,
          "id": "6161ef15-4264-4d1a-9274-8130672830bc"
        },
        {
          "x": 24,
          "y": 45,
          "z": 34,
          "id": "6e211d92-5fc4-4cf6-a571-3cf1e05a7d68"
        },
        {
          "x": 0,
          "y": 45,
          "z": 34,
          "id": "6b59aa48-942f-41c5-8a4f-0fbd25d0b321"
        }
      ],
      "shouldAddCabinetBox": false,
      "shapeHeight": null
    },
    {
      "pos": {
        "x": 83.3963963963964,
        "y": 28.855855855855832
      },
      "slabPos": {
        "x": -4.603603603603609,
        "y": 37.189189189189165
      },
      "id": 2,
      "featureId": 382499177,
      "features": [
        {
          "featureId": 382499177,
          "partId": "lower_cabinet_boxes"
        },
        {
          "featureId": 382932419,
          "partId": "bottom_cabinet"
        }
      ],
      "colorSet": null,
      "isHidden": false,
      "shapePieces": [],
      "seamCutPointsAndLines": [],
      "shapeParentId": null,
      "lines": [
        {
          "id": "c44d4f3c-63a0-4375-9fca-5e6995b4fb77",
          "from": {
            "id": "f5345b3b-ee34-4558-85f7-8e54a38aef29",
            "x": 0,
            "y": 0,
            "pos": {
              "x": 0,
              "y": 0
            },
            "posSlab": {
              "x": 0,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "lefttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "08c7b4fc-7472-43d7-b3cf-57b28854c78e",
            "x": 42,
            "y": 0,
            "pos": {
              "x": 42,
              "y": 0
            },
            "posSlab": {
              "x": 42,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "righttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "7eff228f-5d14-4664-945c-13f88d02b0bc",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "7a924d17-7e49-485f-9626-586a35757ecd",
          "from": {
            "id": "08c7b4fc-7472-43d7-b3cf-57b28854c78e",
            "x": 42,
            "y": 0,
            "pos": {
              "x": 42,
              "y": 0
            },
            "posSlab": {
              "x": 42,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "righttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "e69ec81f-e6c4-48dc-a40a-b6f5bf00937c",
            "x": 42,
            "y": 24,
            "pos": {
              "x": 42,
              "y": 24
            },
            "posSlab": {
              "x": 42,
              "y": 24
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "rightbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "5b815685-0af2-4340-9bf9-d6bfbc8ff84b",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "e363999d-fb0e-4627-aead-c6f01e07ef8f",
          "from": {
            "id": "e69ec81f-e6c4-48dc-a40a-b6f5bf00937c",
            "x": 42,
            "y": 24,
            "pos": {
              "x": 42,
              "y": 24
            },
            "posSlab": {
              "x": 42,
              "y": 24
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "rightbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "e31155b1-f967-4042-8017-1fd3bf271460",
            "x": 0,
            "y": 24,
            "pos": {
              "x": 0,
              "y": 24
            },
            "posSlab": {
              "x": 0,
              "y": 24
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "leftbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "81c9213e-22ec-4c2e-8538-0aef6f49fd5e",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "9805fdf5-d82a-4e31-9884-24ef659993b6",
          "from": {
            "id": "e31155b1-f967-4042-8017-1fd3bf271460",
            "x": 0,
            "y": 24,
            "pos": {
              "x": 0,
              "y": 24
            },
            "posSlab": {
              "x": 0,
              "y": 24
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "leftbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "f5345b3b-ee34-4558-85f7-8e54a38aef29",
            "x": 0,
            "y": 0,
            "pos": {
              "x": 0,
              "y": 0
            },
            "posSlab": {
              "x": 0,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "lefttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "6b68a166-8da5-4662-b7b5-cad4d04cdc71",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        }
      ],
      "shapeType": "square",
      "rotatedDegrees": 0,
      "rotatedDegreesSlab": 0,
      "partId": "lower_cabinet_boxes",
      "qtCatName": "Kitchen",
      "fromLayout": null,
      "squareFeet": 1,
      "quantity": 1,
      "quantitySubParts": {
        "doors": 2,
        "drawers": 2,
        "cabinetDoorsAndDrawersQuantity": 4,
        "cabinetDoorsSQFT": 0,
        "cabinetDoorsLNFT": 0
      },
      "isDisabledInPopup": false,
      "rotateAngleParts": [],
      "isPointsChanged": true,
      "isPositionChanged": true,
      "isResetSlabModePopupWasDisplayed": false,
      "shapeSlab": {
        "absolutePosition": null
      },
      "shapeCabinet": {
        "width": 42,
        "height": 34,
        "depth": 24
      },
      "shapeAbsolute": {
        "absolutePosition": {
          "x": 80.8963963963964,
          "y": 26.689189189189165
        },
        "intersectionPoints": [],
        "snappedWithShape": null,
        "snappedShapeGroup": 21
      },
      "shapeParams": {
        "shapeCabinet": true,
        "canSnap": true,
        "width": 42,
        "height": 34,
        "depth": 24,
        "diamondLength": 0,
        "thirdPartyAR3DMetaData": {
          "ActualDisplayedName": [
            "Bryant SM-B42"
          ],
          "DisplayedName": [
            "Bryant SM-B42"
          ],
          "Width": [
            "42"
          ],
          "Height": [
            "34"
          ],
          "Depth": [
            "24"
          ],
          "SKU": [
            "SM-B42"
          ],
          "Shape": [
            "SM-B42"
          ],
          "DoorStyle": [
            "Bryant"
          ],
          "Door": [
            "2"
          ],
          "Drawer": [
            "2"
          ],
          "filters": {
            "Style": [
              "Bryant"
            ],
            "Width": [
              "42"
            ],
            "Height": [
              "34"
            ],
            "Depth": [
              "24"
            ]
          }
        },
        "shapeLayout": "rectangle"
      },
      "relatedParentFeatureId": 382932419,
      "slabModeCoreParentId": null,
      "parentPartId": "bottom_cabinet",
      "slabParentPartId": null,
      "shouldUseSlabPricing": false,
      "originalPointsCoords": [
        {
          "x": 0,
          "y": 0,
          "z": 34,
          "id": "f5345b3b-ee34-4558-85f7-8e54a38aef29"
        },
        {
          "x": 42,
          "y": 0,
          "z": 34,
          "id": "08c7b4fc-7472-43d7-b3cf-57b28854c78e"
        },
        {
          "x": 42,
          "y": 24,
          "z": 34,
          "id": "e69ec81f-e6c4-48dc-a40a-b6f5bf00937c"
        },
        {
          "x": 0,
          "y": 24,
          "z": 34,
          "id": "e31155b1-f967-4042-8017-1fd3bf271460"
        }
      ],
      "shouldAddCabinetBox": false,
      "shapeHeight": null
    },
    {
      "pos": {
        "x": -15.10360360360361,
        "y": 80.68918918918916
      },
      "slabPos": {
        "x": -4.603603603603609,
        "y": 37.189189189189165
      },
      "id": 3,
      "featureId": 382499177,
      "features": [
        {
          "featureId": 382499177,
          "partId": "lower_cabinet_boxes"
        },
        {
          "featureId": 382932419,
          "partId": "bottom_cabinet"
        }
      ],
      "colorSet": null,
      "isHidden": false,
      "shapePieces": [],
      "seamCutPointsAndLines": [],
      "shapeParentId": null,
      "lines": [
        {
          "id": "165960c4-2c92-4896-93e7-06e48c9f04c8",
          "from": {
            "id": "9ef4552e-0f22-4cf5-bb4b-bd9a82f54c03",
            "x": 9,
            "y": 33,
            "pos": {
              "x": 9,
              "y": 33
            },
            "posSlab": {
              "x": 0,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "leftbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "a0579193-4329-4cf9-bc66-731daefe4aad",
            "x": 9,
            "y": -9,
            "pos": {
              "x": 9,
              "y": -9
            },
            "posSlab": {
              "x": 42,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "lefttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "cc6a953c-6077-4d19-a4bc-0bdfa7c3813f",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "70a4aae2-b936-4411-8a2a-fc9eb758d31f",
          "from": {
            "id": "a0579193-4329-4cf9-bc66-731daefe4aad",
            "x": 9,
            "y": -9,
            "pos": {
              "x": 9,
              "y": -9
            },
            "posSlab": {
              "x": 42,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "lefttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "d26a05e9-2c50-4b41-bc03-65c90b3619a5",
            "x": 33,
            "y": -9,
            "pos": {
              "x": 33,
              "y": -9
            },
            "posSlab": {
              "x": 42,
              "y": 24
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "righttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "4458c4b3-ea91-495b-9d02-7f83da73da0e",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "2bf979f2-51a4-48a9-8735-fe50548b2dbd",
          "from": {
            "id": "d26a05e9-2c50-4b41-bc03-65c90b3619a5",
            "x": 33,
            "y": -9,
            "pos": {
              "x": 33,
              "y": -9
            },
            "posSlab": {
              "x": 42,
              "y": 24
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "righttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "94e21842-2e66-4bac-ac94-e80bb93295e8",
            "x": 33,
            "y": 33,
            "pos": {
              "x": 33,
              "y": 33
            },
            "posSlab": {
              "x": 0,
              "y": 24
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "rightbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "0a309a2b-ac3f-4983-b7cf-3f4d9e3a8e20",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "d93a1304-5f3e-46e1-b300-d77e08a893ac",
          "from": {
            "id": "94e21842-2e66-4bac-ac94-e80bb93295e8",
            "x": 33,
            "y": 33,
            "pos": {
              "x": 33,
              "y": 33
            },
            "posSlab": {
              "x": 0,
              "y": 24
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "rightbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "9ef4552e-0f22-4cf5-bb4b-bd9a82f54c03",
            "x": 9,
            "y": 33,
            "pos": {
              "x": 9,
              "y": 33
            },
            "posSlab": {
              "x": 0,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "leftbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "84a54d5b-11b5-4ef1-9f34-ddcb37c104c6",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        }
      ],
      "shapeType": "square",
      "rotatedDegrees": 90,
      "rotatedDegreesSlab": 0,
      "partId": "lower_cabinet_boxes",
      "qtCatName": "Kitchen",
      "fromLayout": null,
      "squareFeet": 1,
      "quantity": 1,
      "quantitySubParts": {
        "doors": 2,
        "drawers": 2,
        "cabinetDoorsAndDrawersQuantity": 4,
        "cabinetDoorsSQFT": 0,
        "cabinetDoorsLNFT": 0
      },
      "isDisabledInPopup": false,
      "rotateAngleParts": [],
      "isPointsChanged": true,
      "isPositionChanged": true,
      "isResetSlabModePopupWasDisplayed": false,
      "shapeSlab": {
        "absolutePosition": null
      },
      "shapeCabinet": {
        "width": 24,
        "height": 34,
        "depth": 42
      },
      "shapeAbsolute": {
        "absolutePosition": {
          "x": -15.10360360360361,
          "y": 80.68918918918916
        },
        "intersectionPoints": [],
        "snappedWithShape": null,
        "snappedShapeGroup": 21
      },
      "shapeParams": {
        "shapeCabinet": true,
        "canSnap": true,
        "width": 42,
        "height": 34,
        "depth": 24,
        "diamondLength": 0,
        "thirdPartyAR3DMetaData": {
          "ActualDisplayedName": [
            "Bryant SM-B42"
          ],
          "DisplayedName": [
            "Bryant SM-B42"
          ],
          "Width": [
            "42"
          ],
          "Height": [
            "34"
          ],
          "Depth": [
            "24"
          ],
          "SKU": [
            "SM-B42"
          ],
          "Shape": [
            "SM-B42"
          ],
          "DoorStyle": [
            "Bryant"
          ],
          "Door": [
            "2"
          ],
          "Drawer": [
            "2"
          ],
          "filters": {
            "Style": [
              "Bryant"
            ],
            "Width": [
              "42"
            ],
            "Height": [
              "34"
            ],
            "Depth": [
              "24"
            ]
          }
        },
        "shapeLayout": "rectangle"
      },
      "relatedParentFeatureId": 382932419,
      "slabModeCoreParentId": null,
      "parentPartId": "bottom_cabinet",
      "slabParentPartId": null,
      "shouldUseSlabPricing": false,
      "originalPointsCoords": [
        {
          "x": 9,
          "y": 33,
          "z": 34,
          "id": "9ef4552e-0f22-4cf5-bb4b-bd9a82f54c03"
        },
        {
          "x": 9,
          "y": -9,
          "z": 34,
          "id": "a0579193-4329-4cf9-bc66-731daefe4aad"
        },
        {
          "x": 33,
          "y": -9,
          "z": 34,
          "id": "d26a05e9-2c50-4b41-bc03-65c90b3619a5"
        },
        {
          "x": 33,
          "y": 33,
          "z": 34,
          "id": "94e21842-2e66-4bac-ac94-e80bb93295e8"
        }
      ],
      "shouldAddCabinetBox": false,
      "shapeHeight": null
    },
    {
      "pos": {
        "x": 38.41441441441436,
        "y": 25.495495495495472
      },
      "slabPos": {
        "x": -4.603603603603609,
        "y": 37.189189189189165
      },
      "id": 4,
      "featureId": 382499177,
      "features": [
        {
          "featureId": 382499177,
          "partId": "lower_cabinet_boxes"
        },
        {
          "featureId": 382932419,
          "partId": "bottom_cabinet"
        }
      ],
      "colorSet": null,
      "isHidden": false,
      "shapePieces": [],
      "seamCutPointsAndLines": [],
      "shapeParentId": null,
      "lines": [
        {
          "id": "38b26dce-3cc4-488a-b3a6-9d0077abe6b8",
          "from": {
            "id": "44adcf7e-e03c-4078-9b85-8059a5972a53",
            "x": 0,
            "y": 0,
            "pos": {
              "x": 0,
              "y": 0
            },
            "posSlab": {
              "x": 0,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "lefttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "fd92d491-6260-49fa-91f8-3fecb202b14f",
            "x": 42,
            "y": 0,
            "pos": {
              "x": 42,
              "y": 0
            },
            "posSlab": {
              "x": 42,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "righttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "81ed1f84-3034-4f92-ab44-d0326ebdb105",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "e7b37c60-3239-4588-9902-ca8008b36a07",
          "from": {
            "id": "fd92d491-6260-49fa-91f8-3fecb202b14f",
            "x": 42,
            "y": 0,
            "pos": {
              "x": 42,
              "y": 0
            },
            "posSlab": {
              "x": 42,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "righttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "448ec928-feb9-43bf-8e3a-d9076bbc827f",
            "x": 42,
            "y": 24,
            "pos": {
              "x": 42,
              "y": 24
            },
            "posSlab": {
              "x": 42,
              "y": 24
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "rightbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "213cccd5-7889-49b2-b340-b0f9549afed5",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "ee9a5da1-b892-4b00-916e-5ad20ff6b100",
          "from": {
            "id": "448ec928-feb9-43bf-8e3a-d9076bbc827f",
            "x": 42,
            "y": 24,
            "pos": {
              "x": 42,
              "y": 24
            },
            "posSlab": {
              "x": 42,
              "y": 24
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "rightbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "da44ece8-1c4e-4ec6-8f4b-a42a9670402f",
            "x": 0,
            "y": 24,
            "pos": {
              "x": 0,
              "y": 24
            },
            "posSlab": {
              "x": 0,
              "y": 24
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "leftbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "a54f74dd-78bb-41af-9aee-e72b3a2a5dfc",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "1448cbe8-c171-4d1b-9708-e5f1dab73a75",
          "from": {
            "id": "da44ece8-1c4e-4ec6-8f4b-a42a9670402f",
            "x": 0,
            "y": 24,
            "pos": {
              "x": 0,
              "y": 24
            },
            "posSlab": {
              "x": 0,
              "y": 24
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "leftbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "44adcf7e-e03c-4078-9b85-8059a5972a53",
            "x": 0,
            "y": 0,
            "pos": {
              "x": 0,
              "y": 0
            },
            "posSlab": {
              "x": 0,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "lefttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "404ff619-a8eb-476f-ab19-ccab32b69ebc",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        }
      ],
      "shapeType": "square",
      "rotatedDegrees": 0,
      "rotatedDegreesSlab": 0,
      "partId": "lower_cabinet_boxes",
      "qtCatName": "Kitchen",
      "fromLayout": null,
      "squareFeet": 1,
      "quantity": 1,
      "quantitySubParts": {
        "doors": 2,
        "drawers": 2,
        "cabinetDoorsAndDrawersQuantity": 4,
        "cabinetDoorsSQFT": 0,
        "cabinetDoorsLNFT": 0
      },
      "isDisabledInPopup": false,
      "rotateAngleParts": [],
      "isPointsChanged": true,
      "isPositionChanged": true,
      "isResetSlabModePopupWasDisplayed": false,
      "shapeSlab": {
        "absolutePosition": null
      },
      "shapeCabinet": {
        "width": 42,
        "height": 34,
        "depth": 24
      },
      "shapeAbsolute": {
        "absolutePosition": {
          "x": 38.896396396396376,
          "y": 26.68918918918917
        },
        "intersectionPoints": [],
        "snappedWithShape": null,
        "snappedShapeGroup": 21
      },
      "shapeParams": {
        "shapeCabinet": true,
        "canSnap": true,
        "width": 42,
        "height": 34,
        "depth": 24,
        "diamondLength": 0,
        "thirdPartyAR3DMetaData": {
          "ActualDisplayedName": [
            "Bryant SM-B42"
          ],
          "DisplayedName": [
            "Bryant SM-B42"
          ],
          "Width": [
            "42"
          ],
          "Height": [
            "34"
          ],
          "Depth": [
            "24"
          ],
          "SKU": [
            "SM-B42"
          ],
          "Shape": [
            "SM-B42"
          ],
          "DoorStyle": [
            "Bryant"
          ],
          "Door": [
            "2"
          ],
          "Drawer": [
            "2"
          ],
          "filters": {
            "Style": [
              "Bryant"
            ],
            "Width": [
              "42"
            ],
            "Height": [
              "34"
            ],
            "Depth": [
              "24"
            ]
          }
        },
        "shapeLayout": "rectangle"
      },
      "relatedParentFeatureId": 382932419,
      "slabModeCoreParentId": null,
      "parentPartId": "bottom_cabinet",
      "slabParentPartId": null,
      "shouldUseSlabPricing": false,
      "originalPointsCoords": [
        {
          "x": 0,
          "y": 0,
          "z": 34,
          "id": "44adcf7e-e03c-4078-9b85-8059a5972a53"
        },
        {
          "x": 42,
          "y": 0,
          "z": 34,
          "id": "fd92d491-6260-49fa-91f8-3fecb202b14f"
        },
        {
          "x": 42,
          "y": 24,
          "z": 34,
          "id": "448ec928-feb9-43bf-8e3a-d9076bbc827f"
        },
        {
          "x": 0,
          "y": 24,
          "z": 34,
          "id": "da44ece8-1c4e-4ec6-8f4b-a42a9670402f"
        }
      ],
      "shouldAddCabinetBox": false,
      "shapeHeight": null
    },
    {
      "pos": {
        "x": -18.10360360360361,
        "y": 101.68918918918916
      },
      "slabPos": {
        "x": 44.66666666666668,
        "y": 90.00000000000001
      },
      "id": 5,
      "featureId": 382499168,
      "features": [
        {
          "featureId": 382499168,
          "partId": "upper_cabinet_boxes"
        },
        {
          "featureId": 382932526,
          "partId": "top_cabinet"
        }
      ],
      "colorSet": null,
      "isHidden": false,
      "shapePieces": [],
      "seamCutPointsAndLines": [],
      "shapeParentId": null,
      "lines": [
        {
          "id": "d3912f65-1bc3-46fc-af02-d2e84f569cb0",
          "from": {
            "id": "3f2c46c1-a1e9-4f66-a582-3e35879c84e5",
            "x": 12,
            "y": 24,
            "pos": {
              "x": 12,
              "y": 24
            },
            "posSlab": {
              "x": 0,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "leftbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "b6b87dc1-147b-4073-b7c1-b7dc27934d2e",
            "x": 12,
            "y": -12,
            "pos": {
              "x": 12,
              "y": -12
            },
            "posSlab": {
              "x": 36,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "lefttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "059a6368-b8bf-44a0-b6c3-1e28fc0c63f5",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "1d9b203c-47ae-4f1c-bd79-76654e51a945",
          "from": {
            "id": "b6b87dc1-147b-4073-b7c1-b7dc27934d2e",
            "x": 12,
            "y": -12,
            "pos": {
              "x": 12,
              "y": -12
            },
            "posSlab": {
              "x": 36,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "lefttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "45b86a09-38d8-4cbe-bff5-58726cdc4e48",
            "x": 24,
            "y": -12,
            "pos": {
              "x": 24,
              "y": -12
            },
            "posSlab": {
              "x": 36,
              "y": 12
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "righttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "0ed5c322-4679-47a1-87d6-270620e48f27",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "f1d9b483-75dd-4277-98a1-03d1fae1591a",
          "from": {
            "id": "45b86a09-38d8-4cbe-bff5-58726cdc4e48",
            "x": 24,
            "y": -12,
            "pos": {
              "x": 24,
              "y": -12
            },
            "posSlab": {
              "x": 36,
              "y": 12
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "righttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "a748b138-df4c-416b-8712-81947d6fe86d",
            "x": 24,
            "y": 24,
            "pos": {
              "x": 24,
              "y": 24
            },
            "posSlab": {
              "x": 0,
              "y": 12
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "rightbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "3f7a5aa4-d03b-4d12-9612-2d3efe1ca927",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "71ca89b3-1d14-45f8-b707-d86eddd14a4d",
          "from": {
            "id": "a748b138-df4c-416b-8712-81947d6fe86d",
            "x": 24,
            "y": 24,
            "pos": {
              "x": 24,
              "y": 24
            },
            "posSlab": {
              "x": 0,
              "y": 12
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "rightbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "3f2c46c1-a1e9-4f66-a582-3e35879c84e5",
            "x": 12,
            "y": 24,
            "pos": {
              "x": 12,
              "y": 24
            },
            "posSlab": {
              "x": 0,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "leftbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "a52f8d15-70bf-48ea-a26b-62988a9480a1",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        }
      ],
      "shapeType": "square",
      "rotatedDegrees": 90,
      "rotatedDegreesSlab": 0,
      "partId": "upper_cabinet_boxes",
      "qtCatName": "Kitchen",
      "fromLayout": null,
      "squareFeet": 1,
      "quantity": 1,
      "quantitySubParts": {
        "doors": 2,
        "drawers": 0,
        "cabinetDoorsAndDrawersQuantity": 2,
        "cabinetDoorsSQFT": 0,
        "cabinetDoorsLNFT": 0
      },
      "isDisabledInPopup": false,
      "rotateAngleParts": [],
      "isPointsChanged": true,
      "isPositionChanged": true,
      "isResetSlabModePopupWasDisplayed": false,
      "shapeSlab": {
        "absolutePosition": null
      },
      "shapeCabinet": {
        "width": 12,
        "height": 42,
        "depth": 36
      },
      "shapeAbsolute": {
        "absolutePosition": {
          "x": -18.10360360360361,
          "y": 101.68918918918916
        },
        "intersectionPoints": [],
        "snappedWithShape": null,
        "snappedShapeGroup": 21
      },
      "shapeParams": {
        "shapeCabinet": true,
        "canSnap": true,
        "width": 36,
        "height": 42,
        "depth": 12,
        "diamondLength": 0,
        "thirdPartyAR3DMetaData": {
          "ActualDisplayedName": [
            "Bryant SM-W3642"
          ],
          "DisplayedName": [
            "Bryant SM-W3642"
          ],
          "Width": [
            "36"
          ],
          "Height": [
            "42"
          ],
          "Depth": [
            "12"
          ],
          "SKU": [
            "SM-W3642"
          ],
          "Shape": [
            "SM-W3642"
          ],
          "DoorStyle": [
            "Bryant"
          ],
          "Door": [
            "2"
          ],
          "Drawer": [
            "0"
          ],
          "filters": {
            "Style": [
              "Bryant"
            ],
            "Width": [
              "36"
            ],
            "Height": [
              "42"
            ],
            "Depth": [
              "12"
            ]
          }
        },
        "shapeLayout": "rectangle"
      },
      "relatedParentFeatureId": 382932526,
      "slabModeCoreParentId": null,
      "parentPartId": "top_cabinet",
      "slabParentPartId": null,
      "shouldUseSlabPricing": false,
      "originalPointsCoords": [
        {
          "x": 12,
          "y": 24,
          "z": 42,
          "id": "3f2c46c1-a1e9-4f66-a582-3e35879c84e5"
        },
        {
          "x": 12,
          "y": -12,
          "z": 42,
          "id": "b6b87dc1-147b-4073-b7c1-b7dc27934d2e"
        },
        {
          "x": 24,
          "y": -12,
          "z": 42,
          "id": "45b86a09-38d8-4cbe-bff5-58726cdc4e48"
        },
        {
          "x": 24,
          "y": 24,
          "z": 42,
          "id": "a748b138-df4c-416b-8712-81947d6fe86d"
        }
      ],
      "shouldAddCabinetBox": false,
      "shapeHeight": null
    },
    {
      "pos": {
        "x": 86.33333333333339,
        "y": 24.66666666666668
      },
      "slabPos": {
        "x": 38.66666666666668,
        "y": 90.00000000000001
      },
      "id": 6,
      "featureId": 382994627,
      "features": [
        {
          "featureId": 382994627,
          "partId": "upper_cabinet_boxes"
        },
        {
          "featureId": 382932526,
          "partId": "top_cabinet"
        }
      ],
      "colorSet": null,
      "isHidden": false,
      "shapePieces": [],
      "seamCutPointsAndLines": [],
      "shapeParentId": null,
      "lines": [
        {
          "id": "28c4d044-0888-43d3-a99b-a07210e9e514",
          "from": {
            "id": "d8ebf8a5-f35f-43f0-bc1b-69818c263681",
            "x": 0,
            "y": 0,
            "pos": {
              "x": 0,
              "y": 0
            },
            "posSlab": {
              "x": 0,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "lefttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "5a53e198-0750-414b-813c-041c97ec9317",
            "x": 48,
            "y": 0,
            "pos": {
              "x": 48,
              "y": 0
            },
            "posSlab": {
              "x": 48,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "righttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "c9556759-9d58-40b0-8b17-6c10075e6113",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "282c23a4-385b-4f53-b03d-6530c0bd7647",
          "from": {
            "id": "5a53e198-0750-414b-813c-041c97ec9317",
            "x": 48,
            "y": 0,
            "pos": {
              "x": 48,
              "y": 0
            },
            "posSlab": {
              "x": 48,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "righttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "7f09b4eb-4155-465e-ab35-9205642308e4",
            "x": 48,
            "y": 12,
            "pos": {
              "x": 48,
              "y": 12
            },
            "posSlab": {
              "x": 48,
              "y": 12
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "rightbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "33208f9a-5f43-4666-bf66-99e33d14d2ee",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "fe59333d-73d4-4652-bdb2-c9a83426cbab",
          "from": {
            "id": "7f09b4eb-4155-465e-ab35-9205642308e4",
            "x": 48,
            "y": 12,
            "pos": {
              "x": 48,
              "y": 12
            },
            "posSlab": {
              "x": 48,
              "y": 12
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "rightbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "a61bb1e7-74ae-4e53-9fbe-c92e598da1bb",
            "x": 0,
            "y": 12,
            "pos": {
              "x": 0,
              "y": 12
            },
            "posSlab": {
              "x": 0,
              "y": 12
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "leftbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "9e16e728-dcad-4d70-86d7-4b7b6fbb1ffb",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "6292b4d5-9787-4784-8b22-6580aeb884d3",
          "from": {
            "id": "a61bb1e7-74ae-4e53-9fbe-c92e598da1bb",
            "x": 0,
            "y": 12,
            "pos": {
              "x": 0,
              "y": 12
            },
            "posSlab": {
              "x": 0,
              "y": 12
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "leftbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "d8ebf8a5-f35f-43f0-bc1b-69818c263681",
            "x": 0,
            "y": 0,
            "pos": {
              "x": 0,
              "y": 0
            },
            "posSlab": {
              "x": 0,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "lefttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "6957bb5e-5176-4ea0-b10c-372ebac7e25b",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        }
      ],
      "shapeType": "square",
      "rotatedDegrees": 0,
      "rotatedDegreesSlab": 0,
      "partId": "upper_cabinet_boxes",
      "qtCatName": "Kitchen",
      "fromLayout": null,
      "squareFeet": 1,
      "quantity": 1,
      "quantitySubParts": {
        "doors": 2,
        "drawers": 0,
        "cabinetDoorsAndDrawersQuantity": 2,
        "cabinetDoorsSQFT": 0,
        "cabinetDoorsLNFT": 0
      },
      "isDisabledInPopup": false,
      "rotateAngleParts": [],
      "isPointsChanged": true,
      "isPositionChanged": true,
      "isResetSlabModePopupWasDisplayed": false,
      "shapeSlab": {
        "absolutePosition": null
      },
      "shapeCabinet": {
        "width": 48,
        "height": 12,
        "depth": 12
      },
      "shapeAbsolute": {
        "absolutePosition": {
          "x": 86.8963963963964,
          "y": 26.689189189189168
        },
        "intersectionPoints": [],
        "snappedWithShape": null,
        "snappedShapeGroup": 21
      },
      "shapeParams": {
        "shapeCabinet": true,
        "canSnap": true,
        "width": 48,
        "height": 12,
        "depth": 12,
        "diamondLength": 0,
        "thirdPartyAR3DMetaData": {
          "ActualDisplayedName": [
            "Bryant H4812"
          ],
          "DisplayedName": [
            "Bryant H4812"
          ],
          "Width": [
            "48"
          ],
          "Height": [
            "12"
          ],
          "Depth": [
            "12"
          ],
          "SKU": [
            "H4812"
          ],
          "Shape": [
            "H4812"
          ],
          "DoorStyle": [
            "Bryant"
          ],
          "Door": [
            "2"
          ],
          "Drawer": [
            "0"
          ],
          "Category": [
            "Hood"
          ],
          "filters": {
            "Style": [
              "Bryant"
            ],
            "Width": [
              "48"
            ],
            "Height": [
              "12"
            ],
            "Depth": [
              "12"
            ]
          }
        },
        "shapeLayout": "rectangle"
      },
      "relatedParentFeatureId": 382932526,
      "slabModeCoreParentId": null,
      "parentPartId": "top_cabinet",
      "slabParentPartId": null,
      "shouldUseSlabPricing": false,
      "originalPointsCoords": [
        {
          "x": 0,
          "y": 0,
          "z": 12,
          "id": "d8ebf8a5-f35f-43f0-bc1b-69818c263681"
        },
        {
          "x": 48,
          "y": 0,
          "z": 12,
          "id": "5a53e198-0750-414b-813c-041c97ec9317"
        },
        {
          "x": 48,
          "y": 12,
          "z": 12,
          "id": "7f09b4eb-4155-465e-ab35-9205642308e4"
        },
        {
          "x": 0,
          "y": 12,
          "z": 12,
          "id": "a61bb1e7-74ae-4e53-9fbe-c92e598da1bb"
        }
      ],
      "shouldAddCabinetBox": false,
      "shapeHeight": null
    },
    {
      "pos": {
        "x": 50.00000000000001,
        "y": 25.99999999999999
      },
      "slabPos": {
        "x": 44.66666666666668,
        "y": 90.00000000000001
      },
      "id": 7,
      "featureId": 382499172,
      "features": [
        {
          "featureId": 382499172,
          "partId": "upper_cabinet_boxes"
        },
        {
          "featureId": 382932526,
          "partId": "top_cabinet"
        }
      ],
      "colorSet": null,
      "isHidden": false,
      "shapePieces": [],
      "seamCutPointsAndLines": [],
      "shapeParentId": null,
      "lines": [
        {
          "id": "137ed60a-7ea4-4e72-842c-4644d4f985fa",
          "from": {
            "id": "0c6a4916-b2b4-49c0-8f90-eea1bd833447",
            "x": 0,
            "y": 0,
            "pos": {
              "x": 0,
              "y": 0
            },
            "posSlab": {
              "x": 0,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "lefttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "5621d643-9be0-4fa3-bea4-a904fa8d0122",
            "x": 36,
            "y": 0,
            "pos": {
              "x": 36,
              "y": 0
            },
            "posSlab": {
              "x": 36,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "righttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "96492edc-cd7f-4eb3-a615-5d71b1f63ae5",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "af7b0c69-d2b6-479b-a0e4-1a31cf4ebb8d",
          "from": {
            "id": "5621d643-9be0-4fa3-bea4-a904fa8d0122",
            "x": 36,
            "y": 0,
            "pos": {
              "x": 36,
              "y": 0
            },
            "posSlab": {
              "x": 36,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "righttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "7780e74c-8488-43b1-952c-25947c2166c9",
            "x": 36,
            "y": 12,
            "pos": {
              "x": 36,
              "y": 12
            },
            "posSlab": {
              "x": 36,
              "y": 12
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "rightbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "3517d9e3-1c4a-495b-942b-4c8e3ce3a0b7",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "e7fc75f5-7ff1-4009-bebb-a4d3a26fb617",
          "from": {
            "id": "7780e74c-8488-43b1-952c-25947c2166c9",
            "x": 36,
            "y": 12,
            "pos": {
              "x": 36,
              "y": 12
            },
            "posSlab": {
              "x": 36,
              "y": 12
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "rightbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "3a5d2ef4-18b9-4732-bc53-c6b62d06105b",
            "x": 0,
            "y": 12,
            "pos": {
              "x": 0,
              "y": 12
            },
            "posSlab": {
              "x": 0,
              "y": 12
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "leftbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "be9b128c-9e3b-4ea4-b099-476abb08af0d",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "cd5f9b84-d538-4d3c-a1fb-ceab82281625",
          "from": {
            "id": "3a5d2ef4-18b9-4732-bc53-c6b62d06105b",
            "x": 0,
            "y": 12,
            "pos": {
              "x": 0,
              "y": 12
            },
            "posSlab": {
              "x": 0,
              "y": 12
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "leftbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "0c6a4916-b2b4-49c0-8f90-eea1bd833447",
            "x": 0,
            "y": 0,
            "pos": {
              "x": 0,
              "y": 0
            },
            "posSlab": {
              "x": 0,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "lefttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "af941f74-2f04-4b3b-8e3f-999ca73760f9",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        }
      ],
      "shapeType": "square",
      "rotatedDegrees": 0,
      "rotatedDegreesSlab": 0,
      "partId": "upper_cabinet_boxes",
      "qtCatName": "Kitchen",
      "fromLayout": null,
      "squareFeet": 1,
      "quantity": 1,
      "quantitySubParts": {
        "doors": 2,
        "drawers": 0,
        "cabinetDoorsAndDrawersQuantity": 2,
        "cabinetDoorsSQFT": 0,
        "cabinetDoorsLNFT": 0
      },
      "isDisabledInPopup": false,
      "rotateAngleParts": [],
      "isPointsChanged": true,
      "isPositionChanged": true,
      "isResetSlabModePopupWasDisplayed": false,
      "shapeSlab": {
        "absolutePosition": null
      },
      "shapeCabinet": {
        "width": 36,
        "height": 36,
        "depth": 12
      },
      "shapeAbsolute": {
        "absolutePosition": {
          "x": 50.8963963963964,
          "y": 26.68918918918917
        },
        "intersectionPoints": [],
        "snappedWithShape": null,
        "snappedShapeGroup": 21
      },
      "shapeParams": {
        "shapeCabinet": true,
        "canSnap": true,
        "width": 36,
        "height": 36,
        "depth": 12,
        "diamondLength": 0,
        "thirdPartyAR3DMetaData": {
          "ActualDisplayedName": [
            "Bryant SM-W3636"
          ],
          "DisplayedName": [
            "Bryant SM-W3636"
          ],
          "Width": [
            "36"
          ],
          "Height": [
            "36"
          ],
          "Depth": [
            "12"
          ],
          "SKU": [
            "SM-W3636"
          ],
          "Shape": [
            "SM-W3636"
          ],
          "DoorStyle": [
            "Bryant"
          ],
          "Door": [
            "2"
          ],
          "Drawer": [
            "0"
          ],
          "filters": {
            "Style": [
              "Bryant"
            ],
            "Width": [
              "36"
            ],
            "Height": [
              "36"
            ],
            "Depth": [
              "12"
            ]
          }
        },
        "shapeLayout": "rectangle"
      },
      "relatedParentFeatureId": 382932526,
      "slabModeCoreParentId": null,
      "parentPartId": "top_cabinet",
      "slabParentPartId": null,
      "shouldUseSlabPricing": false,
      "originalPointsCoords": [
        {
          "x": 0,
          "y": 0,
          "z": 36,
          "id": "0c6a4916-b2b4-49c0-8f90-eea1bd833447"
        },
        {
          "x": 36,
          "y": 0,
          "z": 36,
          "id": "5621d643-9be0-4fa3-bea4-a904fa8d0122"
        },
        {
          "x": 36,
          "y": 12,
          "z": 36,
          "id": "7780e74c-8488-43b1-952c-25947c2166c9"
        },
        {
          "x": 0,
          "y": 12,
          "z": 36,
          "id": "3a5d2ef4-18b9-4732-bc53-c6b62d06105b"
        }
      ],
      "shouldAddCabinetBox": false,
      "shapeHeight": null
    },
    {
      "pos": {
        "x": -18.10360360360361,
        "y": 65.68918918918916
      },
      "slabPos": {
        "x": 44.66666666666668,
        "y": 90.00000000000001
      },
      "id": 8,
      "featureId": 382499174,
      "features": [
        {
          "featureId": 382499174,
          "partId": "upper_cabinet_boxes"
        },
        {
          "featureId": 382932526,
          "partId": "top_cabinet"
        }
      ],
      "colorSet": null,
      "isHidden": false,
      "shapePieces": [],
      "seamCutPointsAndLines": [],
      "shapeParentId": null,
      "lines": [
        {
          "id": "f95e9102-44ee-4fe1-b4c5-347ce109b09f",
          "from": {
            "id": "772fad2d-4a36-470c-91c0-8b70f29009ee",
            "x": 12,
            "y": 24,
            "pos": {
              "x": 12,
              "y": 24
            },
            "posSlab": {
              "x": 0,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "leftbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "6961280f-969f-4447-8803-c943f26b5dc6",
            "x": 12,
            "y": -12,
            "pos": {
              "x": 12,
              "y": -12
            },
            "posSlab": {
              "x": 36,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "lefttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "4db5e7a6-31d1-48bc-b580-83a3a3bcaa87",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "7b25745d-abcd-4dab-b7fe-7b8128eb22df",
          "from": {
            "id": "6961280f-969f-4447-8803-c943f26b5dc6",
            "x": 12,
            "y": -12,
            "pos": {
              "x": 12,
              "y": -12
            },
            "posSlab": {
              "x": 36,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "lefttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "84f0b568-1e55-45eb-b29e-4cffce851317",
            "x": 24,
            "y": -12,
            "pos": {
              "x": 24,
              "y": -12
            },
            "posSlab": {
              "x": 36,
              "y": 12
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "righttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "e7eb7c74-b112-4aea-9041-756f0157301d",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "690f55da-d810-4953-9e0e-f5d9532c4ab0",
          "from": {
            "id": "84f0b568-1e55-45eb-b29e-4cffce851317",
            "x": 24,
            "y": -12,
            "pos": {
              "x": 24,
              "y": -12
            },
            "posSlab": {
              "x": 36,
              "y": 12
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "righttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "bbb2bd3b-2404-4120-a63b-7480d66fff88",
            "x": 24,
            "y": 24,
            "pos": {
              "x": 24,
              "y": 24
            },
            "posSlab": {
              "x": 0,
              "y": 12
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "rightbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "6ae1e607-cbcc-4435-8fec-4af8e9b3fcad",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "55f1f8d1-f9c1-4447-bf59-33a63b4cc955",
          "from": {
            "id": "bbb2bd3b-2404-4120-a63b-7480d66fff88",
            "x": 24,
            "y": 24,
            "pos": {
              "x": 24,
              "y": 24
            },
            "posSlab": {
              "x": 0,
              "y": 12
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "rightbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "772fad2d-4a36-470c-91c0-8b70f29009ee",
            "x": 12,
            "y": 24,
            "pos": {
              "x": 12,
              "y": 24
            },
            "posSlab": {
              "x": 0,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "leftbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "2e71d25c-e1b4-4aa4-924a-62d3db24f875",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        }
      ],
      "shapeType": "square",
      "rotatedDegrees": 90,
      "rotatedDegreesSlab": 0,
      "partId": "upper_cabinet_boxes",
      "qtCatName": "Kitchen",
      "fromLayout": null,
      "squareFeet": 1,
      "quantity": 1,
      "quantitySubParts": {
        "doors": 1,
        "drawers": 0,
        "cabinetDoorsAndDrawersQuantity": 1,
        "cabinetDoorsSQFT": 0,
        "cabinetDoorsLNFT": 0
      },
      "isDisabledInPopup": false,
      "rotateAngleParts": [],
      "isPointsChanged": true,
      "isPositionChanged": true,
      "isResetSlabModePopupWasDisplayed": false,
      "shapeSlab": {
        "absolutePosition": null
      },
      "shapeCabinet": {
        "width": 12,
        "height": 30,
        "depth": 36
      },
      "shapeAbsolute": {
        "absolutePosition": {
          "x": -18.10360360360361,
          "y": 65.68918918918916
        },
        "intersectionPoints": [],
        "snappedWithShape": null,
        "snappedShapeGroup": 21
      },
      "shapeParams": {
        "shapeCabinet": true,
        "canSnap": true,
        "width": 36,
        "height": 30,
        "depth": 12,
        "diamondLength": 0,
        "thirdPartyAR3DMetaData": {
          "ActualDisplayedName": [
            "Bryant SW-WBC3630"
          ],
          "DisplayedName": [
            "Bryant SW-WBC3630"
          ],
          "Width": [
            "36"
          ],
          "Height": [
            "30"
          ],
          "Depth": [
            "12"
          ],
          "SKU": [
            "SW-WBC3630"
          ],
          "Shape": [
            "SW-WBC3630"
          ],
          "DoorStyle": [
            "Bryant"
          ],
          "Door": [
            "1"
          ],
          "Drawer": [
            "0"
          ],
          "filters": {
            "Style": [
              "Bryant"
            ],
            "Width": [
              "36"
            ],
            "Height": [
              "30"
            ],
            "Depth": [
              "12"
            ]
          }
        },
        "shapeLayout": "rectangle"
      },
      "relatedParentFeatureId": 382932526,
      "slabModeCoreParentId": null,
      "parentPartId": "top_cabinet",
      "slabParentPartId": null,
      "shouldUseSlabPricing": false,
      "originalPointsCoords": [
        {
          "x": 12,
          "y": 24,
          "z": 30,
          "id": "772fad2d-4a36-470c-91c0-8b70f29009ee"
        },
        {
          "x": 12,
          "y": -12,
          "z": 30,
          "id": "6961280f-969f-4447-8803-c943f26b5dc6"
        },
        {
          "x": 24,
          "y": -12,
          "z": 30,
          "id": "84f0b568-1e55-45eb-b29e-4cffce851317"
        },
        {
          "x": 24,
          "y": 24,
          "z": 30,
          "id": "bbb2bd3b-2404-4120-a63b-7480d66fff88"
        }
      ],
      "shouldAddCabinetBox": false,
      "shapeHeight": null
    },
    {
      "pos": {
        "x": 18.333333333333353,
        "y": 25.999999999999996
      },
      "slabPos": {
        "x": 47.66666666666668,
        "y": 90.00000000000001
      },
      "id": 9,
      "featureId": 382499162,
      "features": [
        {
          "featureId": 382499162,
          "partId": "upper_cabinet_boxes"
        },
        {
          "featureId": 382932526,
          "partId": "top_cabinet"
        }
      ],
      "colorSet": null,
      "isHidden": false,
      "shapePieces": [],
      "seamCutPointsAndLines": [],
      "shapeParentId": null,
      "lines": [
        {
          "id": "9faee721-11a1-4977-ad87-77829f08b09b",
          "from": {
            "id": "ce31bc03-a4a9-4517-a1ea-9d5d34a3e8ba",
            "x": 0,
            "y": 0,
            "pos": {
              "x": 0,
              "y": 0
            },
            "posSlab": {
              "x": 0,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "lefttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "8b00f21f-6581-487c-a9fb-881e40ae7b41",
            "x": 30,
            "y": 0,
            "pos": {
              "x": 30,
              "y": 0
            },
            "posSlab": {
              "x": 30,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "righttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "5d7b417c-77ce-4b84-a99f-f49a87e05154",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "a3104a78-398e-4a3a-beff-88705f7a43c4",
          "from": {
            "id": "8b00f21f-6581-487c-a9fb-881e40ae7b41",
            "x": 30,
            "y": 0,
            "pos": {
              "x": 30,
              "y": 0
            },
            "posSlab": {
              "x": 30,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "righttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "b92d0c01-eee9-4703-86c5-2b3037c0f110",
            "x": 30,
            "y": 12,
            "pos": {
              "x": 30,
              "y": 12
            },
            "posSlab": {
              "x": 30,
              "y": 12
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "rightbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "1e22ea04-1a01-4a4d-8328-219258027760",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "55747700-6bd2-4de8-883e-668135aa082e",
          "from": {
            "id": "b92d0c01-eee9-4703-86c5-2b3037c0f110",
            "x": 30,
            "y": 12,
            "pos": {
              "x": 30,
              "y": 12
            },
            "posSlab": {
              "x": 30,
              "y": 12
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "rightbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "bf62b8a2-45c7-42ec-b911-688f42452d19",
            "x": 0,
            "y": 12,
            "pos": {
              "x": 0,
              "y": 12
            },
            "posSlab": {
              "x": 0,
              "y": 12
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "leftbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "2c24bfa0-a2a7-48d4-a0ec-6e5d056c8042",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "6c058918-de76-4157-9e8d-1dedcfecb95a",
          "from": {
            "id": "bf62b8a2-45c7-42ec-b911-688f42452d19",
            "x": 0,
            "y": 12,
            "pos": {
              "x": 0,
              "y": 12
            },
            "posSlab": {
              "x": 0,
              "y": 12
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "leftbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "ce31bc03-a4a9-4517-a1ea-9d5d34a3e8ba",
            "x": 0,
            "y": 0,
            "pos": {
              "x": 0,
              "y": 0
            },
            "posSlab": {
              "x": 0,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "lefttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "9fc42f3e-c903-4ad8-a2d0-59977447bbce",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        }
      ],
      "shapeType": "square",
      "rotatedDegrees": 0,
      "rotatedDegreesSlab": 0,
      "partId": "upper_cabinet_boxes",
      "qtCatName": "Kitchen",
      "fromLayout": null,
      "squareFeet": 1,
      "quantity": 1,
      "quantitySubParts": {
        "doors": 2,
        "drawers": 0,
        "cabinetDoorsAndDrawersQuantity": 2,
        "cabinetDoorsSQFT": 0,
        "cabinetDoorsLNFT": 0
      },
      "isDisabledInPopup": false,
      "rotateAngleParts": [],
      "isPointsChanged": true,
      "isPositionChanged": true,
      "isResetSlabModePopupWasDisplayed": false,
      "shapeSlab": {
        "absolutePosition": null
      },
      "shapeCabinet": {
        "width": 30,
        "height": 36,
        "depth": 12
      },
      "shapeAbsolute": {
        "absolutePosition": {
          "x": 20.89639639639641,
          "y": 26.68918918918917
        },
        "intersectionPoints": [],
        "snappedWithShape": null,
        "snappedShapeGroup": 21
      },
      "shapeParams": {
        "shapeCabinet": true,
        "canSnap": true,
        "width": 30,
        "height": 36,
        "depth": 12,
        "diamondLength": 0,
        "thirdPartyAR3DMetaData": {
          "ActualDisplayedName": [
            "Bryant SM-W3036"
          ],
          "DisplayedName": [
            "Bryant SM-W3036"
          ],
          "Width": [
            "30"
          ],
          "Height": [
            "36"
          ],
          "Depth": [
            "12"
          ],
          "SKU": [
            "SM-W3036"
          ],
          "Shape": [
            "SM-W3036"
          ],
          "DoorStyle": [
            "Bryant"
          ],
          "Door": [
            "2"
          ],
          "Drawer": [
            "0"
          ],
          "filters": {
            "Style": [
              "Bryant"
            ],
            "Width": [
              "30"
            ],
            "Height": [
              "36"
            ],
            "Depth": [
              "12"
            ]
          }
        },
        "shapeLayout": "rectangle"
      },
      "relatedParentFeatureId": 382932526,
      "slabModeCoreParentId": null,
      "parentPartId": "top_cabinet",
      "slabParentPartId": null,
      "shouldUseSlabPricing": false,
      "originalPointsCoords": [
        {
          "x": 0,
          "y": 0,
          "z": 36,
          "id": "ce31bc03-a4a9-4517-a1ea-9d5d34a3e8ba"
        },
        {
          "x": 30,
          "y": 0,
          "z": 36,
          "id": "8b00f21f-6581-487c-a9fb-881e40ae7b41"
        },
        {
          "x": 30,
          "y": 12,
          "z": 36,
          "id": "b92d0c01-eee9-4703-86c5-2b3037c0f110"
        },
        {
          "x": 0,
          "y": 12,
          "z": 36,
          "id": "bf62b8a2-45c7-42ec-b911-688f42452d19"
        }
      ],
      "shouldAddCabinetBox": false,
      "shapeHeight": null
    },
    {
      "pos": {
        "x": -4.4999999999999964,
        "y": 25.833333333333346
      },
      "slabPos": {
        "x": 49.16666666666668,
        "y": 82.50000000000001
      },
      "id": 10,
      "featureId": 382994749,
      "features": [
        {
          "featureId": 382994749,
          "partId": "upper_cabinet_boxes"
        },
        {
          "featureId": 382932526,
          "partId": "top_cabinet"
        }
      ],
      "colorSet": null,
      "isHidden": false,
      "shapePieces": [],
      "seamCutPointsAndLines": [],
      "shapeParentId": null,
      "lines": [
        {
          "id": "5ecfa898-caab-4828-9d19-b53ecac5c898",
          "from": {
            "id": "1b102801-6c34-47d3-b0b9-39b2c210fb1d",
            "x": 6.8326,
            "y": 0,
            "pos": {
              "x": 6.8326,
              "y": 0
            },
            "posSlab": {
              "x": 6.832599999999999,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "8249e866-07f2-46ba-84c9-0edcdd5ac44c",
            "x": 27,
            "y": 0,
            "pos": {
              "x": 27,
              "y": 0
            },
            "posSlab": {
              "x": 27,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "righttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "f31bad6f-c4f2-4f08-8c64-14d307134e02",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "9015cf26-5560-4369-87f6-172d3d6a0fa8",
          "from": {
            "id": "8249e866-07f2-46ba-84c9-0edcdd5ac44c",
            "x": 27,
            "y": 0,
            "pos": {
              "x": 27,
              "y": 0
            },
            "posSlab": {
              "x": 27,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "righttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "f7006142-ab7d-4b16-94c6-a732e0abcba4",
            "x": 27,
            "y": 12,
            "pos": {
              "x": 27,
              "y": 12
            },
            "posSlab": {
              "x": 27,
              "y": 12
            },
            "arcLength": 0,
            "angle": 0,
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "36831f15-d8d7-4429-a3d5-4c3e379a2b39",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "0e094160-2fcb-48ed-810b-56ebf67dee36",
          "from": {
            "id": "f7006142-ab7d-4b16-94c6-a732e0abcba4",
            "x": 27,
            "y": 12,
            "pos": {
              "x": 27,
              "y": 12
            },
            "posSlab": {
              "x": 27,
              "y": 12
            },
            "arcLength": 0,
            "angle": 0,
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "6ddd3262-af98-4116-afac-d89526c1981e",
            "x": 12,
            "y": 27,
            "pos": {
              "x": 12,
              "y": 27
            },
            "posSlab": {
              "x": 12,
              "y": 27
            },
            "arcLength": 0,
            "angle": 0,
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "2ee50c53-8bbc-43b4-b408-89d734f911e3",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "f3ea01de-4e67-4c69-b0dc-d2c13cf1b404",
          "from": {
            "id": "6ddd3262-af98-4116-afac-d89526c1981e",
            "x": 12,
            "y": 27,
            "pos": {
              "x": 12,
              "y": 27
            },
            "posSlab": {
              "x": 12,
              "y": 27
            },
            "arcLength": 0,
            "angle": 0,
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "7df04c53-a917-4201-b1b5-18baa80acfbd",
            "x": 0,
            "y": 27,
            "pos": {
              "x": 0,
              "y": 27
            },
            "posSlab": {
              "x": 0,
              "y": 27
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "leftbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "6cd1ef8a-9598-4b08-9e20-c2fb87ccd8a2",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "eb0923c0-7b67-4d96-9cdd-78bd1dcc260d",
          "from": {
            "id": "7df04c53-a917-4201-b1b5-18baa80acfbd",
            "x": 0,
            "y": 27,
            "pos": {
              "x": 0,
              "y": 27
            },
            "posSlab": {
              "x": 0,
              "y": 27
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "leftbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "d10bc61a-48ad-4b73-ba73-e7142bb8eda5",
            "x": 0,
            "y": 6.8326,
            "pos": {
              "x": 0,
              "y": 6.8326
            },
            "posSlab": {
              "x": 0,
              "y": 6.832599999999999
            },
            "arcLength": 0,
            "angle": 0,
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "87504e97-3a87-463c-ae80-35d372307c39",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "4df389f0-d89c-4341-be9c-dbeb86fbd560",
          "from": {
            "id": "d10bc61a-48ad-4b73-ba73-e7142bb8eda5",
            "x": 0,
            "y": 6.8326,
            "pos": {
              "x": 0,
              "y": 6.8326
            },
            "posSlab": {
              "x": 0,
              "y": 6.832599999999999
            },
            "arcLength": 0,
            "angle": 0,
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "1b102801-6c34-47d3-b0b9-39b2c210fb1d",
            "x": 6.8326,
            "y": 0,
            "pos": {
              "x": 6.8326,
              "y": 0
            },
            "posSlab": {
              "x": 6.832599999999999,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "accb68f3-92c7-4fea-a85e-6965aa73b100",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrlV": null,
            "attachedHandleUrlH": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        }
      ],
      "shapeType": "square",
      "rotatedDegrees": 0,
      "rotatedDegreesSlab": 0,
      "partId": "upper_cabinet_boxes",
      "qtCatName": "Kitchen",
      "fromLayout": null,
      "squareFeet": 1,
      "quantity": 1,
      "quantitySubParts": {
        "doors": 1,
        "drawers": 0,
        "cabinetDoorsAndDrawersQuantity": 1,
        "cabinetDoorsSQFT": 0,
        "cabinetDoorsLNFT": 0
      },
      "isDisabledInPopup": false,
      "rotateAngleParts": [],
      "isPointsChanged": true,
      "isPositionChanged": true,
      "isResetSlabModePopupWasDisplayed": false,
      "shapeSlab": {
        "absolutePosition": null
      },
      "shapeCabinet": {
        "width": 27,
        "height": 42,
        "depth": 27
      },
      "shapeAbsolute": {
        "absolutePosition": {
          "x": -6.1036036036036085,
          "y": 26.689189189189168
        },
        "intersectionPoints": [],
        "snappedWithShape": null,
        "snappedShapeGroup": 21
      },
      "shapeParams": {
        "shapeCabinet": true,
        "canSnap": true,
        "width": 27,
        "height": 42,
        "depth": 12,
        "diamondLength": 20.1674,
        "thirdPartyAR3DMetaData": {
          "ActualDisplayedName": [
            "Bryant DCW2742"
          ],
          "DisplayedName": [
            "Bryant DCW2742"
          ],
          "Width": [
            "27"
          ],
          "Height": [
            "42"
          ],
          "Depth": [
            "12"
          ],
          "SKU": [
            "DCW2742"
          ],
          "Shape": [
            "DCW2742"
          ],
          "DoorStyle": [
            "Bryant"
          ],
          "Door": [
            "1"
          ],
          "Drawer": [
            "0"
          ],
          "SpecialShape": [
            "UpperDimondShape"
          ],
          "DiamondLength": [
            "20.1674in"
          ],
          "filters": {
            "Style": [
              "Bryant"
            ],
            "Width": [
              "27"
            ],
            "Height": [
              "42"
            ],
            "Depth": [
              "12"
            ],
            "DiamondLength": [
              "20.1674in"
            ]
          }
        },
        "shapeLayout": "UpperDimondShape"
      },
      "relatedParentFeatureId": 382932526,
      "slabModeCoreParentId": null,
      "parentPartId": "top_cabinet",
      "slabParentPartId": null,
      "shouldUseSlabPricing": false,
      "originalPointsCoords": [
        {
          "x": 6.8326,
          "y": 0,
          "z": 42,
          "id": "1b102801-6c34-47d3-b0b9-39b2c210fb1d"
        },
        {
          "x": 27,
          "y": 0,
          "z": 42,
          "id": "8249e866-07f2-46ba-84c9-0edcdd5ac44c"
        },
        {
          "x": 27,
          "y": 12,
          "z": 42,
          "id": "f7006142-ab7d-4b16-94c6-a732e0abcba4"
        },
        {
          "x": 12,
          "y": 27,
          "z": 42,
          "id": "6ddd3262-af98-4116-afac-d89526c1981e"
        },
        {
          "x": 0,
          "y": 27,
          "z": 42,
          "id": "7df04c53-a917-4201-b1b5-18baa80acfbd"
        },
        {
          "x": 0,
          "y": 6.8326,
          "z": 42,
          "id": "d10bc61a-48ad-4b73-ba73-e7142bb8eda5"
        }
      ],
      "shouldAddCabinetBox": false,
      "shapeHeight": null
    }
  ],
  "manualCalculate": false,
  "controllers": {
    "walls": [],
    "snappedShapeGroups": [
      0,
      1,
      2,
      3,
      4,
      5,
      6,
      7,
      8,
      9,
      10,
      11,
      12,
      13,
      14,
      15,
      16,
      17,
      18,
      19,
      20,
      21
    ],
    "handles": [],
    "hinge": []
  },
  "underlayment": []
}

export const CABINET_SET3 = {
  "bumpouts": [],
  "canvasImage": "",
  "sqFtSlabImage": "",
  "sqFtSlabCalcImage": "",
  "sqftApplianceImages": "",
  "images3D": "",
  "slabImages": [],
  "measureUnit": "Imperial",
  "sinks": [],
  "radii": [],
  "corners": [],
  "totalInches": 7540.384732531849,
  "shapeLength": 7,
  "objIds": 12,
  "removedFeatures": [],
  "textBoxes": [],
  "slabAdditionalShapesList": [],
  "slabImagesTotalArea": [],
  "squareFeet": 53,
  "countertops": [
    {
      "pos": {
        "x": 77.93333333333332,
        "y": -100.46666666666664
      },
      "slabPos": {
        "x": -21,
        "y": -106.66666666666667
      },
      "id": 12,
      "featureId": 381183142,
      "colorSet": null,
      "isHidden": false,
      "shapePieces": [],
      "seamCutPoints": [],
      "shapeParentId": null,
      "lines": [
        {
          "id": "647a01fa-b2c5-4603-a2bb-a07b78d411ce",
          "from": {
            "id": "7757a1c7-4343-4d9a-9f60-4125938a8d99",
            "x": 0,
            "y": 0,
            "pos": {
              "x": 0,
              "y": 0
            },
            "posSlab": {
              "x": 0,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "lefttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "450bc4f0-4b07-4821-8491-049540b8e489",
            "x": 42,
            "y": 0,
            "pos": {
              "x": 42,
              "y": 0
            },
            "posSlab": {
              "x": 42,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "righttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "13b047b0-7d01-4203-8f21-1d2d53bd4e2f",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrl": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "447973b0-7013-43a1-bd14-cc1c62c93308",
          "from": {
            "id": "450bc4f0-4b07-4821-8491-049540b8e489",
            "x": 42,
            "y": 0,
            "pos": {
              "x": 42,
              "y": 0
            },
            "posSlab": {
              "x": 42,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "righttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "5b6673db-26b9-4abb-a916-7b744fdc54fa",
            "x": 42,
            "y": 24,
            "pos": {
              "x": 42,
              "y": 24
            },
            "posSlab": {
              "x": 42,
              "y": 24
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "rightbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "dbda4393-3a52-4eb0-96b2-c02638e47e84",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrl": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "16d395a2-3c2c-4fe4-bdac-bae16f2fe1b4",
          "from": {
            "id": "5b6673db-26b9-4abb-a916-7b744fdc54fa",
            "x": 42,
            "y": 24,
            "pos": {
              "x": 42,
              "y": 24
            },
            "posSlab": {
              "x": 42,
              "y": 24
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "rightbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "73d327ed-e285-4747-ab65-7b4b3a38e48b",
            "x": 0,
            "y": 24,
            "pos": {
              "x": 0,
              "y": 24
            },
            "posSlab": {
              "x": 0,
              "y": 24
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "leftbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "0e4430a1-9d88-4195-bd50-289e42818b74",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrl": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "a94d91d3-68c3-467d-a93a-7bc9988fb275",
          "from": {
            "id": "73d327ed-e285-4747-ab65-7b4b3a38e48b",
            "x": 0,
            "y": 24,
            "pos": {
              "x": 0,
              "y": 24
            },
            "posSlab": {
              "x": 0,
              "y": 24
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "leftbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "7757a1c7-4343-4d9a-9f60-4125938a8d99",
            "x": 0,
            "y": 0,
            "pos": {
              "x": 0,
              "y": 0
            },
            "posSlab": {
              "x": 0,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "lefttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "37253c2f-03db-40cc-ac71-1a480e531864",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrl": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        }
      ],
      "shapeType": "square",
      "rotatedDegrees": 0,
      "rotatedDegreesSlab": 0,
      "partId": "lower_cabinet_boxes",
      "qtCatName": "Kitchen",
      "fromLayout": null,
      "squareFeet": 1,
      "quantity": 1,
      "isDisabledInPopup": false,
      "rotateAngleParts": [],
      "isPointsChanged": true,
      "isPositionChanged": true,
      "isResetSlabModePopupWasDisplayed": false,
      "shapeSlab": {
        "absolutePosition": null
      },
      "shapeCabinet": {
        "width": 42,
        "height": 34,
        "depth": 24
      },
      "shapeAbsolute": {
        "absolutePosition": {
          "x": 77.93333333333332,
          "y": -100.46666666666664
        },
        "intersectionPoints": [],
        "snappedWithShape": 5,
        "snappedShapeGroup": 31
      },
      "shapeParams": {
        "shapeCabinet": true,
        "canSnap": true,
        "width": 42,
        "height": 34,
        "depth": 24,
        "diamondLength": 0,
        "thirdPartyAR3DMetaData": {
          "ActualDisplayedName": [
            "Hamilton Flat Panel SM-B42"
          ],
          "DisplayedName": [
            "Hamilton Flat Panel SM-B42"
          ],
          "Width": [
            "42"
          ],
          "Height": [
            "34"
          ],
          "Depth": [
            "24"
          ],
          "SKU": [
            "SM-B42"
          ],
          "Shape": [
            "SM-B42"
          ],
          "DoorStyle": [
            "Hamilton Flat Panel"
          ],
          "Door": [
            "2"
          ],
          "Drawer": [
            "2"
          ],
          "filters": {
            "Style": [
              "Hamilton Flat Panel"
            ],
            "Width": [
              "42"
            ],
            "Height": [
              "34"
            ],
            "Depth": [
              "24"
            ]
          }
        },
        "shapeLayout": "rectangle"
      },
      "relatedParentFeatureId": 381762693,
      "slabModeCoreParentId": null,
      "parentPartId": null,
      "slabParentPartId": null,
      "shouldUseSlabPricing": false,
      "originalPointsCoords": [
        {
          "x": 0,
          "y": 0,
          "id": "7757a1c7-4343-4d9a-9f60-4125938a8d99"
        },
        {
          "x": 42,
          "y": 0,
          "id": "450bc4f0-4b07-4821-8491-049540b8e489"
        },
        {
          "x": 42,
          "y": 24,
          "id": "5b6673db-26b9-4abb-a916-7b744fdc54fa"
        },
        {
          "x": 0,
          "y": 24,
          "id": "73d327ed-e285-4747-ab65-7b4b3a38e48b"
        }
      ]
    },
    {
      "pos": {
        "x": 119.93333333333332,
        "y": -100.46666666666664
      },
      "slabPos": {
        "x": 37.5,
        "y": -60.1
      },
      "id": 5,
      "featureId": 381672414,
      "colorSet": null,
      "isHidden": false,
      "shapePieces": [],
      "seamCutPoints": [],
      "shapeParentId": null,
      "lines": [
        {
          "id": "7882938b-fa71-466a-ad7e-1517aeab583b",
          "from": {
            "id": "8329535a-7b11-48b8-941b-fb2397b280ce",
            "x": 0,
            "y": 0,
            "pos": {
              "x": 0,
              "y": 0
            },
            "posSlab": {
              "x": 0,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "5d8d5da8-afd0-441e-8277-aa8b085dfa5d",
            "x": 45,
            "y": 0,
            "pos": {
              "x": 45,
              "y": 0
            },
            "posSlab": {
              "x": 45,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "a5c13d55-cf69-4719-84a7-f4c293c97edd",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrl": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "c67aca45-a645-43c4-99df-2955257ebcd2",
          "from": {
            "id": "5d8d5da8-afd0-441e-8277-aa8b085dfa5d",
            "x": 45,
            "y": 0,
            "pos": {
              "x": 45,
              "y": 0
            },
            "posSlab": {
              "x": 45,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "4792d285-2fe0-4dc7-8cf9-d7dc2866b9a5",
            "x": 45,
            "y": 24,
            "pos": {
              "x": 45,
              "y": 24
            },
            "posSlab": {
              "x": 45,
              "y": 24
            },
            "arcLength": 0,
            "angle": 0,
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "be2a5262-5eba-4288-b07b-4ed2ff4d3145",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrl": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "d4aedcd1-8875-4716-8a0f-16361936749d",
          "from": {
            "id": "4792d285-2fe0-4dc7-8cf9-d7dc2866b9a5",
            "x": 45,
            "y": 24,
            "pos": {
              "x": 45,
              "y": 24
            },
            "posSlab": {
              "x": 45,
              "y": 24
            },
            "arcLength": 0,
            "angle": 0,
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "7d4f9cdd-1a7e-44a5-879f-44068e01e4f1",
            "x": 24,
            "y": 24,
            "pos": {
              "x": 24,
              "y": 24
            },
            "posSlab": {
              "x": 24,
              "y": 24
            },
            "arcLength": 0,
            "angle": 0,
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "c714fed9-f24c-4d5e-a06e-6e6b2e949fc2",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrl": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "3c409f1b-74ff-4042-8ad4-5d16d11d3580",
          "from": {
            "id": "7d4f9cdd-1a7e-44a5-879f-44068e01e4f1",
            "x": 24,
            "y": 24,
            "pos": {
              "x": 24,
              "y": 24
            },
            "posSlab": {
              "x": 24,
              "y": 24
            },
            "arcLength": 0,
            "angle": 0,
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "fbffd1f2-c01b-40d7-93a2-eecf6eebf958",
            "x": 24,
            "y": 45,
            "pos": {
              "x": 24,
              "y": 45
            },
            "posSlab": {
              "x": 24,
              "y": 45
            },
            "arcLength": 0,
            "angle": 0,
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "da695b3d-9f91-4bba-9fa4-1cb242afef45",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrl": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "2445f310-99ee-490e-a3ee-373be5aa17e9",
          "from": {
            "id": "fbffd1f2-c01b-40d7-93a2-eecf6eebf958",
            "x": 24,
            "y": 45,
            "pos": {
              "x": 24,
              "y": 45
            },
            "posSlab": {
              "x": 24,
              "y": 45
            },
            "arcLength": 0,
            "angle": 0,
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "a18885db-6594-4e75-a214-15df5ea51f82",
            "x": 0,
            "y": 45,
            "pos": {
              "x": 0,
              "y": 45
            },
            "posSlab": {
              "x": 0,
              "y": 45
            },
            "arcLength": 0,
            "angle": 0,
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "6c9d0041-9c66-48c5-bb4f-117c2d88ed8a",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrl": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "29c6ade2-7972-46b1-89d5-d5ee47620a4d",
          "from": {
            "id": "a18885db-6594-4e75-a214-15df5ea51f82",
            "x": 0,
            "y": 45,
            "pos": {
              "x": 0,
              "y": 45
            },
            "posSlab": {
              "x": 0,
              "y": 45
            },
            "arcLength": 0,
            "angle": 0,
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "8329535a-7b11-48b8-941b-fb2397b280ce",
            "x": 0,
            "y": 0,
            "pos": {
              "x": 0,
              "y": 0
            },
            "posSlab": {
              "x": 0,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "bddde005-44cb-4f3a-9e02-e4ce18508b56",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrl": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        }
      ],
      "shapeType": "square",
      "rotatedDegrees": 0,
      "rotatedDegreesSlab": 0,
      "partId": "lower_cabinet_boxes",
      "qtCatName": "Kitchen",
      "fromLayout": null,
      "squareFeet": 1,
      "quantity": 1,
      "isDisabledInPopup": false,
      "rotateAngleParts": [],
      "isPointsChanged": true,
      "isPositionChanged": true,
      "isResetSlabModePopupWasDisplayed": false,
      "shapeSlab": {
        "absolutePosition": null
      },
      "shapeCabinet": {
        "width": 45,
        "height": 34,
        "depth": 24
      },
      "shapeAbsolute": {
        "absolutePosition": {
          "x": 119.93333333333332,
          "y": -100.46666666666664
        },
        "intersectionPoints": [],
        "snappedWithShape": 12,
        "snappedShapeGroup": 31
      },
      "shapeParams": {
        "shapeCabinet": true,
        "canSnap": true,
        "width": 45,
        "height": 34,
        "depth": 24,
        "diamondLength": 0,
        "thirdPartyAR3DMetaData": {
          "ActualDisplayedName": [
            "Hamilton Flat Panel BBC45-48FHLRB"
          ],
          "DisplayedName": [
            "Hamilton Flat Panel BBC45-48FHLRB"
          ],
          "Width": [
            "45"
          ],
          "Height": [
            "34"
          ],
          "Depth": [
            "24"
          ],
          "SKU": [
            "BBC45-48FHLRB"
          ],
          "Shape": [
            "BBC45-48FHLRB"
          ],
          "DoorStyle": [
            "Hamilton Flat Panel"
          ],
          "Door": [
            "2"
          ],
          "Drawer": [
            "0"
          ],
          "SpecialShape": [
            "LowerLCorner"
          ],
          "filters": {
            "Style": [
              "Hamilton Flat Panel"
            ],
            "Width": [
              "45"
            ],
            "Height": [
              "34"
            ],
            "Depth": [
              "24"
            ]
          }
        },
        "shapeLayout": "LowerLCorner"
      },
      "relatedParentFeatureId": 381762693,
      "slabModeCoreParentId": null,
      "parentPartId": null,
      "slabParentPartId": null,
      "shouldUseSlabPricing": false,
      "originalPointsCoords": [
        {
          "x": 0,
          "y": 0,
          "id": "8329535a-7b11-48b8-941b-fb2397b280ce"
        },
        {
          "x": 45,
          "y": 0,
          "id": "5d8d5da8-afd0-441e-8277-aa8b085dfa5d"
        },
        {
          "x": 45,
          "y": 24,
          "id": "4792d285-2fe0-4dc7-8cf9-d7dc2866b9a5"
        },
        {
          "x": 24,
          "y": 24,
          "id": "7d4f9cdd-1a7e-44a5-879f-44068e01e4f1"
        },
        {
          "x": 24,
          "y": 45,
          "id": "fbffd1f2-c01b-40d7-93a2-eecf6eebf958"
        },
        {
          "x": 0,
          "y": 45,
          "id": "a18885db-6594-4e75-a214-15df5ea51f82"
        }
      ]
    },
    {
      "pos": {
        "x": 38.20000000000003,
        "y": -101.06666666666663
      },
      "slabPos": {
        "x": 39,
        "y": -49.6
      },
      "id": 6,
      "featureId": 381183142,
      "colorSet": null,
      "isHidden": false,
      "shapePieces": [],
      "seamCutPoints": [],
      "shapeParentId": null,
      "lines": [
        {
          "id": "ac535fb8-daba-4237-a079-9c0a9954b91f",
          "from": {
            "id": "c9f4f50e-6454-4f3d-b8af-d7c2b620fe3f",
            "x": 0,
            "y": 0,
            "pos": {
              "x": 0,
              "y": 0
            },
            "posSlab": {
              "x": 0,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "lefttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "4102b6db-3cc7-4c03-ba27-ac7befbc9279",
            "x": 42,
            "y": 0,
            "pos": {
              "x": 42,
              "y": 0
            },
            "posSlab": {
              "x": 42,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "righttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "22915925-981f-4852-ab18-5c98a860e57c",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrl": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "2915c96e-87a9-42fa-bcfa-097e314b068e",
          "from": {
            "id": "4102b6db-3cc7-4c03-ba27-ac7befbc9279",
            "x": 42,
            "y": 0,
            "pos": {
              "x": 42,
              "y": 0
            },
            "posSlab": {
              "x": 42,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "righttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "6c3072f1-d3f3-476a-8d62-6041f21999f6",
            "x": 42,
            "y": 24,
            "pos": {
              "x": 42,
              "y": 24
            },
            "posSlab": {
              "x": 42,
              "y": 24
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "rightbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "0fdaa99c-0c3c-49a3-afb6-d5e5fbb84af8",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrl": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "975a7d08-decb-4044-846f-7cf6ab05534c",
          "from": {
            "id": "6c3072f1-d3f3-476a-8d62-6041f21999f6",
            "x": 42,
            "y": 24,
            "pos": {
              "x": 42,
              "y": 24
            },
            "posSlab": {
              "x": 42,
              "y": 24
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "rightbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "104b7524-8327-4458-a54b-26141bec2eec",
            "x": 0,
            "y": 24,
            "pos": {
              "x": 0,
              "y": 24
            },
            "posSlab": {
              "x": 0,
              "y": 24
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "leftbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "cbd744a8-3640-4fd6-8538-cbb1c609cb77",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrl": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "f4e17ba9-6f1b-4766-bff7-d86602a6f100",
          "from": {
            "id": "104b7524-8327-4458-a54b-26141bec2eec",
            "x": 0,
            "y": 24,
            "pos": {
              "x": 0,
              "y": 24
            },
            "posSlab": {
              "x": 0,
              "y": 24
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "leftbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "c9f4f50e-6454-4f3d-b8af-d7c2b620fe3f",
            "x": 0,
            "y": 0,
            "pos": {
              "x": 0,
              "y": 0
            },
            "posSlab": {
              "x": 0,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "lefttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "2bfe82a8-8e76-4c02-9c4d-2932511ee1e2",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrl": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        }
      ],
      "shapeType": "square",
      "rotatedDegrees": 0,
      "rotatedDegreesSlab": 0,
      "partId": "lower_cabinet_boxes",
      "qtCatName": "Kitchen",
      "fromLayout": null,
      "squareFeet": 1,
      "quantity": 1,
      "isDisabledInPopup": false,
      "rotateAngleParts": [],
      "isPointsChanged": true,
      "isPositionChanged": true,
      "isResetSlabModePopupWasDisplayed": false,
      "shapeSlab": {
        "absolutePosition": null
      },
      "shapeCabinet": {
        "width": 42,
        "height": 34,
        "depth": 24
      },
      "shapeAbsolute": {
        "absolutePosition": {
          "x": 35.93333333333333,
          "y": -100.46666666666665
        },
        "intersectionPoints": [],
        "snappedWithShape": 12,
        "snappedShapeGroup": 31
      },
      "shapeParams": {
        "shapeCabinet": true,
        "canSnap": true,
        "width": 42,
        "height": 34,
        "depth": 24,
        "diamondLength": 0,
        "thirdPartyAR3DMetaData": {
          "ActualDisplayedName": [
            "Hamilton Flat Panel SM-B42"
          ],
          "DisplayedName": [
            "Hamilton Flat Panel SM-B42"
          ],
          "Width": [
            "42"
          ],
          "Height": [
            "34"
          ],
          "Depth": [
            "24"
          ],
          "SKU": [
            "SM-B42"
          ],
          "Shape": [
            "SM-B42"
          ],
          "DoorStyle": [
            "Hamilton Flat Panel"
          ],
          "Door": [
            "2"
          ],
          "Drawer": [
            "2"
          ],
          "filters": {
            "Style": [
              "Hamilton Flat Panel"
            ],
            "Width": [
              "42"
            ],
            "Height": [
              "34"
            ],
            "Depth": [
              "24"
            ]
          }
        },
        "shapeLayout": "rectangle"
      },
      "relatedParentFeatureId": 381762693,
      "slabModeCoreParentId": null,
      "parentPartId": null,
      "slabParentPartId": null,
      "shouldUseSlabPricing": false,
      "originalPointsCoords": [
        {
          "x": 0,
          "y": 0,
          "id": "c9f4f50e-6454-4f3d-b8af-d7c2b620fe3f"
        },
        {
          "x": 42,
          "y": 0,
          "id": "4102b6db-3cc7-4c03-ba27-ac7befbc9279"
        },
        {
          "x": 42,
          "y": 24,
          "id": "6c3072f1-d3f3-476a-8d62-6041f21999f6"
        },
        {
          "x": 0,
          "y": 24,
          "id": "104b7524-8327-4458-a54b-26141bec2eec"
        }
      ]
    },
    {
      "pos": {
        "x": -6.0666666666666575,
        "y": -100.46666666666665
      },
      "slabPos": {
        "x": 39,
        "y": -58.6
      },
      "id": 7,
      "featureId": 381672425,
      "colorSet": null,
      "isHidden": false,
      "shapePieces": [],
      "seamCutPoints": [],
      "shapeParentId": null,
      "lines": [
        {
          "id": "165ddbbe-5161-4aa6-ad24-6f5bb2dbd133",
          "from": {
            "id": "d1b66302-82de-4b57-8f70-38c836201254",
            "x": 12.3065,
            "y": 0,
            "pos": {
              "x": 12.3065,
              "y": 0
            },
            "posSlab": {
              "x": 12.3065,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "afb94d89-9ec9-4a59-9261-b6b746126b22",
            "x": 42,
            "y": 0,
            "pos": {
              "x": 42,
              "y": 0
            },
            "posSlab": {
              "x": 42,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "d30fc942-ba44-4a40-b9d4-06125d02a497",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrl": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "246453e1-e835-4841-8b49-8e9826c89584",
          "from": {
            "id": "afb94d89-9ec9-4a59-9261-b6b746126b22",
            "x": 42,
            "y": 0,
            "pos": {
              "x": 42,
              "y": 0
            },
            "posSlab": {
              "x": 42,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "dd4f428d-2e34-4a5e-b31a-7f81822e66ea",
            "x": 42,
            "y": 24,
            "pos": {
              "x": 42,
              "y": 24
            },
            "posSlab": {
              "x": 42,
              "y": 24
            },
            "arcLength": 0,
            "angle": 0,
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "8b782418-71c8-4906-b258-9a883c1e14d7",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrl": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "777f1787-844c-4c1f-ad74-103b8c440607",
          "from": {
            "id": "dd4f428d-2e34-4a5e-b31a-7f81822e66ea",
            "x": 42,
            "y": 24,
            "pos": {
              "x": 42,
              "y": 24
            },
            "posSlab": {
              "x": 42,
              "y": 24
            },
            "arcLength": 0,
            "angle": 0,
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "a9636338-80eb-4493-a7da-4ed87028321e",
            "x": 24,
            "y": 42,
            "pos": {
              "x": 24,
              "y": 42
            },
            "posSlab": {
              "x": 24,
              "y": 42
            },
            "arcLength": 0,
            "angle": 0,
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "3b4fd3af-e212-4f50-9c5a-aa32bdbf040e",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrl": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "59f45381-6a35-4bd2-b230-7e9ead9e5612",
          "from": {
            "id": "a9636338-80eb-4493-a7da-4ed87028321e",
            "x": 24,
            "y": 42,
            "pos": {
              "x": 24,
              "y": 42
            },
            "posSlab": {
              "x": 24,
              "y": 42
            },
            "arcLength": 0,
            "angle": 0,
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "6f04935b-3540-4294-b4cc-e8a9e95a4b58",
            "x": 0,
            "y": 42,
            "pos": {
              "x": 0,
              "y": 42
            },
            "posSlab": {
              "x": 0,
              "y": 42
            },
            "arcLength": 0,
            "angle": 0,
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "0a0d3ded-0683-4fe9-86b3-d19e98e518ff",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrl": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "40fb4dd5-82c8-4a4f-a486-ed241767bd34",
          "from": {
            "id": "6f04935b-3540-4294-b4cc-e8a9e95a4b58",
            "x": 0,
            "y": 42,
            "pos": {
              "x": 0,
              "y": 42
            },
            "posSlab": {
              "x": 0,
              "y": 42
            },
            "arcLength": 0,
            "angle": 0,
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "c5561c94-e740-4360-82a2-f8548e6f0b87",
            "x": 0,
            "y": 12.3065,
            "pos": {
              "x": 0,
              "y": 12.3065
            },
            "posSlab": {
              "x": 0,
              "y": 12.3065
            },
            "arcLength": 0,
            "angle": 0,
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "2183cb80-52ae-4409-ab53-d569db21871d",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrl": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "691ccdc8-7e56-4b77-a086-07dc83714807",
          "from": {
            "id": "c5561c94-e740-4360-82a2-f8548e6f0b87",
            "x": 0,
            "y": 12.3065,
            "pos": {
              "x": 0,
              "y": 12.3065
            },
            "posSlab": {
              "x": 0,
              "y": 12.3065
            },
            "arcLength": 0,
            "angle": 0,
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "d1b66302-82de-4b57-8f70-38c836201254",
            "x": 12.3065,
            "y": 0,
            "pos": {
              "x": 12.3065,
              "y": 0
            },
            "posSlab": {
              "x": 12.3065,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "5a8acee9-cada-4d78-be8c-110de6976c52",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrl": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        }
      ],
      "shapeType": "square",
      "rotatedDegrees": 0,
      "rotatedDegreesSlab": 0,
      "partId": "lower_cabinet_boxes",
      "qtCatName": "Kitchen",
      "fromLayout": null,
      "squareFeet": 1,
      "quantity": 1,
      "isDisabledInPopup": false,
      "rotateAngleParts": [],
      "isPointsChanged": true,
      "isPositionChanged": true,
      "isResetSlabModePopupWasDisplayed": false,
      "shapeSlab": {
        "absolutePosition": null
      },
      "shapeCabinet": {
        "width": 42,
        "height": 34,
        "depth": 24
      },
      "shapeAbsolute": {
        "absolutePosition": {
          "x": -6.0666666666666575,
          "y": -100.46666666666665
        },
        "intersectionPoints": [],
        "snappedWithShape": 6,
        "snappedShapeGroup": 31
      },
      "shapeParams": {
        "shapeCabinet": true,
        "canSnap": true,
        "width": 42,
        "height": 34,
        "depth": 24,
        "diamondLength": 29.6935,
        "thirdPartyAR3DMetaData": {
          "ActualDisplayedName": [
            "Hamilton Flat Panel DCB42LRB"
          ],
          "DisplayedName": [
            "Hamilton Flat Panel DCB42LRB"
          ],
          "Width": [
            "42"
          ],
          "Height": [
            "34"
          ],
          "Depth": [
            "24"
          ],
          "SKU": [
            "DCB42LRB"
          ],
          "Shape": [
            "DCB42LRB"
          ],
          "DoorStyle": [
            "Hamilton Flat Panel"
          ],
          "Door": [
            "2"
          ],
          "Drawer": [
            "0"
          ],
          "SpecialShape": [
            "LowerDimondShape"
          ],
          "DiamondLength": [
            "29.6935in"
          ],
          "filters": {
            "Style": [
              "Hamilton Flat Panel"
            ],
            "Width": [
              "42"
            ],
            "Height": [
              "34"
            ],
            "Depth": [
              "24"
            ],
            "DiamondLength": [
              "29.6935in"
            ]
          }
        },
        "shapeLayout": "LowerDimondShape"
      },
      "relatedParentFeatureId": 381762693,
      "slabModeCoreParentId": null,
      "parentPartId": null,
      "slabParentPartId": null,
      "shouldUseSlabPricing": false,
      "originalPointsCoords": [
        {
          "x": 12.3065,
          "y": 0,
          "id": "d1b66302-82de-4b57-8f70-38c836201254"
        },
        {
          "x": 42,
          "y": 0,
          "id": "afb94d89-9ec9-4a59-9261-b6b746126b22"
        },
        {
          "x": 42,
          "y": 24,
          "id": "dd4f428d-2e34-4a5e-b31a-7f81822e66ea"
        },
        {
          "x": 24,
          "y": 42,
          "id": "a9636338-80eb-4493-a7da-4ed87028321e"
        },
        {
          "x": 0,
          "y": 42,
          "id": "6f04935b-3540-4294-b4cc-e8a9e95a4b58"
        },
        {
          "x": 0,
          "y": 12.3065,
          "id": "c5561c94-e740-4360-82a2-f8548e6f0b87"
        }
      ]
    },
    {
      "pos": {
        "x": 66.53333333333335,
        "y": -99.33333333333329
      },
      "slabPos": {
        "x": 68.13333333333334,
        "y": -79.06666666666666
      },
      "id": 9,
      "featureId": 381183133,
      "colorSet": null,
      "isHidden": false,
      "shapePieces": [],
      "seamCutPoints": [],
      "shapeParentId": null,
      "lines": [
        {
          "id": "a41c77ab-2008-4ea5-b3b8-965943349ce6",
          "from": {
            "id": "2fe55550-d46f-4442-8231-44610f2cde3a",
            "x": 0,
            "y": 0,
            "pos": {
              "x": 0,
              "y": 0
            },
            "posSlab": {
              "x": 0,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "lefttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "3cbf3cd2-48f1-48df-839d-44faefc2b2fb",
            "x": 36,
            "y": 0,
            "pos": {
              "x": 36,
              "y": 0
            },
            "posSlab": {
              "x": 36,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "righttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "b3582108-71aa-4c6e-b6df-0553a381ca33",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrl": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "a670d4d5-37f4-4b9e-917c-b8081cbbd2d0",
          "from": {
            "id": "3cbf3cd2-48f1-48df-839d-44faefc2b2fb",
            "x": 36,
            "y": 0,
            "pos": {
              "x": 36,
              "y": 0
            },
            "posSlab": {
              "x": 36,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "righttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "36871fd9-8866-495c-aed1-c95115051230",
            "x": 36,
            "y": 12,
            "pos": {
              "x": 36,
              "y": 12
            },
            "posSlab": {
              "x": 36,
              "y": 12
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "rightbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "1c31df18-ec68-4f44-9103-89aaf919cb28",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrl": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "2c715779-9dda-4267-b508-06b454b2935d",
          "from": {
            "id": "36871fd9-8866-495c-aed1-c95115051230",
            "x": 36,
            "y": 12,
            "pos": {
              "x": 36,
              "y": 12
            },
            "posSlab": {
              "x": 36,
              "y": 12
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "rightbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "5b245f9e-32e5-4fc4-88e4-f03e7f5a021f",
            "x": 0,
            "y": 12,
            "pos": {
              "x": 0,
              "y": 12
            },
            "posSlab": {
              "x": 0,
              "y": 12
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "leftbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "9f1ed23b-f565-4abe-9179-27085920a697",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrl": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "625a3b14-9432-412d-9d3e-64e78e4528bb",
          "from": {
            "id": "5b245f9e-32e5-4fc4-88e4-f03e7f5a021f",
            "x": 0,
            "y": 12,
            "pos": {
              "x": 0,
              "y": 12
            },
            "posSlab": {
              "x": 0,
              "y": 12
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "leftbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "2fe55550-d46f-4442-8231-44610f2cde3a",
            "x": 0,
            "y": 0,
            "pos": {
              "x": 0,
              "y": 0
            },
            "posSlab": {
              "x": 0,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "lefttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "b6b16ec2-2e3f-41a9-be82-feef6eb33739",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrl": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        }
      ],
      "shapeType": "square",
      "rotatedDegrees": 0,
      "rotatedDegreesSlab": 0,
      "partId": "upper_cabinet_boxes",
      "qtCatName": "Kitchen",
      "fromLayout": null,
      "squareFeet": 1,
      "quantity": 1,
      "isDisabledInPopup": false,
      "rotateAngleParts": [],
      "isPointsChanged": true,
      "isPositionChanged": true,
      "isResetSlabModePopupWasDisplayed": false,
      "shapeSlab": {
        "absolutePosition": null
      },
      "shapeCabinet": {
        "width": 36,
        "height": 42,
        "depth": 12
      },
      "shapeAbsolute": {
        "absolutePosition": {
          "x": 65.93333333333335,
          "y": -100.46666666666665
        },
        "intersectionPoints": [],
        "snappedWithShape": 10,
        "snappedShapeGroup": 31
      },
      "shapeParams": {
        "shapeCabinet": true,
        "canSnap": true,
        "width": 36,
        "height": 42,
        "depth": 12,
        "diamondLength": 0,
        "thirdPartyAR3DMetaData": {
          "ActualDisplayedName": [
            "Hamilton Flat Panel SM-W3642"
          ],
          "DisplayedName": [
            "Hamilton Flat Panel SM-W3642"
          ],
          "Width": [
            "36"
          ],
          "Height": [
            "42"
          ],
          "Depth": [
            "12"
          ],
          "SKU": [
            "SM-W3642"
          ],
          "Shape": [
            "SM-W3642"
          ],
          "DoorStyle": [
            "Hamilton Flat Panel"
          ],
          "Door": [
            "2"
          ],
          "Drawer": [
            "0"
          ],
          "filters": {
            "Style": [
              "Hamilton Flat Panel"
            ],
            "Width": [
              "36"
            ],
            "Height": [
              "42"
            ],
            "Depth": [
              "12"
            ]
          }
        },
        "shapeLayout": "rectangle"
      },
      "relatedParentFeatureId": 381762675,
      "slabModeCoreParentId": null,
      "parentPartId": null,
      "slabParentPartId": null,
      "shouldUseSlabPricing": false,
      "originalPointsCoords": [
        {
          "x": 0,
          "y": 0,
          "id": "2fe55550-d46f-4442-8231-44610f2cde3a"
        },
        {
          "x": 36,
          "y": 0,
          "id": "3cbf3cd2-48f1-48df-839d-44faefc2b2fb"
        },
        {
          "x": 36,
          "y": 12,
          "id": "36871fd9-8866-495c-aed1-c95115051230"
        },
        {
          "x": 0,
          "y": 12,
          "id": "5b245f9e-32e5-4fc4-88e4-f03e7f5a021f"
        }
      ]
    },
    {
      "pos": {
        "x": 28.933333333333362,
        "y": -99.06666666666665
      },
      "slabPos": {
        "x": 68.13333333333334,
        "y": -79.06666666666666
      },
      "id": 10,
      "featureId": 381183137,
      "colorSet": null,
      "isHidden": false,
      "shapePieces": [],
      "seamCutPoints": [],
      "shapeParentId": null,
      "lines": [
        {
          "id": "c7d0673f-c0b1-4e41-93a5-7dbe797c0c02",
          "from": {
            "id": "844238cb-c72c-422f-a4e1-6375df980944",
            "x": 0,
            "y": 0,
            "pos": {
              "x": 0,
              "y": 0
            },
            "posSlab": {
              "x": 0,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "lefttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "3655728d-51cb-4842-aa0c-74e9fcae6ccc",
            "x": 36,
            "y": 0,
            "pos": {
              "x": 36,
              "y": 0
            },
            "posSlab": {
              "x": 36,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "righttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "c548ea6b-8a50-4519-a014-243925de5180",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrl": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "8d99dbbc-9a40-42b7-94aa-171633d87f60",
          "from": {
            "id": "3655728d-51cb-4842-aa0c-74e9fcae6ccc",
            "x": 36,
            "y": 0,
            "pos": {
              "x": 36,
              "y": 0
            },
            "posSlab": {
              "x": 36,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "righttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "676a53bb-28d2-401a-835e-57383804d3ea",
            "x": 36,
            "y": 12,
            "pos": {
              "x": 36,
              "y": 12
            },
            "posSlab": {
              "x": 36,
              "y": 12
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "rightbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "9b9cb935-af2d-41c7-9247-7662901d48f1",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrl": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "8d9829de-6472-4963-950a-402efe78e8fe",
          "from": {
            "id": "676a53bb-28d2-401a-835e-57383804d3ea",
            "x": 36,
            "y": 12,
            "pos": {
              "x": 36,
              "y": 12
            },
            "posSlab": {
              "x": 36,
              "y": 12
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "rightbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "8fb12eda-3755-416e-ba51-965155387f63",
            "x": 0,
            "y": 12,
            "pos": {
              "x": 0,
              "y": 12
            },
            "posSlab": {
              "x": 0,
              "y": 12
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "leftbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "9585ae3e-578e-4d3c-b61b-e7af31ae5748",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrl": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "fda03198-c1f8-451c-8404-34df394ecc39",
          "from": {
            "id": "8fb12eda-3755-416e-ba51-965155387f63",
            "x": 0,
            "y": 12,
            "pos": {
              "x": 0,
              "y": 12
            },
            "posSlab": {
              "x": 0,
              "y": 12
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "leftbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "844238cb-c72c-422f-a4e1-6375df980944",
            "x": 0,
            "y": 0,
            "pos": {
              "x": 0,
              "y": 0
            },
            "posSlab": {
              "x": 0,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "lefttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "0b7dc8be-4e89-4656-96de-c6f475f1b00a",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrl": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        }
      ],
      "shapeType": "square",
      "rotatedDegrees": 0,
      "rotatedDegreesSlab": 0,
      "partId": "upper_cabinet_boxes",
      "qtCatName": "Kitchen",
      "fromLayout": null,
      "squareFeet": 1,
      "quantity": 1,
      "isDisabledInPopup": false,
      "rotateAngleParts": [],
      "isPointsChanged": true,
      "isPositionChanged": true,
      "isResetSlabModePopupWasDisplayed": false,
      "shapeSlab": {
        "absolutePosition": null
      },
      "shapeCabinet": {
        "width": 36,
        "height": 36,
        "depth": 12
      },
      "shapeAbsolute": {
        "absolutePosition": {
          "x": 29.93333333333333,
          "y": -100.46666666666665
        },
        "intersectionPoints": [],
        "snappedWithShape": 9,
        "snappedShapeGroup": 31
      },
      "shapeParams": {
        "shapeCabinet": true,
        "canSnap": true,
        "width": 36,
        "height": 36,
        "depth": 12,
        "diamondLength": 0,
        "thirdPartyAR3DMetaData": {
          "ActualDisplayedName": [
            "Hamilton Flat Panel SM-W3636"
          ],
          "DisplayedName": [
            "Hamilton Flat Panel SM-W3636"
          ],
          "Width": [
            "36"
          ],
          "Height": [
            "36"
          ],
          "Depth": [
            "12"
          ],
          "SKU": [
            "SM-W3636"
          ],
          "Shape": [
            "SM-W3636"
          ],
          "DoorStyle": [
            "Hamilton Flat Panel"
          ],
          "Door": [
            "2"
          ],
          "Drawer": [
            "0"
          ],
          "filters": {
            "Style": [
              "Hamilton Flat Panel"
            ],
            "Width": [
              "36"
            ],
            "Height": [
              "36"
            ],
            "Depth": [
              "12"
            ]
          }
        },
        "shapeLayout": "rectangle"
      },
      "relatedParentFeatureId": 381762675,
      "slabModeCoreParentId": null,
      "parentPartId": null,
      "slabParentPartId": null,
      "shouldUseSlabPricing": false,
      "originalPointsCoords": [
        {
          "x": 0,
          "y": 0,
          "id": "844238cb-c72c-422f-a4e1-6375df980944"
        },
        {
          "x": 36,
          "y": 0,
          "id": "3655728d-51cb-4842-aa0c-74e9fcae6ccc"
        },
        {
          "x": 36,
          "y": 12,
          "id": "676a53bb-28d2-401a-835e-57383804d3ea"
        },
        {
          "x": 0,
          "y": 12,
          "id": "8fb12eda-3755-416e-ba51-965155387f63"
        }
      ]
    },
    {
      "pos": {
        "x": -6.799999999999994,
        "y": -99.33333333333329
      },
      "slabPos": {
        "x": 68.13333333333334,
        "y": -79.06666666666666
      },
      "id": 11,
      "featureId": 381183139,
      "colorSet": null,
      "isHidden": false,
      "shapePieces": [],
      "seamCutPoints": [],
      "shapeParentId": null,
      "lines": [
        {
          "id": "45e1a826-e059-49cb-a68d-db6575a4c909",
          "from": {
            "id": "176fe8da-27cd-41c1-89de-8dafd037ae59",
            "x": 0,
            "y": 0,
            "pos": {
              "x": 0,
              "y": 0
            },
            "posSlab": {
              "x": 0,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "lefttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "32b73148-443d-43b2-8b37-2871e61bb3cc",
            "x": 36,
            "y": 0,
            "pos": {
              "x": 36,
              "y": 0
            },
            "posSlab": {
              "x": 36,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "righttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "f96261e8-94c2-438a-a40a-d7a8a8bdd56d",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrl": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "79506af2-6dd7-444a-93d3-1780eb565d0e",
          "from": {
            "id": "32b73148-443d-43b2-8b37-2871e61bb3cc",
            "x": 36,
            "y": 0,
            "pos": {
              "x": 36,
              "y": 0
            },
            "posSlab": {
              "x": 36,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "righttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "c1c62f14-6557-4f83-a59c-3ac8af699504",
            "x": 36,
            "y": 12,
            "pos": {
              "x": 36,
              "y": 12
            },
            "posSlab": {
              "x": 36,
              "y": 12
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "rightbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "4092e21b-71a5-4892-9322-ac95ab0ad4ce",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrl": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "c4bbbb29-cefd-4923-b53d-853a7f6ce8fc",
          "from": {
            "id": "c1c62f14-6557-4f83-a59c-3ac8af699504",
            "x": 36,
            "y": 12,
            "pos": {
              "x": 36,
              "y": 12
            },
            "posSlab": {
              "x": 36,
              "y": 12
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "rightbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "73ac4a3f-49b8-4ab2-8e2e-730a5d6358c9",
            "x": 0,
            "y": 12,
            "pos": {
              "x": 0,
              "y": 12
            },
            "posSlab": {
              "x": 0,
              "y": 12
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "leftbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "435366c8-54f5-42ae-820d-51e28aef018f",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrl": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "9a87fba6-fa9c-4913-8861-66eb31350cc5",
          "from": {
            "id": "73ac4a3f-49b8-4ab2-8e2e-730a5d6358c9",
            "x": 0,
            "y": 12,
            "pos": {
              "x": 0,
              "y": 12
            },
            "posSlab": {
              "x": 0,
              "y": 12
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "leftbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "176fe8da-27cd-41c1-89de-8dafd037ae59",
            "x": 0,
            "y": 0,
            "pos": {
              "x": 0,
              "y": 0
            },
            "posSlab": {
              "x": 0,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "lefttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "112f0193-ec8e-4ed0-9519-ebdf08328c60",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrl": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        }
      ],
      "shapeType": "square",
      "rotatedDegrees": 0,
      "rotatedDegreesSlab": 0,
      "partId": "upper_cabinet_boxes",
      "qtCatName": "Kitchen",
      "fromLayout": null,
      "squareFeet": 1,
      "quantity": 1,
      "isDisabledInPopup": false,
      "rotateAngleParts": [],
      "isPointsChanged": true,
      "isPositionChanged": true,
      "isResetSlabModePopupWasDisplayed": false,
      "shapeSlab": {
        "absolutePosition": null
      },
      "shapeCabinet": {
        "width": 36,
        "height": 30,
        "depth": 12
      },
      "shapeAbsolute": {
        "absolutePosition": {
          "x": -6.06666666666666,
          "y": -100.46666666666665
        },
        "intersectionPoints": [],
        "snappedWithShape": 10,
        "snappedShapeGroup": 31
      },
      "shapeParams": {
        "shapeCabinet": true,
        "canSnap": true,
        "width": 36,
        "height": 30,
        "depth": 12,
        "diamondLength": 0,
        "thirdPartyAR3DMetaData": {
          "ActualDisplayedName": [
            "Hamilton Flat Panel SW-WBC3630"
          ],
          "DisplayedName": [
            "Hamilton Flat Panel SW-WBC3630"
          ],
          "Width": [
            "36"
          ],
          "Height": [
            "30"
          ],
          "Depth": [
            "12"
          ],
          "SKU": [
            "SW-WBC3630"
          ],
          "Shape": [
            "SW-WBC3630"
          ],
          "DoorStyle": [
            "Hamilton Flat Panel"
          ],
          "Door": [
            "1"
          ],
          "Drawer": [
            "0"
          ],
          "filters": {
            "Style": [
              "Hamilton Flat Panel"
            ],
            "Width": [
              "36"
            ],
            "Height": [
              "30"
            ],
            "Depth": [
              "12"
            ]
          }
        },
        "shapeLayout": "rectangle"
      },
      "relatedParentFeatureId": 381762675,
      "slabModeCoreParentId": null,
      "parentPartId": null,
      "slabParentPartId": null,
      "shouldUseSlabPricing": false,
      "originalPointsCoords": [
        {
          "x": 0,
          "y": 0,
          "id": "176fe8da-27cd-41c1-89de-8dafd037ae59"
        },
        {
          "x": 36,
          "y": 0,
          "id": "32b73148-443d-43b2-8b37-2871e61bb3cc"
        },
        {
          "x": 36,
          "y": 12,
          "id": "c1c62f14-6557-4f83-a59c-3ac8af699504"
        },
        {
          "x": 0,
          "y": 12,
          "id": "73ac4a3f-49b8-4ab2-8e2e-730a5d6358c9"
        }
      ]
    }
  ],
  "manualCalculate": false,
  "controllers": {
    "walls": [],
    "snappedShapeGroups": [
      0,
      1,
      2,
      3,
      4,
      5,
      6,
      7,
      8,
      9,
      10,
      11,
      12,
      13,
      14,
      15,
      16,
      17,
      18,
      19,
      20,
      21,
      22,
      23,
      24,
      25,
      26,
      27,
      28,
      29,
      30,
      31
    ],
    "handles": [],
    "hinge": []
  },
  "underlayment": []
}

export const CABINET_SET2 = [
  {
    "shapeId": 1,
    "partId": "lower_cabinet_boxes",
    "x": -45.13333333333333,
    "y": 0,
    "z": -34.4666666666667,
    "rotation": 90,
    "url": "https://d1mb1i73swc8dz.cloudfront.net/ar-composer-v2/models/All-Top Cabinet-Fairbank-Barcelona 2-H4818.glb",
    "material_url": "https://d1mb1i73swc8dz.cloudfront.net/ar-composer-v2/textures/All-Cabinet-Dutch Gray-Trend.glb",
    "framed": false,
    "frame_width": 0.75,
    "frame_height": 0.25,
    "target_width": 48,
    "target_depth": 12,
    "target_height": 18,
    "width": 48,
    "height": 18,
    "depth": 12,
    "contour_points": [
      {
        "x": 18,
        "y": 30,
        "id": "13c5f884-cc36-4537-afab-9e73716b37ce"
      },
      {
        "x": 18,
        "y": -18,
        "id": "67cba080-e63f-4367-a5d6-3294d212aaf1"
      },
      {
        "x": 30,
        "y": -18,
        "id": "ba70c7da-e2a9-4914-afb8-9c435cbde0f7"
      },
      {
        "x": 30,
        "y": 30,
        "id": "11c8255e-c2f2-4afe-bca8-3dff28be49d1"
      }
    ],
    "original_points": [
      {
        "x": 0,
        "y": 0,
        "id": "13c5f884-cc36-4537-afab-9e73716b37ce"
      },
      {
        "x": 48,
        "y": 0,
        "id": "67cba080-e63f-4367-a5d6-3294d212aaf1"
      },
      {
        "x": 48,
        "y": 12,
        "id": "ba70c7da-e2a9-4914-afb8-9c435cbde0f7"
      },
      {
        "x": 0,
        "y": 12,
        "id": "11c8255e-c2f2-4afe-bca8-3dff28be49d1"
      }
    ],
    "featureId": 272476414,
    "parentFeatureId": 272289587,
    "shapeLayout": "rectangle"
  },
  {
    "shapeId": 10,
    "partId": "upper_cabinet_boxes",
    "x": 160.53333333333316,
    "y": 52,
    "z": 3.4359833333333327,
    "rotation": 270,
    "url": "https://d1mb1i73swc8dz.cloudfront.net/ar-composer-v2/models/All-Top Cabinet-Fairbank-Barcelona 2-H4818.glb",
    "material_url": "https://d1mb1i73swc8dz.cloudfront.net/ar-composer-v2/textures/All-Cabinet-Dutch Gray-Trend.glb",
    "framed": false,
    "frame_width": 0.75,
    "frame_height": 0.25,
    "target_width": 48,
    "target_depth": 12,
    "target_height": 18,
    "width": 48,
    "height": 18,
    "depth": 12,
    "contour_points": [
      {
        "x": 30,
        "y": -18,
        "id": "fb95bdb3-57ac-4b9e-9620-3aea19504c2b"
      },
      {
        "x": 30,
        "y": 30,
        "id": "f2939976-4d3e-48dc-be86-0f4b0f4894ef"
      },
      {
        "x": 18,
        "y": 30,
        "id": "1df267ef-bd5d-41ac-a492-4d29480d2ff3"
      },
      {
        "x": 18,
        "y": -18,
        "id": "c6be3316-86e1-4872-ad32-38bb00c70d76"
      }
    ],
    "original_points": [
      {
        "x": 0,
        "y": 0,
        "id": "fb95bdb3-57ac-4b9e-9620-3aea19504c2b"
      },
      {
        "x": 48,
        "y": 0,
        "id": "f2939976-4d3e-48dc-be86-0f4b0f4894ef"
      },
      {
        "x": 48,
        "y": 12,
        "id": "1df267ef-bd5d-41ac-a492-4d29480d2ff3"
      },
      {
        "x": 0,
        "y": 12,
        "id": "c6be3316-86e1-4872-ad32-38bb00c70d76"
      }
    ],
    "featureId": 272476414,
    "parentFeatureId": 272289587,
    "shapeLayout": "rectangle"
  },
  {
    "shapeId": 9,
    "partId": "upper_cabinet_boxes",
    "x": 115.33333333333331,
    "y": 52,
    "z": 99.10529999999989,
    "rotation": 180,
    "url": "https://d1mb1i73swc8dz.cloudfront.net/ar-composer-v2/models/All-Top Cabinet-Fairbank-Barcelona 2-H4818.glb",
    "material_url": "https://d1mb1i73swc8dz.cloudfront.net/ar-composer-v2/textures/All-Cabinet-Dutch Gray-Trend.glb",
    "framed": false,
    "frame_width": 0.75,
    "frame_height": 0.25,
    "target_width": 48,
    "target_depth": 12,
    "target_height": 18,
    "width": 48,
    "height": 18,
    "depth": 12,
    "contour_points": [
      {
        "x": 48,
        "y": 12,
        "id": "b091744b-00bb-4f92-9e69-b447e6e4def6"
      },
      {
        "x": 0,
        "y": 12,
        "id": "4325e622-93fb-414c-b662-f83a86dee364"
      },
      {
        "x": 0,
        "y": 0,
        "id": "300f3d60-3ca2-45c5-9016-1a40122bd839"
      },
      {
        "x": 48,
        "y": 0,
        "id": "7dce39ce-5fb3-4655-bc1c-066af713d4e8"
      }
    ],
    "original_points": [
      {
        "x": 0,
        "y": 0,
        "id": "b091744b-00bb-4f92-9e69-b447e6e4def6"
      },
      {
        "x": 48,
        "y": 0,
        "id": "4325e622-93fb-414c-b662-f83a86dee364"
      },
      {
        "x": 48,
        "y": 12,
        "id": "300f3d60-3ca2-45c5-9016-1a40122bd839"
      },
      {
        "x": 0,
        "y": 12,
        "id": "7dce39ce-5fb3-4655-bc1c-066af713d4e8"
      }
    ],
    "featureId": 272476414,
    "parentFeatureId": 272289587,
    "shapeLayout": "rectangle"
  },
  {
    "featureId": 272209426,
    "shapeId": 8,
    "partId": "hood",
    "x": 16.333333333333343,
    "y": 52,
    "z": 99.10794999999992,
    "rotation": 90,
    "url": "https://qc-3dfiles.s3.amazonaws.com/ar-composer/All-Hood-GE JVW5361 BS.glb",
    "width": 30,
    "height": 12,
    "depth": 15.4053
  },
  {
    "featureId": 272209426,
    "shapeId": 7,
    "partId": "hood",
    "x": 167.83068333333313,
    "y": 52,
    "z": 66.43863333333334,
    "rotation": 180,
    "url": "https://qc-3dfiles.s3.amazonaws.com/ar-composer/All-Hood-GE JVW5361 BS.glb",
    "width": 30,
    "height": 12,
    "depth": 15.4053
  },
  {
    "featureId": 272209426,
    "shapeId": 6,
    "partId": "hood",
    "x": -6.230683333333214,
    "y": 52,
    "z": -38.06666666666658,
    "rotation": 0,
    "url": "https://qc-3dfiles.s3.amazonaws.com/ar-composer/All-Hood-GE JVW5361 BS.glb",
    "width": 30,
    "height": 12,
    "depth": 15.4053
  },
  {
    "featureId": 272209426,
    "shapeId": 5,
    "partId": "hood",
    "x": 143.2666666666667,
    "y": 52,
    "z": -71.96931666666698,
    "rotation": -90,
    "url": "https://qc-3dfiles.s3.amazonaws.com/ar-composer/All-Hood-GE JVW5361 BS.glb",
    "width": 30,
    "height": 12,
    "depth": 15.4053
  },
  {
    "featureId": 374232550,
    "shapeId": 4,
    "partId": "fridge",
    "x": -2.356533333333223,
    "y": 0,
    "z": 42.907483333333424,
    "rotation": 0,
    "url": "https://qc-3dfiles.s3.amazonaws.com/ar-composer/All-Fridge-ZLINE RFM-W 36 SS.glb",
    "width": 36,
    "height": 12,
    "depth": 29.1536
  },
  {
    "featureId": 374232550,
    "shapeId": 3,
    "partId": "fridge",
    "x": 163.9565333333332,
    "y": 0,
    "z": -14.587216666666674,
    "rotation": 180,
    "url": "https://qc-3dfiles.s3.amazonaws.com/ar-composer/All-Fridge-ZLINE RFM-W 36 SS.glb",
    "width": 36,
    "height": 12,
    "depth": 29.1536
  },
  {
    "featureId": 374232550,
    "shapeId": 2,
    "partId": "fridge",
    "x": 49.33333333333332,
    "y": 0,
    "z": 99.08209999999991,
    "rotation": 90,
    "url": "https://qc-3dfiles.s3.amazonaws.com/ar-composer/All-Fridge-ZLINE RFM-W 36 SS.glb",
    "width": 36,
    "height": 12,
    "depth": 29.1536
  },
  {
    "featureId": 374232550,
    "shapeId": 1,
    "partId": "fridge",
    "x": 62.26666666666674,
    "y": 0,
    "z": -71.99516666666699,
    "rotation": -90,
    "url": "https://qc-3dfiles.s3.amazonaws.com/ar-composer/All-Fridge-ZLINE RFM-W 36 SS.glb",
    "width": 36,
    "height": 12,
    "depth": 29.1536
  }
]
